import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useParams, Link, useNavigate, useSearchParams } from 'react-router-dom';
import { 
  getProjet, 
  updateProjet,
  updateDevis,
  getProjetDevisMaag,
  getFournisseursDirects,
  getAchatsArtisans,
  createFournisseurDirect,
  deleteFournisseurDirect,
  createAchatArtisan,
  updateAchatArtisan,
  deleteAchatArtisan,
  getLots,
  getProjetMarge,
  getDevisPdfUrl,
  signerDevis,
  createDevisMaag,
  updateFournisseurDirect,
  deleteDevisMaag,
  addDevisTypeToProjet,
  getAvailableDevisTypes,
  getFacturesArtisans,
  uploadFactureArtisan,
  updateFactureArtisan,
  deleteFactureArtisan,
  getFactureDownloadUrl,
  getFacturesExportUrl,
  analyzeInvoice,
  analyzeDevisArtisan,
  getProjetPlannings,
  createPlanning,
  deletePlanning,
  duplicatePlanning,
  getSuggestedServerPath,
  duplicateDevisMaag,
  getDevisAvailableForCopy,
  resyncProjetFromBase,
  resyncDevisFromBase,
  generateSignatureLink,
  duplicateDevisForV2
} from '../services/api';
import { updateCoutLot, uploadDevisLot, createFournisseurLot, updateFournisseurLot, deleteFournisseurLot, uploadDevisFournisseur, downloadDevisFournisseurPdf, analyzeDevisFournisseur, createFournisseurFromAnalysis, getProjetBDC, genererBDC, proposeBDCType, unlinkFactureFromSlot, reassignFacture, detectMargeDuplicates, mergeFournisseurSlots, downloadBDCPdf, deleteBdc, signerBDC, getDescriptifArtisans, createDescriptifArtisans, updateDescriptifArtisans, resyncDescriptifArtisans, deleteDescriptifArtisans, addDescriptifLigne, updateDescriptifLigne, deleteDescriptifLigne, downloadDescriptifPdf, downloadDescriptifExcel, getDescriptifEmailTemplate, sendDescriptifEmail, getDescriptifEmailHistory, getContacts, createContact, moveFournisseur, moveFournisseurLot, getBDCEmailTemplate, sendBDCEmail, setDevisReference, listFacturesClient, uploadFactureClient, deleteFactureClient, downloadFactureClientUrl, listFraisGeneraux, createFraisGeneral, updateFraisGeneral, deleteFraisGeneral, getProjetMagasinHistorique } from '../services/api';
import ProjectFileManager from '../components/ProjectFileManager';
import { 
  ArrowLeft,
  FileText,
  Truck,
  Wrench,
  Receipt,
  Plus,
  Trash2,
  Save,
  BarChart3,
  Clock,
  Play,
  Pause,
  Download,
  TrendingUp,
  TrendingDown,
  Check,
  X,
  Edit2,
  Lock,
  Unlock,
  CheckCircle,
  PenTool,
  Upload,
  FileCheck,
  Package,
  Eye,
  Info,
  Calendar,
  Copy,
  Server,
  FolderOpen,
  Clipboard,
  ExternalLink,
  AlertCircle,
  RefreshCw,
  Link2,
  Mail,
  Loader2,
  Paperclip,
  Hammer,
  FileSpreadsheet,
  BookUser,
  Search,
  MoveRight,
  Send,
  Star,
  ChevronDown,
  ClipboardCheck,
  Store
} from 'lucide-react';
import { toast } from 'sonner';
import SignaturePad from '../components/SignaturePad';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import ComptesRendusTab from '../components/ComptesRendusTab';
import PDFPreviewModal from '../components/PDFPreviewModal';
import { usePdfPreview } from '../hooks/usePdfPreview';

// Parse "1 500,50" / "1500.5" / "1 500 €" → number. Returns { ok, value, error }.
export const parseMontantInput = (raw) => {
  const txt = String(raw ?? '').replace(/[\s\u00a0\u202f€]/g, '').replace(',', '.');
  if (txt === '') return { ok: true, value: 0 };
  if (!/^-?\d+(\.\d+)?$/.test(txt)) return { ok: false, value: 0, error: `Montant invalide « ${String(raw).trim()} » : saisissez uniquement des chiffres` };
  const value = parseFloat(txt);
  if (value < 0) return { ok: false, value: 0, error: 'Un montant ne peut pas être négatif' };
  return { ok: true, value };
};

// Map fournisseurs to slots 1/2/3 strictly by `slot` (no index fallback → a lone slot 2 must NOT show as slot 1).
export const mapFournisseursBySlot = (fournisseurs) => {
  const bySlot = {};
  const unslotted = [];
  (fournisseurs || []).forEach((f) => {
    const s = Number(f?.slot);
    if ([1, 2, 3].includes(s) && !bySlot[s]) bySlot[s] = f;
    else unslotted.push(f);
  });
  unslotted.forEach((f) => {
    const free = [1, 2, 3].find((s) => !bySlot[s]);
    if (free) bySlot[free] = f;
  });
  return bySlot;
};

const MONTANT_INPUT_PROPS = {
  type: 'text',
  inputMode: 'decimal',
  autoComplete: 'off',
  placeholder: '0 €',
  title: 'Montant HT (€)',
  onKeyDown: (e) => { if (e.key === 'Enter') e.currentTarget.blur(); },
};

/* Historique du magasin : autres projets au même lieu (même enseigne), CA MAAG HT par année */
const STATUT_COURT = { en_preparation: 'Préparation', en_cours: 'En cours', termine_facturation: 'Facturation', stand_by: 'Stand-by', cloture: 'Clôturé', projet_non_realise: 'Non réalisé' };
const MagasinHistorique = ({ projetId }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    getProjetMagasinHistorique(projetId).then((r) => setData(r.data)).catch(() => setData(null));
  }, [projetId]);
  if (!data) return null;
  const eur0 = (v) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);
  const autres = data.projets.filter((p) => p.id !== projetId);
  return (
    <div className="mb-6 rounded-xl border border-indigo-200 bg-indigo-50/50 p-4" data-testid="magasin-historique">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 font-semibold text-indigo-900"><Store className="w-4 h-4" /> Historique du magasin <span className="text-xs font-normal text-indigo-700">({data.nb_projets} projet{data.nb_projets > 1 ? 's' : ''} à ce lieu)</span></div>
        <div className="flex flex-wrap gap-1.5 text-xs">
          {Object.entries(data.ca_par_annee).sort().map(([a, v]) => <span key={a} className="px-2 py-1 rounded-md bg-white border border-indigo-200 text-indigo-900" data-testid={`magasin-ca-${a}`}>{a} : <b>{eur0(v)}</b> HT</span>)}
          <span className="px-2 py-1 rounded-md bg-indigo-600 text-white" data-testid="magasin-ca-total">Total : <b>{eur0(data.ca_total)}</b> HT</span>
        </div>
      </div>
      {autres.length === 0 ? (
        <p className="text-xs text-indigo-800/70">Premier projet à ce lieu. Pour un futur devis sur ce magasin, créez un nouveau projet et choisissez « Magasin déjà enregistré » : les infos seront reprises ici.</p>
      ) : (
        <div className="divide-y divide-indigo-100 bg-white rounded-lg border border-indigo-100">
          {autres.map((p) => (
            <Link key={p.id} to={`/projets/${p.id}`} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2 hover:bg-indigo-50" data-testid={`magasin-projet-${p.id}`}>
              <div className="min-w-0">
                <div className="text-sm font-medium text-slate-900">{p.annee || '—'} · {p.devis_signes[0] || p.ville}</div>
                {p.devis_signes.length > 1 && <div className="text-xs text-slate-500 truncate">{p.devis_signes.slice(1).join(' · ')}</div>}
              </div>
              <div className="flex items-center gap-3 text-xs">
                <span className={`px-2 py-0.5 rounded-full ${p.statut === 'cloture' ? 'bg-slate-100 text-slate-600' : 'bg-green-100 text-green-700'}`}>{STATUT_COURT[p.statut] || p.statut}</span>
                <span className="font-mono font-semibold text-slate-900">{eur0(p.ca_maag)} HT</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};


const ProjetDetailPage = () => {
  const { projetId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const { previewState: pdfPreview, openPreview: openPdfPreview, closePreview: closePdfPreview } = usePdfPreview();
  // Feature flag — Réactivé le 27/07/2026 sur demande utilisateur pour permettre
  // l'envoi du lien de signature au client via un email externe (copie presse-papier).
  const ENABLE_CLIENT_SIGNATURE_FLOW = true;
  // Feature flag — Mathieu a demandé de simplifier l'UI Devis MAAG : retirer les
  // boutons "Synchroniser depuis la Base MAAG" et les sections de devis prédéfinis
  // affichées hors du modal Nouveau devis. Le code et fonctions sont conservés.
  const ENABLE_BASE_MAAG_SYNC = false;
  const [projet, setProjet] = useState(null);
  const [devisMaag, setDevisMaag] = useState([]);
  const [fournisseursDirects, setFournisseursDirects] = useState([]);
  const [achatsArtisans, setAchatsArtisans] = useState([]);
  const [lots, setLots] = useState([]);
  const [margeData, setMargeData] = useState(null);
  const [bdcList, setBdcList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(() => {
    const tabParam = searchParams.get('tab');
    return tabParam || 'devis_maag';
  });
  
  // Planning state
  const [plannings, setPlannings] = useState([]);
  const [creatingPlanning, setCreatingPlanning] = useState(false);
  
  // Server path state
  const [editingServerPath, setEditingServerPath] = useState(false);
  const [serverPathInput, setServerPathInput] = useState('');
  const [savingServerPath, setSavingServerPath] = useState(false);
  
  // Forms
  const [newFD, setNewFD] = useState({ designation: '', fournisseur: '', categorie: 'intervenants', payeur: 'CLIENT', montant_ht: '' });
  const [newAchat, setNewAchat] = useState({ lot_id: '1', entreprise: '', description: '', montant_ht: '', statut: 'devis' });
  const [showManualAchatForm, setShowManualAchatForm] = useState(false);
  const [isDraggingAchat, setIsDraggingAchat] = useState(false);
  const [isDraggingFacture, setIsDraggingFacture] = useState(false);
  
  // Suivi factures editing
  const [editingSuivi, setEditingSuivi] = useState(null);
  
  // Signature modal
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signingDevis, setSigningDevis] = useState(null);
  
  // New devis modal
  const [showNewDevisModal, setShowNewDevisModal] = useState(false);
  const [newDevisObjet, setNewDevisObjet] = useState('');
  const [suggestedObjet, setSuggestedObjet] = useState('');
  const [editingDevisObjetId, setEditingDevisObjetId] = useState(null);
  const [editingDevisObjet, setEditingDevisObjet] = useState('');
  const [creatingDevis, setCreatingDevis] = useState(false);
  
  // Create mode: 'vide', 'modele', 'copier'
  const [createMode, setCreateMode] = useState('vide');
  const [copyFilter, setCopyFilter] = useState('same_enseigne');
  const [availableDevisForCopy, setAvailableDevisForCopy] = useState([]);
  const [selectedSourceDevis, setSelectedSourceDevis] = useState(null);
  const [copySearchQuery, setCopySearchQuery] = useState('');
  const [expandedEnseignesInCopy, setExpandedEnseignesInCopy] = useState({});
  const [loadingDevisForCopy, setLoadingDevisForCopy] = useState(false);
  
  // Available devis types for adding
  const [availableDevisTypes, setAvailableDevisTypes] = useState([]);
  const [addingDevisType, setAddingDevisType] = useState(false);
  
  // Resync state
  const [resyncing, setResyncing] = useState(false);
  const [resyncingDevisId, setResyncingDevisId] = useState(null);

  // Devis fournisseur analysis state (Marge tab)
  const [isDraggingDevisFournisseur, setIsDraggingDevisFournisseur] = useState(false);
  const [analyzingDevisFournisseur, setAnalyzingDevisFournisseur] = useState(false);
  const [showLotSelectionModal, setShowLotSelectionModal] = useState(false);
  const [analyzedDevisData, setAnalyzedDevisData] = useState(null);
  const [selectedLotForDevis, setSelectedLotForDevis] = useState('');
  const [selectedSlotForDevis, setSelectedSlotForDevis] = useState(1);
  const devisFournisseurInputRef = useRef(null);

  // BDC Signature state
  const [showBDCSignatureModal, setShowBDCSignatureModal] = useState(false);
  const [bdcToSign, setBdcToSign] = useState(null);
  const [signingBDC, setSigningBDC] = useState(false);
  const [bdcEmailFournisseur, setBdcEmailFournisseur] = useState('');
  const bdcSignatureRef = useRef(null);

  // BDC Email Modal (like Descriptif Artisans)
  const [showBDCEmailModal, setShowBDCEmailModal] = useState(false);
  const [bdcToEmail, setBdcToEmail] = useState(null);
  const [bdcEmailForm, setBdcEmailForm] = useState({
    email_fournisseur: '',
    nom_fournisseur: '',
    mode_vouvoiement: true,
    objet: '',
    message_html: ''
  });
  const [sendingBDCEmail, setSendingBDCEmail] = useState(false);
  const [bdcContactsList, setBdcContactsList] = useState([]);
  const [showBdcContactPicker, setShowBdcContactPicker] = useState(false);
  const [bdcContactSearch, setBdcContactSearch] = useState('');
  const [saveBdcContact, setSaveBdcContact] = useState(false);

  // Move Fournisseur Modal
  const [showMoveFournisseurModal, setShowMoveFournisseurModal] = useState(false);
  const [fournisseurToMove, setFournisseurToMove] = useState(null);
  const [newLotId, setNewLotId] = useState('');

  // Signature link modal
  const [showSignatureLinkModal, setShowSignatureLinkModal] = useState(false);
  const [signatureLinkDevis, setSignatureLinkDevis] = useState(null);
  const [signatureLinkEmail, setSignatureLinkEmail] = useState('');
  const [generatingSignatureLink, setGeneratingSignatureLink] = useState(false);

  // Factures artisans
  const [facturesArtisans, setFacturesArtisans] = useState([]);
  const [showUploadFactureModal, setShowUploadFactureModal] = useState(false);
  const [uploadingFacture, setUploadingFacture] = useState(false);
  const [newFacture, setNewFacture] = useState({
    artisan_nom: '',
    montant_ht: '',
    montant_ttc: '',
    date_facture: '',
    numero_facture: '',
    achat_artisan_id: '',
    lot_id: '',
    type_facture: 'simple', // 'simple' | 'acompte' | 'finale'
    commentaire: ''
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [analyzingInvoice, setAnalyzingInvoice] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  // Facture artisan AI alert (sous-traitance + TVA présente = incohérence)
  const [factureTvaWarning, setFactureTvaWarning] = useState(false);
  const [factureTvaAccepted, setFactureTvaAccepted] = useState(false);
  const [factureDetectedType, setFactureDetectedType] = useState(null); // 'sous_traitance' | 'fourniture' | null

  // BDC generation modal (fourniture vs sous-traitance)
  const [bdcModalFournisseur, setBdcModalFournisseur] = useState(null);
  const [bdcAutoLiquidation, setBdcAutoLiquidation] = useState(true);
  const [bdcProposing, setBdcProposing] = useState(false);
  const [bdcGenerating, setBdcGenerating] = useState(false);
  const [bdcAiProposalSource, setBdcAiProposalSource] = useState(null); // 'ai' | 'default' | null

  // Marge duplicates detection
  const [duplicatesModal, setDuplicatesModal] = useState(false);
  const [duplicatesPairs, setDuplicatesPairs] = useState([]);
  const [duplicatesLoading, setDuplicatesLoading] = useState(false);
  const [mergingPair, setMergingPair] = useState(null);

  // Facture history popover (per-slot list of linked factures)
  const [factureHistorySlot, setFactureHistorySlot] = useState(null);

  // Reassign facture modal (from Suivi Factures tab)
  const [reassignFactureTarget, setReassignFactureTarget] = useState(null);
  const [reassignLotId, setReassignLotId] = useState('');
  const [reassignSlotId, setReassignSlotId] = useState('');
  const [reassigning, setReassigning] = useState(false);
  const [reassignLotMenuOpen, setReassignLotMenuOpen] = useState(false);
  const [reassignSlotMenuOpen, setReassignSlotMenuOpen] = useState(false);
  const [statutMenuOpen, setStatutMenuOpen] = useState(false);
  const [devisSourceMenuOpen, setDevisSourceMenuOpen] = useState(false);
  const [facturesClient, setFacturesClient] = useState([]);
  const [uploadingFactureClient, setUploadingFactureClient] = useState(false);
  const [showFactureClientModal, setShowFactureClientModal] = useState(false);
  const [factureClientForm, setFactureClientForm] = useState({ numero_facture: '', date_facture: '', montant_ht: '', montant_ttc: '', file: null });

  // Frais Généraux (carte bancaire, restau, timbres, etc.)
  const [fraisGeneraux, setFraisGeneraux] = useState([]);
  const [showFraisGenModal, setShowFraisGenModal] = useState(false);
  const [showFraisGenDetailModal, setShowFraisGenDetailModal] = useState(false);
  const [editingFraisGen, setEditingFraisGen] = useState(null);
  const [fraisGenForm, setFraisGenForm] = useState({ libelle: '', montant_ht: '', montant_ttc: '', date: '', categorie: 'Divers' });
  const [savingFraisGen, setSavingFraisGen] = useState(false);

  // Descriptif Artisans (Demande de devis)
  const [descriptifArtisans, setDescriptifArtisans] = useState(null);
  const [loadingDescriptif, setLoadingDescriptif] = useState(false);
  const [creatingDescriptif, setCreatingDescriptif] = useState(false);
  const [selectedDevisSource, setSelectedDevisSource] = useState('');
  const [descriptifRemarques, setDescriptifRemarques] = useState('');
  const [editingDescriptifLigne, setEditingDescriptifLigne] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedLotsForExport, setSelectedLotsForExport] = useState([]);
  const [exportingDescriptif, setExportingDescriptif] = useState(false);
  const [resyncingDescriptif, setResyncingDescriptif] = useState(false);
  const [showChangeSourceModal, setShowChangeSourceModal] = useState(false);
  const [newDevisSource, setNewDevisSource] = useState('');
  const [showAddLigneModal, setShowAddLigneModal] = useState(false);
  const [newLigne, setNewLigne] = useState({
    lot_id: '',
    lot_nom: '',
    sous_lot_nom: '',
    sous_sous_lot_nom: '',
    groupe_nom: '',
    is_titre_libre: false,
    description: '',
    unite: 'U',
    quantite: 0,
    localisation: '',
    commentaire: ''
  });

  // Email Descriptif Artisans
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailForm, setEmailForm] = useState({
    email_artisan: '',
    prenom_artisan: '',
    mode_tutoiement: true,
    objet: '',
    message_html: '',
    lots: 'all'
  });
  const [emailAttachments, setEmailAttachments] = useState([]);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailPreview, setEmailPreview] = useState(null);
  const [emailHistory, setEmailHistory] = useState([]);
  const [showEmailHistory, setShowEmailHistory] = useState(false);
  const emailAttachmentRef = useRef(null);
  // Guard against stale loadData responses (race between PATCH + DELETE)
  const loadDataTokenRef = useRef(0);
  // Prevents onBlur PATCH from firing when the user is deleting the slot
  const deletingSlotIdRef = useRef(null);
  
  // Contacts auto-complétion
  const [contactsList, setContactsList] = useState([]);
  const [showContactSuggestions, setShowContactSuggestions] = useState(false);
  const [contactSearchTerm, setContactSearchTerm] = useState('');
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [showSaveContactPrompt, setShowSaveContactPrompt] = useState(false);
  const [showContactPickerModal, setShowContactPickerModal] = useState(false);
  const [contactPickerSearch, setContactPickerSearch] = useState('');

  useEffect(() => {
    loadData();
  }, [projetId]);

  const loadData = async () => {
    // Increment token so any earlier in-flight loadData call becomes stale
    const myToken = ++loadDataTokenRef.current;
    try {
      const [projetRes, devisRes, fdRes, achatsRes, lotsRes, margeRes, facturesRes, planningsRes, bdcRes] = await Promise.all([
        getProjet(projetId).catch((e) => { console.warn('getProjet failed', e); return { data: null }; }),
        getProjetDevisMaag(projetId).catch((e) => { console.warn('getProjetDevisMaag failed', e); return { data: [] }; }),
        getFournisseursDirects(projetId).catch((e) => { console.warn('getFournisseursDirects failed', e); return { data: [] }; }),
        getAchatsArtisans(projetId).catch((e) => { console.warn('getAchatsArtisans failed', e); return { data: [] }; }),
        getLots().catch((e) => { console.warn('getLots failed', e); return { data: [] }; }),
        getProjetMarge(projetId).catch(() => ({ data: null })),
        getFacturesArtisans(projetId).catch(() => ({ data: [] })),
        getProjetPlannings(projetId).catch(() => ({ data: [] })),
        getProjetBDC(projetId).catch(() => ({ data: [] }))
      ]);
      // Drop stale responses (another loadData started meanwhile)
      if (myToken !== loadDataTokenRef.current) return;
      if (projetRes.data) setProjet(projetRes.data);
      setDevisMaag(devisRes.data || []);
      setFournisseursDirects(fdRes.data || []);
      setAchatsArtisans(achatsRes.data || []);
      setLots(lotsRes.data || []);
      setMargeData(margeRes.data);
      setFacturesArtisans(facturesRes.data || []);
      setPlannings(planningsRes.data || []);
      setBdcList(bdcRes.data || []);

      // Load client invoices (Henrri PDFs)
      try {
        const fcRes = await listFacturesClient(projetId);
        setFacturesClient(fcRes.data || []);
      } catch (e) {
        setFacturesClient([]);
      }

      // Load frais généraux
      try {
        const fgRes = await listFraisGeneraux(projetId);
        setFraisGeneraux(fgRes.data || []);
      } catch (e) {
        setFraisGeneraux([]);
      }
      
      // Load available devis types
      try {
        const availableRes = await getAvailableDevisTypes(projetId);
        setAvailableDevisTypes(availableRes.data);
      } catch (e) {
        setAvailableDevisTypes([]);
      }
      
      // Load descriptif artisans
      try {
        const descriptifRes = await getDescriptifArtisans(projetId);
        setDescriptifArtisans(descriptifRes.data);
        if (descriptifRes.data) {
          setDescriptifRemarques(descriptifRes.data.remarques || '');
        }
      } catch (e) {
        setDescriptifArtisans(null);
      }
    } catch (e) {
      // Use setTimeout to avoid flushSync warning
      setTimeout(() => {
        toast.error('Erreur lors du chargement');
        navigate('/clients');
      }, 0);
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePlanning = async () => {
    try {
      setCreatingPlanning(true);
      const res = await createPlanning(projetId);
      toast.success('Planning créé');
      navigate(`/planning/${res.data.id}`);
    } catch (err) {
      toast.error('Erreur lors de la création du planning');
    } finally {
      setCreatingPlanning(false);
    }
  };

  const handleDuplicatePlanning = async (planningId) => {
    try {
      const res = await duplicatePlanning(planningId);
      toast.success('Planning dupliqué');
      loadData();
    } catch (err) {
      toast.error('Erreur lors de la duplication');
    }
  };

  const handleDeletePlanning = async (planningId) => {
    if (!window.confirm('Supprimer ce planning ?')) return;
    try {
      await deletePlanning(planningId);
      toast.success('Planning supprimé');
      loadData();
    } catch (err) {
      toast.error('Erreur lors de la suppression');
    }
  };

  // ============ DESCRIPTIF ARTISANS HANDLERS ============
  
  const loadDescriptifArtisans = async () => {
    try {
      setLoadingDescriptif(true);
      const res = await getDescriptifArtisans(projetId);
      setDescriptifArtisans(res.data);
      if (res.data) {
        setDescriptifRemarques(res.data.remarques || '');
      }
    } catch (e) {
      setDescriptifArtisans(null);
    } finally {
      setLoadingDescriptif(false);
    }
  };

  const handleCreateDescriptif = async () => {
    if (!selectedDevisSource) {
      toast.error('Veuillez sélectionner un devis source');
      return;
    }
    try {
      setCreatingDescriptif(true);
      await createDescriptifArtisans(projetId, {
        devis_source_id: selectedDevisSource,
        remarques: ''
      });
      toast.success('Descriptif artisans créé');
      await loadDescriptifArtisans();
    } catch (e) {
      toast.error('Erreur lors de la création');
    } finally {
      setCreatingDescriptif(false);
    }
  };

  const handleResyncDescriptif = async () => {
    if (!window.confirm('Resynchroniser depuis le devis source ? Toutes vos modifications seront écrasées.')) return;
    try {
      setResyncingDescriptif(true);
      await resyncDescriptifArtisans(projetId);
      toast.success('Descriptif resynchronisé');
      await loadDescriptifArtisans();
    } catch (e) {
      toast.error('Erreur lors de la resynchronisation');
    } finally {
      setResyncingDescriptif(false);
    }
  };

  const handleChangeSourceDevis = async () => {
    if (!newDevisSource) {
      toast.error('Veuillez sélectionner un devis source');
      return;
    }
    if (!window.confirm('Remplacer le devis source ? Toutes les lignes actuelles seront écrasées par celles du nouveau devis.')) return;
    try {
      setResyncingDescriptif(true);
      await resyncDescriptifArtisans(projetId, newDevisSource);
      toast.success('Descriptif mis à jour depuis le nouveau devis');
      setShowChangeSourceModal(false);
      setNewDevisSource('');
      await loadDescriptifArtisans();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erreur lors du changement de source');
    } finally {
      setResyncingDescriptif(false);
    }
  };

  const handleDeleteDescriptif = async () => {
    if (!window.confirm('Supprimer complètement le descriptif artisans ? Vous pourrez ensuite le recréer depuis un devis de votre choix.')) return;
    try {
      await deleteDescriptifArtisans(projetId);
      toast.success('Descriptif supprimé');
      setDescriptifArtisans(null);
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const handleUpdateDescriptifRemarques = async () => {
    try {
      await updateDescriptifArtisans(projetId, { remarques: descriptifRemarques });
      toast.success('Remarques enregistrées');
    } catch (e) {
      toast.error('Erreur lors de la sauvegarde');
    }
  };

  const handleUpdateDescriptifLigne = async (ligneId, updates) => {
    try {
      await updateDescriptifLigne(projetId, ligneId, updates);
      await loadDescriptifArtisans();
      setEditingDescriptifLigne(null);
      toast.success('Ligne mise à jour');
    } catch (e) {
      toast.error('Erreur lors de la mise à jour');
    }
  };

  const handleDeleteDescriptifLigne = async (ligneId) => {
    if (!window.confirm('Supprimer cette ligne ?')) return;
    try {
      await deleteDescriptifLigne(projetId, ligneId);
      await loadDescriptifArtisans();
      toast.success('Ligne supprimée');
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const handleAddDescriptifLigne = async () => {
    if (!newLigne.description.trim()) {
      toast.error('La description est requise');
      return;
    }
    try {
      await addDescriptifLigne(projetId, newLigne);
      await loadDescriptifArtisans();
      setShowAddLigneModal(false);
      setNewLigne({
        lot_id: '',
        lot_nom: '',
        sous_lot_nom: '',
        sous_sous_lot_nom: '',
        groupe_nom: '',
        is_titre_libre: false,
        description: '',
        unite: 'U',
        quantite: 0,
        localisation: '',
        commentaire: ''
      });
      toast.success('Ligne ajoutée');
    } catch (e) {
      toast.error('Erreur lors de l\'ajout');
    }
  };

  const handleExportDescriptif = async (format) => {
    try {
      setExportingDescriptif(true);
      const lotsParam = selectedLotsForExport.length > 0 ? selectedLotsForExport.join(',') : 'all';
      const filename = `Demande_Devis_${projet?.enseigne_nom || 'Client'}_${projet?.ville || ''}`.replace(/\s+/g, '_');

      if (format === 'pdf') {
        setShowExportModal(false);
        await openPdfPreview(
          `/projets/${projetId}/descriptif-artisans/export/pdf?lots=${lotsParam}`,
          { title: `Descriptif artisans — ${projet?.enseigne_nom || ''}`, filename: `${filename}.pdf` }
        );
      } else {
        await downloadDescriptifExcel(projetId, lotsParam, filename);
        toast.success(`Export XLSX téléchargé`);
        setShowExportModal(false);
      }
    } catch (e) {
      toast.error('Erreur lors de l\'export');
    } finally {
      setExportingDescriptif(false);
    }
  };

  // ============ EMAIL DESCRIPTIF HANDLERS ============
  
  const loadEmailHistory = async () => {
    try {
      const res = await getDescriptifEmailHistory(projetId);
      setEmailHistory(res.data || []);
    } catch (e) {
      setEmailHistory([]);
    }
  };

  // Chargement des contacts fournisseurs pour l'auto-complétion
  const loadContactsForAutocomplete = async () => {
    try {
      const res = await getContacts('fournisseur', null);
      setContactsList(res.data);
    } catch (e) {
      console.error('Error loading contacts', e);
    }
  };

  // Filtrer les contacts selon la recherche
  const handleContactSearch = (searchValue) => {
    setContactSearchTerm(searchValue);
    if (searchValue.length < 2) {
      setFilteredContacts([]);
      setShowContactSuggestions(false);
      return;
    }
    
    const searchLower = searchValue.toLowerCase();
    const filtered = contactsList.filter(c => 
      c.nom?.toLowerCase().includes(searchLower) ||
      c.prenom?.toLowerCase().includes(searchLower) ||
      c.entreprise?.toLowerCase().includes(searchLower) ||
      c.email?.toLowerCase().includes(searchLower)
    ).slice(0, 5);
    
    setFilteredContacts(filtered);
    setShowContactSuggestions(filtered.length > 0);
  };

  // Sélectionner un contact depuis les suggestions
  const handleSelectContact = (contact) => {
    setEmailForm(prev => ({
      ...prev,
      prenom_artisan: contact.prenom || contact.nom,
      email_artisan: contact.email || ''
    }));
    setShowContactSuggestions(false);
    setContactSearchTerm('');
    setTimeout(handleUpdateEmailPreview, 100);
  };

  // Sauvegarder le contact après envoi
  const handleSaveNewContact = async () => {
    try {
      await createContact({
        nom: emailForm.prenom_artisan,
        prenom: '',
        entreprise: '',
        email: emailForm.email_artisan,
        telephone: '',
        type_contact: 'fournisseur',
        metier: '',
        notes: `Ajouté depuis le projet ${projet?.nom_complet || ''}`
      });
      toast.success('Contact enregistré !');
      setShowSaveContactPrompt(false);
      loadContactsForAutocomplete();
    } catch (e) {
      console.error('Error saving contact', e);
      toast.error('Erreur lors de l\'enregistrement');
    }
  };

  // ============ BDC EMAIL FUNCTIONS ============
  
  const handleOpenBDCEmailModal = async (bdc) => {
    setBdcToEmail(bdc);
    setBdcEmailForm({
      email_fournisseur: '',
      nom_fournisseur: '',
      mode_vouvoiement: true,
      objet: '',
      message_html: ''
    });
    setSaveBdcContact(false);
    setShowBDCEmailModal(true);
    
    // Load contacts
    try {
      const res = await getContacts('fournisseur', null);
      setBdcContactsList(res.data);
    } catch (e) {
      console.error('Error loading contacts', e);
    }
  };

  const handleUpdateBDCEmailPreview = async () => {
    if (!bdcToEmail || !bdcEmailForm.nom_fournisseur.trim()) return;
    
    try {
      const res = await getBDCEmailTemplate(
        projetId,
        bdcToEmail.id,
        bdcEmailForm.nom_fournisseur,
        bdcEmailForm.mode_vouvoiement
      );
      setBdcEmailForm(prev => ({
        ...prev,
        objet: res.data.objet,
        message_html: res.data.message_html
      }));
    } catch (e) {
      console.error('Error loading BDC email template', e);
    }
  };

  const handleSelectBdcContact = async (contact) => {
    const newNom = contact.prenom || contact.nom;
    setBdcEmailForm(prev => ({
      ...prev,
      nom_fournisseur: newNom,
      email_fournisseur: contact.email || ''
    }));
    setShowBdcContactPicker(false);
    
    // Call API with the new name directly
    if (bdcToEmail && newNom.trim()) {
      try {
        const res = await getBDCEmailTemplate(
          projetId,
          bdcToEmail.id,
          newNom,
          bdcEmailForm.mode_vouvoiement
        );
        setBdcEmailForm(prev => ({
          ...prev,
          nom_fournisseur: newNom,
          email_fournisseur: contact.email || '',
          objet: res.data.objet,
          message_html: res.data.message_html
        }));
      } catch (e) {
        console.error('Error loading BDC email template', e);
      }
    }
  };

  const handleSendBDCEmail = async () => {
    if (!bdcEmailForm.email_fournisseur || !bdcEmailForm.nom_fournisseur) {
      toast.error('Email et nom du fournisseur requis');
      return;
    }
    
    try {
      setSendingBDCEmail(true);
      await sendBDCEmail(projetId, bdcToEmail.id, {
        email_fournisseur: bdcEmailForm.email_fournisseur,
        nom_fournisseur: bdcEmailForm.nom_fournisseur,
        mode_vouvoiement: bdcEmailForm.mode_vouvoiement,
        objet: bdcEmailForm.objet,
        message_html: bdcEmailForm.message_html,
        save_contact: saveBdcContact
      });
      toast.success(`Email envoyé à ${bdcEmailForm.email_fournisseur}`);
      setShowBDCEmailModal(false);
    } catch (e) {
      console.error('Error sending BDC email', e);
      toast.error('Erreur lors de l\'envoi de l\'email');
    } finally {
      setSendingBDCEmail(false);
    }
  };

  // ============ MOVE FOURNISSEUR FUNCTIONS ============

  const handleOpenMoveFournisseur = (fournisseur) => {
    setFournisseurToMove(fournisseur);
    setNewLotId(fournisseur.lot_id);
    setShowMoveFournisseurModal(true);
  };

  const handleMoveFournisseur = async () => {
    if (!fournisseurToMove || !newLotId) return;
    
    try {
      if (fournisseurToMove.legacy) await moveFournisseur(fournisseurToMove.legacy_id || fournisseurToMove.id, newLotId);
      else await moveFournisseurLot(projetId, fournisseurToMove.id, newLotId);
      toast.success(`Fournisseur déplacé vers le lot ${newLotId}`);
      setShowMoveFournisseurModal(false);
      await loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors du déplacement');
    }
  };

  const handleDeleteFournisseur = async (fournisseur) => {
    if (!fournisseur?.id) return;
    // Mark as deleting BEFORE the confirm so any pending onBlur is skipped
    deletingSlotIdRef.current = fournisseur.id;
    if (!window.confirm(`Supprimer ${fournisseur.entreprise} du lot ${fournisseur.lot_id} ?`)) {
      deletingSlotIdRef.current = null;
      return;
    }

    try {
      // Legacy fournisseurs come from the old `achats_artisans` collection.
      // The `/fournisseurs-lots/{id}` endpoint only touches `fournisseurs_lots`,
      // so legacy rows need to be routed to `deleteAchatArtisan`.
      const targetId = fournisseur.legacy_id || fournisseur.id;
      if (fournisseur.legacy) {
        await deleteAchatArtisan(targetId);
      } else {
        await deleteFournisseurLot(projetId, fournisseur.id);
      }
      toast.success('Fournisseur supprimé');
      await loadData();
    } catch (e) {
      console.error('Error deleting fournisseur', e);
      toast.error('Erreur lors de la suppression');
    } finally {
      deletingSlotIdRef.current = null;
    }
  };

  // Delete a BDC (bon de commande). Also detaches the fournisseur slot.
  const handleDeleteBDC = async (bdc) => {
    if (!bdc?.id) return;
    const label = `${bdc.numero || 'ce BDC'} — ${bdc.entreprise || ''}`;
    const suffix = bdc.statut === 'signe'
      ? '\n\n⚠️ Ce BDC est déjà SIGNÉ. La suppression est définitive.'
      : '';
    if (!window.confirm(`Supprimer ${label} ?${suffix}`)) return;
    try {
      await deleteBdc(projetId, bdc.id);
      toast.success('BDC supprimé');
      await loadData();
    } catch (e) {
      console.error('Error deleting BDC', e);
      toast.error(e.response?.data?.detail || 'Erreur lors de la suppression');
    }
  };

  // Force-unlock a slot: detach every linked facture so the user can edit
  // or delete the fournisseur again (used when a facture was mis-rattached).
  const handleForceUnlockSlot = async (fournisseur, factures) => {
    if (!fournisseur?.id || !factures || factures.length === 0) return;
    const label = fournisseur.entreprise || `slot ${fournisseur.slot || ''}`;
    const msg =
      `Déverrouiller "${label}" ?\n\n` +
      `${factures.length} facture(s) actuellement rattachée(s) seront détachées.\n` +
      `Les factures ne sont PAS supprimées : elles retourneront dans "À rattacher" et vous pourrez les réassigner.`;
    if (!window.confirm(msg)) return;

    try {
      // Truly detach each facture: parent_fournisseur_id=null and no lot_id
      // change → the facture returns to "À rattacher" queue.
      await Promise.all(
        factures.map((fa) =>
          reassignFacture(fa.id, {
            parent_fournisseur_id: null,
          }).catch((e) => {
            console.warn('reassign→null failed for facture', fa.id, e);
          })
        )
      );
      toast.success(`Slot déverrouillé (${factures.length} facture(s) détachée(s))`);
      await loadData();
    } catch (e) {
      console.error('Error force-unlock', e);
      toast.error('Erreur lors du déverrouillage');
    }
  };

  // Open BDC generation modal: ask whether it's sous-traitance (auto-liquidation)
  // or fourniture (avec TVA). Optionally call AI to propose the right type.
  const handleOpenBdcModal = async (fournisseur) => {
    setBdcModalFournisseur(fournisseur);
    setBdcAutoLiquidation(true); // Default: sous-traitance (most frequent)
    setBdcAiProposalSource(null);
    if (fournisseur?.pdf_filename) {
      setBdcProposing(true);
      try {
        const res = await proposeBDCType(projetId, fournisseur.id);
        const proposed = !!res.data.auto_liquidation_proposed;
        setBdcAutoLiquidation(proposed);
        setBdcAiProposalSource(res.data.source || null);
      } catch (e) {
        // Silent fallback to default
      } finally {
        setBdcProposing(false);
      }
    }
  };

  const handleConfirmBdc = async () => {
    if (!bdcModalFournisseur) return;
    setBdcGenerating(true);
    try {
      const res = await genererBDC(projetId, bdcModalFournisseur.id, { auto_liquidation: bdcAutoLiquidation });
      toast.success(res.data.message || 'BDC généré');
      setBdcModalFournisseur(null);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur génération BDC');
    } finally {
      setBdcGenerating(false);
    }
  };

  // Marge duplicates detection
  const handleOpenDuplicates = async () => {
    setDuplicatesModal(true);
    setDuplicatesLoading(true);
    try {
      const res = await detectMargeDuplicates(projetId);
      setDuplicatesPairs(res.data.pairs || []);
    } catch (e) {
      toast.error('Erreur lors de la détection');
      setDuplicatesPairs([]);
    } finally {
      setDuplicatesLoading(false);
    }
  };

  const handleMergeDuplicates = async (pair, keepIsA) => {
    const keepId = keepIsA ? pair.slot_a.id : pair.slot_b.id;
    const discardId = keepIsA ? pair.slot_b.id : pair.slot_a.id;
    setMergingPair(`${pair.slot_a.id}-${pair.slot_b.id}`);
    try {
      await mergeFournisseurSlots(projetId, keepId, discardId);
      toast.success('Doublon fusionné');
      // Refresh duplicates list
      const res = await detectMargeDuplicates(projetId);
      setDuplicatesPairs(res.data.pairs || []);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur fusion');
    } finally {
      setMergingPair(null);
    }
  };

  // Reassign facture handlers
  const handleOpenReassign = (facture) => {
    setReassignFactureTarget(facture);
    setReassignLotId(facture.lot_id || '');
    setReassignSlotId(facture.parent_fournisseur_id || '');
    setReassignLotMenuOpen(false);
    setReassignSlotMenuOpen(false);
  };

  const handleConfirmReassign = async () => {
    if (!reassignFactureTarget) return;
    setReassigning(true);
    try {
      await reassignFacture(reassignFactureTarget.id, {
        lot_id: reassignLotId || null,
        parent_fournisseur_id: reassignSlotId || null,
      });
      toast.success('Rattachement modifié');
      setReassignFactureTarget(null);
      loadData();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur de réassignation');
    } finally {
      setReassigning(false);
    }
  };

  // Flat list of all slots in the project, used by the reassign modal
  const allFournisseurSlots = useMemo(() => {
    if (!margeData?.marges_par_lot) return [];
    return margeData.marges_par_lot.flatMap((lot) =>
      (lot.fournisseurs || []).map((f) => ({
        ...f,
        lot_id: lot.lot_id,
        lot_nom: lot.lot_nom,
      }))
    );
  }, [margeData]);

  // Signer BDC automatiquement et ouvrir modal email
  const handleSignerEtEnvoyerBDC = async (bdc) => {
    try {
      // Signer le BDC avec signature par défaut (tampon MAAG)
      await signerBDC(projetId, bdc.id, {
        signature_image: '', // Vide = utilise tampon MAAG par défaut
        signe_par: 'MAAG',
        email_fournisseur: ''
      });
      toast.success(`BDC ${bdc.numero} signé !`);
      
      // Recharger les données pour avoir le BDC signé
      await loadData();
      
      // Ouvrir le modal email avec le BDC signé
      const bdcSigne = { ...bdc, statut: 'signe' };
      handleOpenBDCEmailModal(bdcSigne);
      
    } catch (e) {
      console.error('Error signing BDC', e);
      toast.error(e.response?.data?.detail || 'Erreur lors de la signature');
    }
  };

  const handleOpenEmailModal = async () => {
    // Reset form
    setEmailForm({
      email_artisan: '',
      prenom_artisan: '',
      mode_tutoiement: true,
      objet: '',
      message_html: '',
      lots: selectedLotsForExport.length > 0 ? selectedLotsForExport.join(',') : 'all'
    });
    setEmailAttachments([]);
    setEmailPreview(null);
    setShowExportModal(false);
    setShowEmailModal(true);
    setShowContactSuggestions(false);
    setContactSearchTerm('');
    
    // Load contacts for autocomplete
    await loadContactsForAutocomplete();
    
    // Load email history
    await loadEmailHistory();
  };

  const handleUpdateEmailPreview = async () => {
    if (!emailForm.prenom_artisan.trim()) return;
    
    try {
      const res = await getDescriptifEmailTemplate(
        projetId,
        emailForm.prenom_artisan,
        emailForm.mode_tutoiement,
        emailForm.lots
      );
      setEmailPreview(res.data);
      setEmailForm(prev => ({
        ...prev,
        objet: prev.objet || res.data.objet,
        message: prev.message || ''
      }));
    } catch (e) {
      console.error('Error loading email template', e);
    }
  };

  const handleAddEmailAttachment = (e) => {
    const files = Array.from(e.target.files);
    const totalSize = emailAttachments.reduce((acc, f) => acc + f.size, 0) + files.reduce((acc, f) => acc + f.size, 0);
    
    if (totalSize > 10 * 1024 * 1024) {
      toast.error('Taille totale des pièces jointes dépasse 10 MB');
      return;
    }
    
    setEmailAttachments(prev => [...prev, ...files]);
    e.target.value = '';
  };

  const handleRemoveEmailAttachment = (index) => {
    setEmailAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const handleSendEmail = async () => {
    if (!emailForm.email_artisan.trim()) {
      toast.error('L\'email de l\'artisan est requis');
      return;
    }
    if (!emailForm.prenom_artisan.trim()) {
      toast.error('Le prénom de l\'artisan est requis');
      return;
    }
    
    try {
      setSendingEmail(true);
      
      const formData = new FormData();
      formData.append('email_artisan', emailForm.email_artisan);
      formData.append('prenom_artisan', emailForm.prenom_artisan);
      formData.append('mode_tutoiement', emailForm.mode_tutoiement);
      formData.append('lots', emailForm.lots);
      
      if (emailForm.objet) {
        formData.append('objet', emailForm.objet);
      }
      
      // Send the edited HTML message if modified
      if (emailForm.message_html) {
        formData.append('message_html', emailForm.message_html);
      }
      
      // Add attachments
      emailAttachments.forEach(file => {
        formData.append('attachments', file);
      });
      
      await sendDescriptifEmail(projetId, formData);
      toast.success(`Email envoyé à ${emailForm.email_artisan}`);
      
      // Check if this contact is new and propose to save it
      const existingContact = contactsList.find(c => 
        c.email?.toLowerCase() === emailForm.email_artisan.toLowerCase()
      );
      
      if (!existingContact && emailForm.email_artisan.trim()) {
        setShowSaveContactPrompt(true);
      } else {
        setShowEmailModal(false);
      }
      
      // Reload history
      await loadEmailHistory();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'envoi');
    } finally {
      setSendingEmail(false);
    }
  };

  // Convention de nommage imposée : « ENSEIGNE - VILLE LIEU - Objet »
  const objetPrefix = () => `${(projet?.enseigne_nom || '').toUpperCase().trim()} - ${(projet?.ville || '').toUpperCase().trim()} - `;
  const stripObjetPrefix = (full) => {
    const s = (full || '').trim();
    const p = objetPrefix();
    if (s.toUpperCase().startsWith(p)) return s.slice(p.length).trim();
    // Ancien format « MAINTENANCE YVES DELORME VELIZY… » : on garde le 1er mot comme objet
    const ens = (projet?.enseigne_nom || '').toUpperCase().trim();
    const ville = (projet?.ville || '').toUpperCase().trim();
    return s.toUpperCase().replace(ens, '').replace(ville, '').replace(/\s+/g, ' ').replace(/^[\s-]+|[\s-]+$/g, '').trim() || s;
  };
  const formatObjet = (libre) => `${objetPrefix()}${(libre || '').trim().toUpperCase()}`;

  // Adapte l'objet d'un devis source au projet courant → partie libre uniquement (le préfixe ENSEIGNE - VILLE est ajouté à la création)
  const adaptObjetToProjet = (sourceDevis) => {
    const src = (sourceDevis?.objet || '').trim();
    if (!projet) return src;
    const libre = stripObjetPrefix(src);
    if (sourceDevis?.projet_id === projet.id) return libre ? `${libre} (COPIE)` : '';
    return libre || 'DEVIS';
  };

  const handleRenameDevis = async (d) => {
    const objet = formatObjet(editingDevisObjet);
    if (!editingDevisObjet.trim()) { toast.error("L'objet ne peut pas être vide"); return; }
    if (objet === d.objet) { setEditingDevisObjetId(null); return; }
    if (d.statut === 'signe' && !window.confirm('Ce devis est signé. Renommer son objet quand même ?')) return;
    try {
      await updateDevis(d.id, { objet });
      setEditingDevisObjetId(null);
      toast.success('Objet du devis modifié');
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors du renommage');
    }
  };

  const handleCreateDevis = async () => {
    if (!newDevisObjet.trim()) {
      toast.error('L\'objet du devis est requis');
      return;
    }
    setCreatingDevis(true);
    try {
      let res;
      if (createMode === 'copier' && selectedSourceDevis) {
        // Duplicate from existing devis
        res = await duplicateDevisMaag({
          projet_id: projetId,
          source_devis_id: selectedSourceDevis.id,
          objet: formatObjet(newDevisObjet)
        });
        toast.success('Devis copié avec succès !');
      } else {
        // Create new devis
        res = await createDevisMaag({
          projet_id: projetId,
          objet: formatObjet(newDevisObjet)
        });
        toast.success('Devis créé avec succès !');
      }
      setShowNewDevisModal(false);
      setNewDevisObjet('');
      setCreateMode('vide');
      setSelectedSourceDevis(null);
      // Navigate to the new devis
      navigate(`/devis/${res.data.id}`);
    } catch (e) {
      console.error('Error creating devis:', e);
      toast.error('Erreur lors de la création du devis');
    } finally {
      setCreatingDevis(false);
    }
  };

  const loadDevisForCopy = async (filter) => {
    setLoadingDevisForCopy(true);
    try {
      const enseigneId = filter === 'same_enseigne' ? projet?.enseigne_id : null;
      const res = await getDevisAvailableForCopy(enseigneId);
      // Filter out devis from current project
      const filtered = res.data.filter(d => d.projet_id !== projetId);
      setAvailableDevisForCopy(filtered);
    } catch (e) {
      console.error('Error loading devis for copy:', e);
      toast.error('Erreur lors du chargement des devis');
    } finally {
      setLoadingDevisForCopy(false);
    }
  };

  const handleDeleteDevis = async (devisId, devisObjet, isSigned = false) => {
    const msg = isSigned
      ? `⚠️ ATTENTION : Le devis "${devisObjet}" est SIGNÉ.\n\nLa suppression d'un devis signé est définitive et peut avoir des conséquences comptables.\n\nÊtes-vous absolument sûr de vouloir le supprimer ?`
      : `Supprimer le devis "${devisObjet}" ? Cette action est irréversible.`;
    if (!window.confirm(msg)) {
      return;
    }
    try {
      await deleteDevisMaag(devisId);
      toast.success('Devis supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const handleAddDevisType = async (typeCode) => {
    setAddingDevisType(true);
    try {
      await addDevisTypeToProjet(projetId, typeCode);
      toast.success('Devis type ajouté');
      setShowNewDevisModal(false);
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'ajout');
    } finally {
      setAddingDevisType(false);
    }
  };

  // --- Frais Généraux handlers ---
  const openFraisGenModal = (frais = null) => {
    if (frais) {
      setEditingFraisGen(frais);
      setFraisGenForm({
        libelle: frais.libelle || '',
        montant_ht: String(frais.montant_ht || ''),
        montant_ttc: String(frais.montant_ttc || ''),
        date: frais.date || new Date().toISOString().slice(0, 10),
        categorie: frais.categorie || 'Divers',
      });
    } else {
      setEditingFraisGen(null);
      setFraisGenForm({
        libelle: '',
        montant_ht: '',
        montant_ttc: '',
        date: new Date().toISOString().slice(0, 10),
        categorie: 'Divers',
      });
    }
    setShowFraisGenModal(true);
  };

  const handleSaveFraisGen = async () => {
    if (!fraisGenForm.libelle.trim()) {
      toast.error('Libellé requis');
      return;
    }
    const ht = parseFloat(fraisGenForm.montant_ht);
    if (isNaN(ht) || ht <= 0) {
      toast.error('Montant HT invalide');
      return;
    }
    const ttc = fraisGenForm.montant_ttc ? parseFloat(fraisGenForm.montant_ttc) : ht;
    setSavingFraisGen(true);
    try {
      const payload = {
        libelle: fraisGenForm.libelle.trim(),
        montant_ht: ht,
        montant_ttc: isNaN(ttc) ? ht : ttc,
        date: fraisGenForm.date,
        categorie: fraisGenForm.categorie,
      };
      if (editingFraisGen) {
        await updateFraisGeneral(projetId, editingFraisGen.id, payload);
        toast.success('Frais général mis à jour');
      } else {
        await createFraisGeneral(projetId, payload);
        toast.success('Frais général ajouté');
      }
      setShowFraisGenModal(false);
      setEditingFraisGen(null);
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'enregistrement');
    } finally {
      setSavingFraisGen(false);
    }
  };

  const handleDeleteFraisGen = async (frais) => {
    if (!window.confirm(`Supprimer le frais "${frais.libelle}" ?`)) return;
    try {
      await deleteFraisGeneral(projetId, frais.id);
      toast.success('Frais supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };


  // --- Resync handlers ---
  const handleResyncFournisseurs = async () => {
    if (!window.confirm('Resynchroniser les fournisseurs directs depuis la Base MAAG ?\n\nCette action ajoutera les nouveaux fournisseurs de la base qui ne sont pas encore dans le projet. Les fournisseurs existants ne seront pas modifiés ni supprimés.')) {
      return;
    }
    
    setResyncing(true);
    try {
      const response = await resyncProjetFromBase(projetId);
      if (response.data.added_count > 0) {
        toast.success(response.data.message);
      } else {
        toast.info('Aucun nouveau fournisseur à ajouter. Le projet est déjà à jour.');
      }
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la synchronisation');
    } finally {
      setResyncing(false);
    }
  };

  const handleResyncDevis = async (devisId, devisObjet) => {
    if (!window.confirm(`Resynchroniser le devis "${devisObjet}" depuis la Base MAAG ?\n\nCette action ajoutera les nouvelles prestations activées dans la base qui ne sont pas encore dans le devis. Les postes existants ne seront pas modifiés ni supprimés.`)) {
      return;
    }
    
    setResyncingDevisId(devisId);
    try {
      const response = await resyncDevisFromBase(projetId, devisId);
      if (response.data.added_count > 0) {
        toast.success(response.data.message);
      } else {
        toast.info('Aucune nouvelle prestation à ajouter. Le devis est déjà à jour.');
      }
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la synchronisation');
    } finally {
      setResyncingDevisId(null);
    }
  };

  // --- Generate Signature Link ---
  const openSignatureLinkModal = (devis) => {
    setSignatureLinkDevis(devis);
    setSignatureLinkEmail('');
    setShowSignatureLinkModal(true);
  };

  const handleGenerateSignatureLink = async () => {
    if (!signatureLinkDevis) return;
    
    setGeneratingSignatureLink(true);
    try {
      const response = await generateSignatureLink(signatureLinkDevis.id, {
        client_email: signatureLinkEmail.trim() || null
      });
      const token = response.data.signature_token;
      const baseUrl = window.location.origin;
      const signatureUrl = `${baseUrl}/signature/${token}`;
      
      // Create marketing email content
      const emailHtml = `
Bonjour,

Veuillez trouver ci-joint votre devis "${signatureLinkDevis.objet}" pour validation.

👉 CLIQUEZ ICI POUR SIGNER LE DEVIS :
${signatureUrl}

Ce lien est valable 30 jours.

Cordialement,
MAAG - Aménagement de magasins
      `.trim();
      
      // Copy to clipboard
      await navigator.clipboard.writeText(emailHtml);
      
      setShowSignatureLinkModal(false);
      setSignatureLinkDevis(null);
      setSignatureLinkEmail('');
      
      toast.success(
        <div>
          <p className="font-semibold">📧 Texte pour email copié !</p>
          <p className="text-xs mt-1">Collez-le dans votre email au client.</p>
          {signatureLinkEmail && <p className="text-xs text-green-600 mt-1">Le PDF sera envoyé à {signatureLinkEmail} après signature.</p>}
          <p className="text-xs text-slate-500 mt-1">Lien valide 30 jours.</p>
        </div>,
        { duration: 6000 }
      );
      
      loadData(); // Refresh to show "En attente" status
    } catch (e) {
      if (e.response?.data?.detail?.includes('déjà signé')) {
        toast.error('Ce devis est déjà signé');
      } else {
        toast.error(e.response?.data?.detail || 'Erreur lors de la génération du lien');
      }
    } finally {
      setGeneratingSignatureLink(false);
    }
  };

  // --- Mark as signed manually ---
  const handleMarkAsSigned = async (devisId, signataireName) => {
    try {
      await signerDevis(devisId, {
        signature_image: '',  // No image for manual signature
        signataire_nom: signataireName
      });
      toast.success(`Devis marqué comme signé par ${signataireName}`);
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la validation');
    }
  };

  // --- Factures Artisans handlers ---
  const handleAnalyzeInvoice = async (file) => {
    if (!file) return;
    
    setSelectedFile(file);
    setAnalyzingInvoice(true);
    setFactureTvaWarning(false);
    setFactureTvaAccepted(false);
    setFactureDetectedType(null);
    toast.info('Analyse de la facture en cours...');
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await analyzeInvoice(formData);
      
      if (response.data.success && response.data.data) {
        const data = response.data.data;
        // Normalize lot_id: only accept it if it matches one of the project's lots
        const projectLotIds = new Set((lots || []).map((l) => String(l.lot_id || l.id)));
        const aiLotId = data.lot_id != null ? String(data.lot_id) : '';
        const matchedLotId = projectLotIds.has(aiLotId) ? aiLotId : '';
        setNewFacture(prev => ({
          ...prev,
          artisan_nom: data.artisan_nom || prev.artisan_nom,
          numero_facture: data.numero_facture || prev.numero_facture,
          date_facture: data.date_facture || prev.date_facture,
          montant_ht: data.montant_ht ? String(data.montant_ht) : prev.montant_ht,
          montant_ttc: data.montant_ttc ? String(data.montant_ttc) : prev.montant_ttc,
          // Le lot choisi par l'utilisateur pendant l'analyse n'est jamais écrasé par l'IA
          lot_id: prev.lot_id || matchedLotId,
        }));
        // Sous-traitance + TVA présente = incohérence → alerte bloquante
        const typePrest = data.type_prestation;
        setFactureDetectedType(typePrest || null);
        const hasTva = data.has_tva === true || data.has_tva === 'true';
        if (typePrest === 'sous_traitance' && hasTva) {
          setFactureTvaWarning(true);
          toast.error(
            "⚠️ ALERTE TVA : prestation détectée comme sous-traitance BTP mais la facture comporte de la TVA. " +
            "L'artisan aurait dû facturer en autoliquidation (sans TVA, art. 283-2 nonies du CGI).",
            { duration: 10000 }
          );
        } else if (matchedLotId) {
          toast.success(`Facture analysée ! Lot ${matchedLotId} proposé par l'IA — modifiable dans la liste avant d'enregistrer.`);
        } else {
          toast.success('Facture analysée ! Sélectionnez le lot puis cliquez sur Enregistrer.');
        }
      } else {
        toast.warning('Analyse partielle - veuillez compléter les champs manuellement');
      }
    } catch (e) {
      toast.error('Erreur lors de l\'analyse - veuillez remplir manuellement');
      console.error(e);
    } finally {
      setAnalyzingInvoice(false);
    }
  };

  // Drag & Drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!analyzingInvoice) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    if (analyzingInvoice) return;
    
    const files = e.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
        handleAnalyzeInvoice(file);
      } else {
        toast.error('Seuls les fichiers PDF sont acceptés');
      }
    }
  };

  const handleSaveFacture = async (force = false) => {
    if (!selectedFile || !newFacture.artisan_nom || !newFacture.montant_ht) {
      toast.error('Fichier PDF, nom artisan et montant HT requis');
      return;
    }
    
    setUploadingFacture(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('artisan_nom', newFacture.artisan_nom);
      formData.append('montant_ht', newFacture.montant_ht);
      if (newFacture.montant_ttc) formData.append('montant_ttc', newFacture.montant_ttc);
      if (newFacture.date_facture) formData.append('date_facture', newFacture.date_facture);
      if (newFacture.numero_facture) formData.append('numero_facture', newFacture.numero_facture);
      if (newFacture.achat_artisan_id) formData.append('achat_artisan_id', newFacture.achat_artisan_id);
      if (newFacture.lot_id) formData.append('lot_id', newFacture.lot_id);
      if (newFacture.type_facture) formData.append('type_facture', newFacture.type_facture);
      if (newFacture.commentaire) formData.append('commentaire', newFacture.commentaire);
      if (force) formData.append('force', 'true');
      
      const uploadRes = await uploadFactureArtisan(projetId, formData);
      const linkedSlot = uploadRes.data?.linked_slot;
      const factureId = uploadRes.data?.id;
      const wasAutoLinked = linkedSlot && (linkedSlot.via === 'fuzzy' || linkedSlot.via === 'exact');

      if (wasAutoLinked && factureId) {
        // Toast with "Annuler le rattachement" undo button
        toast.success(
          (t) => (
            <div className="flex items-center gap-3">
              <div>
                <p className="font-semibold text-sm">Facture rattachée à {linkedSlot.entreprise}</p>
                <p className="text-xs text-slate-500">Devis existant — pas de doublon créé</p>
              </div>
              <button
                onClick={async () => {
                  toast.dismiss(t.id);
                  try {
                    await unlinkFactureFromSlot(factureId);
                    toast.success('Rattachement annulé, nouveau slot créé');
                    loadData();
                  } catch {
                    toast.error('Erreur lors de l\'annulation');
                  }
                }}
                className="px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-medium hover:bg-red-200 whitespace-nowrap"
              >
                Non, autre fournisseur
              </button>
            </div>
          ),
          { duration: 8000 }
        );
      } else {
        toast.success('Facture enregistrée !');
      }

      setShowUploadFactureModal(false);
      setSelectedFile(null);
      setFactureTvaWarning(false);
      setFactureTvaAccepted(false);
      setFactureDetectedType(null);
      setNewFacture({
        artisan_nom: '',
        montant_ht: '',
        montant_ttc: '',
        date_facture: '',
        numero_facture: '',
        achat_artisan_id: '',
        lot_id: '',
        type_facture: 'simple',
        commentaire: ''
      });
      loadData();
    } catch (e) {
      const status = e.response?.status;
      const detail = e.response?.data?.detail;
      if (status === 409 && detail && detail.code === 'duplicate_facture') {
        const existing = detail.existing || {};
        const dateInfo = existing.date_facture || existing.date_paiement || '?';
        const fileInfo = existing.fichier_renomme || '?';
        const confirmMsg = `⚠️ ${detail.message}\n\nFacture existante :\n  • ${fileInfo}\n  • Date : ${dateInfo}\n  • N° : ${existing.numero_facture || '—'}\n\nVeux-tu quand même enregistrer cette nouvelle facture ?`;
        if (window.confirm(confirmMsg)) {
          await handleSaveFacture(true);
        }
        return;
      }
      toast.error(typeof detail === 'string' ? detail : 'Erreur upload');
    } finally {
      setUploadingFacture(false);
    }
  };

  const handleUploadFacture = async (file) => {
    if (!file || !newFacture.artisan_nom || !newFacture.montant_ht) {
      toast.error('Fichier PDF, nom artisan et montant HT requis');
      return;
    }
    
    setUploadingFacture(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('artisan_nom', newFacture.artisan_nom);
      formData.append('montant_ht', newFacture.montant_ht);
      if (newFacture.montant_ttc) formData.append('montant_ttc', newFacture.montant_ttc);
      if (newFacture.date_facture) formData.append('date_facture', newFacture.date_facture);
      if (newFacture.numero_facture) formData.append('numero_facture', newFacture.numero_facture);
      if (newFacture.achat_artisan_id) formData.append('achat_artisan_id', newFacture.achat_artisan_id);
      if (newFacture.lot_id) formData.append('lot_id', newFacture.lot_id);
      if (newFacture.commentaire) formData.append('commentaire', newFacture.commentaire);
      
      await uploadFactureArtisan(projetId, formData);
      toast.success('Facture uploadée');
      setShowUploadFactureModal(false);
      setNewFacture({
        artisan_nom: '',
        montant_ht: '',
        montant_ttc: '',
        date_facture: '',
        numero_facture: '',
        achat_artisan_id: '',
        lot_id: '',
        commentaire: ''
      });
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur upload');
    } finally {
      setUploadingFacture(false);
    }
  };

  const handleValidateFacture = async (factureId) => {
    try {
      await updateFactureArtisan(factureId, { statut: 'validee' });
      toast.success('Facture validée pour paiement');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handlePayFacture = async (factureId) => {
    try {
      await updateFactureArtisan(factureId, { statut: 'payee' });
      toast.success('Facture marquée comme payée');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleDeleteFacture = async (factureId) => {
    if (!window.confirm('Supprimer cette facture ?')) return;
    try {
      await deleteFactureArtisan(factureId);
      toast.success('Facture supprimée');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  // ===== SERVER PATH HANDLERS =====
  
  const handleCopyServerPath = () => {
    if (!projet?.server_path) return;
    navigator.clipboard.writeText(projet.server_path)
      .then(() => toast.success('Chemin copié dans le presse-papiers'))
      .catch(() => toast.error('Erreur lors de la copie'));
  };

  const handleOpenServerFolder = () => {
    if (!projet?.server_path) return;
    
    // For web browsers, we'll try file:// protocol
    // Note: This may not work in all browsers due to security restrictions
    const filePath = projet.server_path.replace(/\\/g, '/');
    const fileUrl = `file:///${filePath}`;
    
    try {
      // Try to open via window.open first
      const newWindow = window.open(fileUrl, '_blank');
      
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        // Fallback: show a message with instructions
        toast.info(
          'Le navigateur ne peut pas ouvrir directement l\'explorateur. Utilisez "Copier le chemin" puis collez dans l\'explorateur Windows.',
          { duration: 5000 }
        );
      } else {
        toast.success('Tentative d\'ouverture du dossier...');
      }
    } catch (err) {
      toast.error('Impossible d\'ouvrir le dossier depuis le navigateur');
    }
  };

  const handleSaveServerPath = async () => {
    setSavingServerPath(true);
    try {
      await updateProjet(projetId, { server_path: serverPathInput.trim() });
      toast.success('Chemin serveur enregistré');
      setEditingServerPath(false);
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de l\'enregistrement');
    } finally {
      setSavingServerPath(false);
    }
  };

  const handleGenerateSuggestedPath = async () => {
    try {
      const res = await getSuggestedServerPath(projetId);
      setServerPathInput(res.data.suggested_path);
      toast.success('Chemin suggéré généré');
    } catch (e) {
      toast.error('Erreur lors de la génération du chemin');
    }
  };

  const handleAddFournisseurDirect = async () => {
    if (!newFD.designation || !newFD.montant_ht) {
      toast.error('Désignation et montant requis');
      return;
    }
    try {
      await createFournisseurDirect({
        projet_id: projetId,
        ...newFD,
        montant_ht: parseFloat(newFD.montant_ht)
      });
      setNewFD({ designation: '', fournisseur: '', categorie: 'intervenants', payeur: 'CLIENT', montant_ht: '' });
      toast.success('Fournisseur direct ajouté');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleDeleteFD = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      await deleteFournisseurDirect(id);
      toast.success('Supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleAddAchat = async () => {
    if (!newAchat.entreprise || !newAchat.montant_ht) {
      toast.error('Entreprise et montant requis');
      return;
    }
    try {
      await createAchatArtisan({
        projet_id: projetId,
        ...newAchat,
        montant_ht: parseFloat(newAchat.montant_ht)
      });
      setNewAchat({ lot_id: '1', entreprise: '', description: '', montant_ht: '', statut: 'devis' });
      toast.success('Achat ajouté');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleDeleteAchat = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try {
      await deleteAchatArtisan(id);
      toast.success('Supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleUpdateAchatSuivi = async (achat, updates) => {
    try {
      await updateAchatArtisan(achat.id, {
        ...achat,
        ...updates
      });
      toast.success('Mis à jour');
      setEditingSuivi(null);
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const formatMoney = (value) => {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value || 0);
  };

  const getMargeColor = (pct) => {
    if (pct === null || pct === undefined) return 'text-slate-400';
    if (pct < 15) return 'text-red-600';
    if (pct < 20) return 'text-orange-500';
    return 'text-green-600';
  };

  const getMargeColorBg = (pct) => {
    if (pct === null || pct === undefined) return 'bg-slate-100 text-slate-600';
    if (pct < 15) return 'bg-red-100 text-red-700';
    if (pct < 20) return 'bg-orange-100 text-orange-700';
    return 'bg-green-100 text-green-700';
  };

  // Handle project update (for toggles & discrete changes — full reload)
  const handleUpdateProjet = async (field, value) => {
    try {
      await updateProjet(projetId, { [field]: value });
      toast.success('Mis à jour');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  // Debounced field change for text inputs — no full reload, no toast spam
  const saveTimerRef = useRef(null);
  const pendingChangesRef = useRef({});
  const handleFieldChange = (field, value) => {
    // Optimistic local update for responsive typing
    setProjet((prev) => (prev ? { ...prev, [field]: value } : prev));
    pendingChangesRef.current[field] = value;
    if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
    saveTimerRef.current = setTimeout(async () => {
      const changes = pendingChangesRef.current;
      pendingChangesRef.current = {};
      if (!Object.keys(changes).length) return;
      try {
        await updateProjet(projetId, changes);
      } catch (e) {
        toast.error('Erreur de sauvegarde');
      }
    }, 600);
  };

  // Flush pending changes on unmount
  useEffect(() => {
    return () => {
      if (saveTimerRef.current) {
        clearTimeout(saveTimerRef.current);
        const changes = pendingChangesRef.current;
        if (Object.keys(changes).length) {
          updateProjet(projetId, changes).catch(() => {});
        }
      }
    };
  }, [projetId]);

  // Calculate duration
  const calculateDuration = () => {
    if (projet.date_debut && projet.date_fin) {
      const debut = new Date(projet.date_debut);
      const fin = new Date(projet.date_fin);
      const diffMs = fin - debut;
      const diffWeeks = Math.ceil(diffMs / (1000 * 60 * 60 * 24 * 7));
      if (diffWeeks > 0) return `${diffWeeks} semaines`;
    }
    return '-';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Guard: API can return 5xx → projet stays null. Don't crash, show a friendly error.
  if (!projet) {
    return (
      <div className="flex flex-col items-center justify-center h-64 text-center gap-3" data-testid="projet-load-error">
        <p className="text-slate-700 font-medium">Impossible de charger le projet.</p>
        <p className="text-sm text-slate-500">Le serveur a peut-être renvoyé une erreur. Réessaie dans un instant.</p>
        <div className="flex gap-2">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 text-sm"
          >
            Recharger
          </button>
          <Link to="/clients" className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 text-sm">
            Retour aux enseignes
          </Link>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: 'infos', label: 'Infos Projet', icon: Edit2, count: null },
    { id: 'devis_maag', label: 'Devis MAAG', icon: FileText, count: devisMaag.length },
    { id: 'descriptif_artisans', label: 'Descriptif Artisans', icon: Hammer, count: descriptifArtisans?.lots?.length || null },
    { id: 'planning', label: 'Planning', icon: Calendar, count: plannings.length },
    { id: 'marge', label: 'Marge', icon: BarChart3, count: bdcList.length > 0 ? bdcList.length : null },
    { id: 'suivi_factures', label: 'Suivi Factures', icon: Receipt, count: facturesArtisans.length },
    { id: 'visites', label: 'Visites', icon: ClipboardCheck, count: null },
    { id: 'serveur', label: 'Serveur', icon: Server, count: null },
  ];

  // Check if user is admin
  const isAdmin = user?.is_admin === true;

  // Calculate totals for fournisseurs directs
  const totalFD = fournisseursDirects.reduce((sum, fd) => sum + fd.montant_ht, 0);
  const totalAchats = achatsArtisans.reduce((sum, a) => sum + a.montant_ht, 0);

  return (
    <div data-testid="projet-detail-page">
      {/* Header */}
      <div className="mb-6">
        <Link to={projet?.enseigne_id ? `/clients?enseigne=${projet.enseigne_id}` : '/clients'} className="inline-flex items-center text-sm text-slate-500 hover:text-slate-900 mb-4" data-testid="back-to-enseigne-link">
          <ArrowLeft className="w-4 h-4 mr-1" />
          Retour à {projet?.enseigne_nom || 'l\'enseigne'}
        </Link>
        
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">{projet.enseigne_nom}</p>
            <h1 className="text-2xl font-bold text-slate-900">{projet.ville}</h1>
            {projet.adresse && <p className="text-slate-500">{projet.adresse}</p>}
            {projet.is_cloture && (
              <div className="flex flex-wrap items-center gap-2 mt-2">
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-slate-700 text-white">
                  <Lock className="w-4 h-4 mr-1" /> {projet.statut === 'projet_non_realise' ? 'Projet non réalisé (lecture seule)' : 'Projet clôturé (lecture seule)'}
                </span>
                <button
                  type="button"
                  data-testid="reopen-projet-btn"
                  onClick={async () => {
                    if (!window.confirm('Rouvrir ce projet en Stand-by ?\n\nIl quittera les archives et redeviendra modifiable. Vous pourrez ensuite changer son statut (En préparation, En cours…).')) return;
                    try {
                      await updateProjet(projetId, { statut: 'stand_by' });
                      toast.success('Projet rouvert en Stand-by');
                      loadData();
                    } catch (err) {
                      toast.error(err.response?.data?.detail || 'Erreur lors de la réouverture');
                    }
                  }}
                  className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-amber-50 border border-amber-300 text-amber-800 hover:bg-amber-100 transition-colors"
                >
                  <Unlock className="w-4 h-4 mr-1" /> Rouvrir en Stand-by
                </button>
              </div>
            )}
          </div>
          <div className="flex items-center gap-3">
            {!projet.is_cloture && (() => {
              const statutOptions = [
                { value: 'en_preparation', label: '🔵 En préparation', cls: 'bg-blue-50 border-blue-200 text-blue-700' },
                { value: 'en_cours', label: '🟢 En cours', cls: 'bg-green-50 border-green-200 text-green-700' },
                { value: 'termine_facturation', label: '🟣 Terminé – facturation', cls: 'bg-purple-50 border-purple-200 text-purple-700' },
                { value: 'stand_by', label: '🟡 Stand-by', cls: 'bg-amber-50 border-amber-200 text-amber-700' },
                { value: 'projet_non_realise', label: '🔴 Projet non réalisé', cls: 'bg-red-50 border-red-200 text-red-700' },
              ];
              const current = statutOptions.find(o => o.value === projet.statut) || statutOptions[0];
              const changeStatut = (newStatut) => {
                setStatutMenuOpen(false);
                if (newStatut === projet.statut) return;
                if (newStatut === 'projet_non_realise') {
                  const yearNum = new Date().getFullYear();
                  if (!window.confirm(`Marquer ce projet comme NON RÉALISÉ ?\n\nIl sera archivé sous "Projet non réalisé ${yearNum}" pour vos statistiques.\nIl n'apparaîtra plus dans le CA ni les dashboards actifs.`)) return;
                  updateProjet(projetId, { statut: 'projet_non_realise', annee_cloture: yearNum }).then(() => {
                    toast.success('Projet archivé comme non réalisé');
                    loadData();
                  });
                } else {
                  updateProjet(projetId, { statut: newStatut }).then(() => {
                    toast.success('Statut mis à jour');
                    loadData();
                  });
                }
              };
              return (
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => setStatutMenuOpen(v => !v)}
                    data-testid="projet-statut-button"
                    className={`h-10 px-4 rounded-lg border text-sm font-medium flex items-center gap-2 ${current.cls}`}
                  >
                    <span>{current.label}</span>
                    <ChevronDown className={`w-4 h-4 transition-transform ${statutMenuOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {statutMenuOpen && (
                    <>
                      <div className="fixed inset-0 z-40" onClick={() => setStatutMenuOpen(false)} />
                      <div data-testid="projet-statut-menu" className="absolute right-0 mt-1 w-56 bg-white border border-slate-200 rounded-lg shadow-lg z-50 overflow-hidden">
                        {statutOptions.map(opt => (
                          <button
                            key={opt.value}
                            type="button"
                            data-testid={`projet-statut-option-${opt.value}`}
                            onClick={() => changeStatut(opt.value)}
                            className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-50 ${projet.statut === opt.value ? 'bg-slate-100 font-semibold' : ''}`}
                          >
                            {opt.label}
                          </button>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              );
            })()}
          </div>
        </div>
      </div>

      {/* Bandeau clôture */}
      {!projet.is_cloture && (projet.statut === 'termine_facturation' || (projet.client_paye && projet.artisans_payes)) && (
        <div className="bg-slate-100 border border-slate-300 rounded-xl p-4 mb-6">
          <h3 className="font-semibold text-slate-800 mb-3">Clôture du projet</h3>
          <div className="flex flex-wrap items-center gap-6">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={projet.client_paye || false}
                onChange={(e) => {
                  updateProjet(projetId, { client_paye: e.target.checked }).then(() => {
                    toast.success('Mis à jour');
                    loadData();
                  });
                }}
                className="w-5 h-5 rounded border-slate-300 text-green-600 focus:ring-green-500"
              />
              <span className="text-sm">Client a payé</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={projet.artisans_payes || false}
                onChange={(e) => {
                  updateProjet(projetId, { artisans_payes: e.target.checked }).then(() => {
                    toast.success('Mis à jour');
                    loadData();
                  });
                }}
                className="w-5 h-5 rounded border-slate-300 text-green-600 focus:ring-green-500"
              />
              <span className="text-sm">Artisans payés</span>
            </label>
            {projet.client_paye && projet.artisans_payes && (
              <button
                onClick={async () => {
                  const currentYear = new Date().getFullYear();
                  const inputYear = window.prompt(
                    `Sur quelle année fiscale archiver ce projet clôturé ?`,
                    String(currentYear)
                  );
                  if (inputYear === null) return; // user cancelled
                  const yearNum = parseInt(inputYear, 10);
                  if (!yearNum || yearNum < 2000 || yearNum > 2100) {
                    toast.error("Année invalide");
                    return;
                  }
                  if (!window.confirm(`Clôturer définitivement ce projet sur l'année ${yearNum} ?`)) return;
                  try {
                    await updateProjet(projetId, { statut: 'cloture', annee_cloture: yearNum });
                    toast.success(`Projet clôturé (archive ${yearNum})`);
                    loadData();
                  } catch (err) {
                    if (err.response?.data?.detail === 'CLOSURE_REQUIRES_CLIENT_INVOICE') {
                      if (window.confirm(
                        "⚠️ Aucune facture client n'est attachée à ce projet.\n\n" +
                        "Voulez-vous quand même clôturer ? La marge finale ne pourra pas être calculée précisément.\n\n" +
                        "Cliquez ANNULER pour retourner et ajouter une facture client d'abord."
                      )) {
                        try {
                          await updateProjet(projetId, { statut: 'cloture', annee_cloture: yearNum, force_cloture: true });
                          toast.warning(`Projet clôturé sans facture client (archive ${yearNum})`);
                          loadData();
                        } catch (e2) {
                          toast.error(e2.response?.data?.detail || "Erreur de clôture");
                        }
                      }
                    } else {
                      toast.error(err.response?.data?.detail || "Erreur de clôture");
                    }
                  }
                }}
                className="flex items-center px-4 py-2 bg-slate-800 text-white rounded-lg text-sm font-medium hover:bg-slate-900"
                data-testid="close-projet-btn"
              >
                <Lock className="w-4 h-4 mr-2" />
                Clôturer le projet
              </button>
            )}
          </div>
          {!(projet.client_paye && projet.artisans_payes) && (
            <p className="text-xs text-slate-500 mt-2">Cochez les deux cases pour pouvoir clôturer le projet.</p>
          )}
        </div>
      )}

      {/* KPIs */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <p className="text-xs text-slate-500 mb-1">CA MAAG</p>
          <p className="text-xl font-bold text-slate-900">{formatMoney(projet.ca_maag)}</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <p className="text-xs text-slate-500 mb-1">Coûts Artisans</p>
          <p className="text-xl font-bold text-slate-900">{formatMoney(projet.total_achats_artisans)}</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <p className="text-xs text-slate-500 mb-1">Marge €</p>
          <p className={`text-xl font-bold ${getMargeColor(projet.marge_pourcentage)}`}>{formatMoney(projet.marge_euros)}</p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <p className="text-xs text-slate-500 mb-1">Marge %</p>
          <p className={`text-xl font-bold ${getMargeColor(projet.marge_pourcentage)}`}>
            {projet.marge_pourcentage !== null ? `${projet.marge_pourcentage.toFixed(1)}%` : '-'}
          </p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          <p className="text-xs text-slate-500 mb-1">Budget Client</p>
          <p className="text-xl font-bold text-purple-600">{formatMoney(projet.budget_global_client)}</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <div className="border-b border-slate-200 overflow-x-auto">
          <nav className="flex -mb-px">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-5 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-slate-900 text-slate-900'
                    : 'border-transparent text-slate-500 hover:text-slate-700'
                }`}
              >
                <tab.icon className="w-4 h-4 mr-2" />
                {tab.label}
                {tab.count !== null && (
                  <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
                    activeTab === tab.id ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'
                  }`}>
                    {tab.count}
                  </span>
                )}
              </button>
            ))}
          </nav>
        </div>

        <div className="p-6">
          {/* Tab: Devis MAAG */}
          {activeTab === 'devis_maag' && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold">Devis MAAG</h3>
                {!projet.is_cloture && (
                  <button
                    onClick={() => {
                      // Défaut : "Depuis un modèle" si des types sont disponibles
                      // (cas typique d'un nouveau projet), sinon "vide"
                      setCreateMode(availableDevisTypes.length > 0 ? 'modele' : 'vide');
                      setShowNewDevisModal(true);
                    }}
                    className="flex items-center px-4 py-2 bg-slate-900 text-white rounded-lg text-sm font-medium hover:bg-slate-800"
                    data-testid="new-devis-btn"
                  >
                    <Plus className="w-4 h-4 mr-2" />
                    Nouveau devis
                  </button>
                )}
              </div>
              {devisMaag.length === 0 ? (
                <div className="text-center py-8">
                  <p className="text-slate-500 mb-4">Aucun devis MAAG.</p>
                  {availableDevisTypes.length > 0 && (
                    <button
                      onClick={() => { setCreateMode('modele'); setShowNewDevisModal(true); }}
                      className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Ajouter un devis type
                    </button>
                  )}
                </div>
              ) : (
                <>
                  {devisMaag.length > 1 && (() => {
                    const refIds = projet.devis_reference_ids || (projet.devis_reference_id ? [projet.devis_reference_id] : []);
                    const usedIds = projet.devis_used_ids || [];
                    const isManual = refIds.length > 0;
                    return (
                      <div className={`mb-3 p-3 rounded-lg border ${isManual ? 'bg-amber-50 border-amber-200' : 'bg-sky-50 border-sky-200'}`}>
                        <div className="flex items-start gap-2 text-sm">
                          <Star className={`w-4 h-4 flex-shrink-0 mt-0.5 ${isManual ? 'fill-amber-500 text-amber-500' : 'text-sky-600'}`} />
                          <div>
                            {isManual ? (
                              <>
                                <span className="font-medium text-amber-900">
                                  {refIds.length === 1 ? '1 devis de référence verrouillé' : `${refIds.length} devis de référence verrouillés`}
                                </span>
                                <span className="text-amber-700"> — Le CA MAAG et la marge sont calculés à partir de la <strong>somme des devis marqués d'une ⭐ pleine</strong>. Re-cliquez sur l'étoile pour retirer un devis de la référence.</span>
                              </>
                            ) : (
                              <>
                                <span className="font-medium text-sky-900">Mode automatique</span>
                                <span className="text-sky-700"> — Le système utilise par défaut <strong>les devis signés</strong> s'il y en a, sinon <strong>le plus ancien</strong> (étoile dorée pâle = utilisé automatiquement). Cliquez sur les étoiles pour verrouiller une sélection manuelle (multi-sélection possible).</span>
                              </>
                            )}
                            {usedIds.length > 0 && (
                              <div className="text-xs text-slate-600 mt-1">
                                Devis comptés : <strong>{usedIds.length}/{devisMaag.length}</strong>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                  <table className="w-full">
                    <thead className="bg-slate-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">Type</th>
                        <th className="px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">Objet</th>
                        <th className="px-4 py-3 text-left text-xs font-bold uppercase text-slate-500">Version</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase text-slate-500">Statut</th>
                        <th className="px-4 py-3 text-right text-xs font-bold uppercase text-slate-500">Total HT</th>
                        <th className="px-4 py-3 text-right text-xs font-bold uppercase text-slate-500">Total TTC</th>
                        <th className="px-4 py-3 text-center text-xs font-bold uppercase text-slate-500">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {devisMaag.map((d) => {
                        const typeLabels = {
                          'travaux_centre_ville': 'Centre-ville',
                          'travaux_centre_commercial': 'Centre co.',
                          'maintenance': 'Maintenance',
                          'bureau_etude': 'Bureau ét.'
                        };
                        const isSigned = d.statut === 'signe';
                        const hasSignatureLink = d.has_signature_link && !isSigned;
                        return (
                          <tr key={d.id} className={`hover:bg-slate-50 ${isSigned ? 'bg-green-50 border-l-4 border-green-500' : hasSignatureLink ? 'bg-amber-50 border-l-4 border-amber-400' : ''}`}>
                            <td className="px-4 py-3">
                              <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded font-medium">
                                {typeLabels[d.type_code] || d.type_code || 'Standard'}
                              </span>
                            </td>
                            <td className="px-4 py-3">
                              {editingDevisObjetId === d.id ? (
                                <div className="flex items-center gap-1">
                                  <div className="flex items-stretch rounded-md border border-indigo-400 overflow-hidden w-full min-w-[320px] focus-within:ring-2 focus-within:ring-indigo-500">
                                    <span className="flex items-center px-2 text-xs font-semibold text-slate-600 bg-slate-100 border-r border-slate-200 whitespace-nowrap" data-testid={`devis-objet-prefix-${d.id}`}>{objetPrefix()}</span>
                                    <input
                                      autoFocus
                                      value={editingDevisObjet}
                                      onChange={(e) => setEditingDevisObjet(e.target.value)}
                                      onKeyDown={(e) => { if (e.key === 'Enter') handleRenameDevis(d); if (e.key === 'Escape') setEditingDevisObjetId(null); }}
                                      className="h-8 px-2 text-sm font-medium flex-1 min-w-0 uppercase focus:outline-none"
                                      placeholder="Objet"
                                      data-testid={`devis-objet-input-${d.id}`}
                                    />
                                  </div>
                                  <button onClick={() => handleRenameDevis(d)} className="p-1.5 text-green-600 hover:bg-green-50 rounded" title="Valider" data-testid={`devis-objet-save-${d.id}`}><Check className="w-4 h-4" /></button>
                                  <button onClick={() => setEditingDevisObjetId(null)} className="p-1.5 text-slate-400 hover:bg-slate-100 rounded" title="Annuler"><X className="w-4 h-4" /></button>
                                </div>
                              ) : (
                                <span className="group/objet inline-flex items-center gap-1.5">
                                  <Link to={`/devis/${d.id}`} className="font-medium text-slate-900 hover:text-blue-600" data-testid={`devis-objet-${d.id}`}>
                                    {d.objet}
                                  </Link>
                                  <button
                                    onClick={() => { setEditingDevisObjetId(d.id); setEditingDevisObjet(stripObjetPrefix(d.objet)); }}
                                    className="p-1 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded transition-colors"
                                    title={isSigned ? "Renommer l'objet (devis signé : confirmation demandée)" : "Renommer l'objet du devis"}
                                    data-testid={`devis-objet-edit-${d.id}`}
                                  >
                                    <Edit2 className="w-3.5 h-3.5" />
                                  </button>
                                </span>
                              )}
                              {isSigned && d.signataire_nom && (
                                <p className="text-xs text-green-600 mt-1">
                                  ✓ Signé par {d.signataire_nom} le {d.date_signature}
                                </p>
                              )}
                              {hasSignatureLink && (
                                <p className="text-xs text-amber-600 mt-1">
                                  ⏳ Lien de signature envoyé - en attente
                                </p>
                              )}
                            </td>
                            <td className="px-4 py-3 text-sm text-slate-500">v{d.version}</td>
                            <td className="px-4 py-3 text-center">
                              {d.statut === 'signe' ? (
                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-green-500 text-white shadow-sm">
                                  <CheckCircle className="w-3.5 h-3.5 mr-1" />
                                  SIGNÉ
                                </span>
                              ) : hasSignatureLink ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                                  <Clock className="w-3 h-3 mr-1" />
                                  En attente
                                </span>
                              ) : d.statut === 'envoye' ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                  Envoyé
                                </span>
                              ) : d.statut === 'refuse' ? (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                  Refusé
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600">
                                  Brouillon
                                </span>
                              )}
                            </td>
                            <td className="px-4 py-3 text-sm text-right font-mono">{formatMoney(d.total_ht_maag || d.total_ht)}</td>
                            <td className="px-4 py-3 text-sm text-right font-mono font-semibold">{formatMoney(d.total_ttc)}</td>
                            <td className="px-4 py-3 text-center">
                              <div className="flex items-center justify-center gap-1">
                                {/* Référence pour CA MAAG + marge (multi-select) */}
                                {(() => {
                                  const refIds = projet.devis_reference_ids || (projet.devis_reference_id ? [projet.devis_reference_id] : []);
                                  const isRef = refIds.includes(d.id);
                                  const usedIds = projet.devis_used_ids || [];
                                  const isAutoUsed = refIds.length === 0 && usedIds.includes(d.id);
                                  return (
                                    <button
                                      onClick={async () => {
                                        const next = isRef
                                          ? refIds.filter((x) => x !== d.id)
                                          : [...refIds, d.id];
                                        try {
                                          await setDevisReference(projetId, next);
                                          const action = isRef ? 'retiré' : 'ajouté';
                                          toast.success(
                                            next.length === 0
                                              ? 'Aucune référence : retour au mode auto (signé sinon plus ancien)'
                                              : `Devis ${action} aux références (${next.length} sélectionné${next.length > 1 ? 's' : ''})`
                                          );
                                          loadData();
                                        } catch (err) {
                                          toast.error('Erreur lors de la mise à jour');
                                        }
                                      }}
                                      className={`p-2 rounded-lg transition-colors ${
                                        isRef
                                          ? 'text-amber-500 bg-amber-50 hover:bg-amber-100'
                                          : isAutoUsed
                                            ? 'text-amber-300 hover:text-amber-500 hover:bg-amber-50'
                                            : 'text-slate-300 hover:text-amber-500 hover:bg-amber-50'
                                      }`}
                                      title={
                                        isRef
                                          ? 'Sélectionné comme référence — cliquer pour retirer'
                                          : isAutoUsed
                                            ? 'Utilisé automatiquement par défaut (cliquer pour le verrouiller comme référence)'
                                            : 'Cliquer pour l\'ajouter aux références (multi-sélection possible)'
                                      }
                                      data-testid={`set-ref-btn-${d.id}`}
                                    >
                                      <Star className={`w-4 h-4 ${isRef || isAutoUsed ? 'fill-amber-500' : ''}`} />
                                    </button>
                                  );
                                })()}
                                {/* PDF Aperçu (via modal — n'écrase plus le téléchargement direct) */}
                                <button
                                  onClick={() => {
                                    const dateStr = (d.date_creation || d.created_at || '').slice(0, 10) || new Date().toISOString().slice(0, 10);
                                    const enseigne = (projet?.enseigne_nom || '').toUpperCase().trim();
                                    const ville = (projet?.ville || '').toUpperCase().trim();
                                    const objet = (d.objet || `Devis ${d.numero || ''}`).trim();
                                    const parts = [dateStr, [enseigne, ville].filter(Boolean).join(' '), objet].filter(Boolean);
                                    const fname = `${parts.join(' - ')}.pdf`.replace(/[\\/:*?"<>|]/g, '_');
                                    openPdfPreview(
                                      `/devis-maag/${d.id}/pdf`,
                                      { title: `Devis ${d.objet || d.numero || ''}`, filename: fname }
                                    );
                                  }}
                                  className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                  title="Aperçu PDF"
                                  data-testid={`devis-preview-btn-${d.id}`}
                                >
                                  <Download className="w-4 h-4" />
                                </button>
                                {/* Signature canvas (client signe en interne) — masqué par flag */}
                                {ENABLE_CLIENT_SIGNATURE_FLOW && d.statut !== 'signe' && !projet.is_cloture && (
                                  <button
                                    onClick={() => {
                                      setSigningDevis(d);
                                      setShowSignatureModal(true);
                                    }}
                                    className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                                    title="Signer le devis (interne)"
                                  >
                                    <PenTool className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Generate signature link for client — masqué par flag */}
                                {ENABLE_CLIENT_SIGNATURE_FLOW && d.statut !== 'signe' && !projet.is_cloture && (
                                  <button
                                    onClick={() => openSignatureLinkModal(d)}
                                    className="p-2 text-slate-400 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                                    title="Générer lien signature client"
                                  >
                                    <Mail className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Mark as signed manually */}
                                {d.statut !== 'signe' && !projet.is_cloture && (
                                  <button
                                    onClick={() => {
                                      const nom = prompt('Nom du signataire :');
                                      if (nom && nom.trim()) {
                                        handleMarkAsSigned(d.id, nom.trim());
                                      }
                                    }}
                                    className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors"
                                    title="Marquer comme signé (signature physique)"
                                  >
                                    <CheckCircle className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Resync from Base MAAG — masqué par flag (UI simplification) */}
                                {ENABLE_BASE_MAAG_SYNC && d.type_code && d.statut !== 'signe' && !projet.is_cloture && (
                                  <button
                                    onClick={() => handleResyncDevis(d.id, d.objet)}
                                    disabled={resyncingDevisId === d.id}
                                    className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors disabled:opacity-50"
                                    title="Resynchroniser depuis la Base MAAG"
                                  >
                                    <RefreshCw className={`w-4 h-4 ${resyncingDevisId === d.id ? 'animate-spin' : ''}`} />
                                  </button>
                                )}
                                {/* Delete */}
                                {!projet.is_cloture && (
                                  <button
                                    onClick={() => handleDeleteDevis(d.id, d.objet, d.statut === 'signe')}
                                    className={`p-2 rounded-lg transition-colors ${d.statut === 'signe' ? 'text-red-500 hover:text-red-700 hover:bg-red-50' : 'text-slate-400 hover:text-red-600 hover:bg-red-50'}`}
                                    title={d.statut === 'signe' ? '⚠️ Supprimer ce devis SIGNÉ (action sensible)' : 'Supprimer ce devis'}
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Duplicate as option (brouillon / en_attente) - parallel version on same project */}
                                {(d.statut === 'brouillon' || d.statut === 'envoye' || d.statut === 'refuse') && !projet.is_cloture && (
                                  <button
                                    onClick={async () => {
                                      const suggested = (d.objet || '').toLowerCase().includes('option')
                                        ? `${d.objet} (copie)`
                                        : `${d.objet} - Option B`;
                                      const newObjet = window.prompt('Nom de la nouvelle version / option :', suggested);
                                      if (!newObjet || !newObjet.trim()) return;
                                      try {
                                        const res = await duplicateDevisMaag({
                                          projet_id: projetId,
                                          source_devis_id: d.id,
                                          objet: newObjet.trim(),
                                          version: d.version || '1'
                                        });
                                        toast.success('Devis dupliqué en option parallèle');
                                        navigate(`/devis/${res.data.id}`);
                                      } catch (err) {
                                        toast.error(err.response?.data?.detail || 'Erreur lors de la duplication');
                                      }
                                    }}
                                    data-testid={`duplicate-option-btn-${d.id}`}
                                    className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                    title="Dupliquer comme option parallèle (même projet)"
                                  >
                                    <Copy className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Duplicate for V2 - only for signed devis */}
                                {(d.statut === 'signe' || d.statut === 'en_attente_signature') && !projet.is_cloture && (
                                  <button
                                    onClick={async () => {
                                      if (window.confirm(`Créer une nouvelle version (V${parseInt(d.version || '1') + 1}) de ce devis ${d.statut === 'en_attente_signature' ? 'en attente' : 'signé'} ?`)) {
                                        try {
                                          const res = await duplicateDevisForV2(d.id);
                                          toast.success(res.data.message);
                                          navigate(`/devis/${res.data.new_devis_id}`);
                                        } catch (e) {
                                          toast.error(e.response?.data?.detail || 'Erreur lors de la duplication');
                                        }
                                      }
                                    }}
                                    className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                    title="Dupliquer pour créer V2"
                                  >
                                    <Copy className="w-4 h-4" />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  
                  {/* Add devis type card — masqué (le bouton "Nouveau devis" en haut suffit) */}
                  {ENABLE_BASE_MAAG_SYNC && availableDevisTypes.length > 0 && !projet.is_cloture && (
                    <div className="mt-4 p-4 bg-slate-50 border border-slate-200 rounded-lg">
                      <div className="flex items-center justify-between">
                        <p className="text-sm text-slate-600">
                          {availableDevisTypes.length} modèle(s) disponible(s)
                        </p>
                        <button
                          onClick={() => { setCreateMode('modele'); setShowNewDevisModal(true); }}
                          className="inline-flex items-center px-3 py-1.5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700"
                        >
                          <Plus className="w-4 h-4 mr-1" />
                          Ajouter
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
              
              {/* Signature info */}
              {devisMaag.some(d => d.statut === 'signe') && (
                <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-600 mr-3 mt-0.5" />
                    <div>
                      <p className="text-sm font-medium text-green-800">Devis signé</p>
                      {devisMaag.filter(d => d.statut === 'signe').map(d => (
                        <p key={d.id} className="text-sm text-green-600">
                          Signé par {d.signataire_nom} le {d.date_signature}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            </div>
          )}

          {/* Signature Modal */}
          {showSignatureModal && signingDevis && (
            <SignaturePad
              devisInfo={{
                objet: signingDevis.objet,
                total_ttc: signingDevis.total_ttc
              }}
              onSign={async (signatureData) => {
                try {
                  await signerDevis(signingDevis.id, signatureData);
                  toast.success('Devis signé avec succès !');
                  setShowSignatureModal(false);
                  setSigningDevis(null);
                  loadData();
                } catch (error) {
                  toast.error('Erreur lors de la signature');
                  console.error(error);
                }
              }}
              onCancel={() => {
                setShowSignatureModal(false);
                setSigningDevis(null);
              }}
            />
          )}

          {/* Signature Link Modal (with email input) */}
          {showSignatureLinkModal && signatureLinkDevis && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
              <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
                <div className="p-6 border-b border-slate-200">
                  <h2 className="text-lg font-bold text-slate-900">Générer un lien de signature</h2>
                  <p className="text-sm text-slate-500 mt-1">Devis : {signatureLinkDevis.objet}</p>
                </div>
                
                <div className="p-6 space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">
                      Email du client (optionnel)
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                      <input
                        type="email"
                        value={signatureLinkEmail}
                        onChange={(e) => setSignatureLinkEmail(e.target.value)}
                        placeholder="client@exemple.com"
                        className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      />
                    </div>
                    <p className="text-xs text-slate-500 mt-1">
                      Si renseigné, le PDF signé sera envoyé automatiquement à cette adresse après signature.
                    </p>
                  </div>
                  
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-3">
                    <p className="text-sm text-purple-700">
                      <span className="font-medium">📋 Le texte pour email sera copié</span> dans votre presse-papier. 
                      Vous pourrez le coller directement dans votre email au client.
                    </p>
                  </div>
                </div>
                
                <div className="p-6 border-t border-slate-200 flex gap-3">
                  <button
                    onClick={() => {
                      setShowSignatureLinkModal(false);
                      setSignatureLinkDevis(null);
                      setSignatureLinkEmail('');
                    }}
                    className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                  >
                    Annuler
                  </button>
                  <button
                    onClick={handleGenerateSignatureLink}
                    disabled={generatingSignatureLink}
                    className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 flex items-center justify-center gap-2"
                  >
                    {generatingSignatureLink ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <Mail className="w-4 h-4" />
                    )}
                    Générer le lien
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Tab: Descriptif Artisans */}
          {activeTab === 'descriptif_artisans' && (
            <div data-testid="descriptif-artisans-tab">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="text-lg font-semibold text-slate-900">Descriptif Artisans</h3>
                  <p className="text-sm text-slate-500">Demande de devis destinée aux artisans (sans prix)</p>
                </div>
              </div>

              {!descriptifArtisans ? (
                // État initial : sélection du devis source
                <div className="bg-slate-50 border border-dashed border-slate-200 rounded-xl p-8">
                  <div className="max-w-md mx-auto text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Hammer className="w-8 h-8 text-emerald-600" />
                    </div>
                    <h4 className="text-lg font-semibold text-slate-900 mb-2">Créer un descriptif artisans</h4>
                    <p className="text-sm text-slate-500 mb-6">
                      Sélectionnez le devis client à partir duquel générer le descriptif.
                      Les prix et fournisseurs directs seront exclus automatiquement.
                    </p>

                    {devisMaag.length === 0 ? (
                      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-left">
                        <p className="text-amber-800 text-sm">
                          <AlertCircle className="w-4 h-4 inline mr-2" />
                          Aucun devis MAAG disponible. Créez d'abord un devis client.
                        </p>
                      </div>
                    ) : (
                      <div className="space-y-4">
                        <div className="relative">
                          <button
                            type="button"
                            onClick={() => setDevisSourceMenuOpen((v) => !v)}
                            data-testid="devis-source-button"
                            className="w-full px-4 py-3 border border-slate-300 rounded-lg text-sm bg-white text-left flex items-center justify-between hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                          >
                            <span className={selectedDevisSource ? 'text-slate-900' : 'text-slate-500'}>
                              {(() => {
                                if (!selectedDevisSource) return 'Sélectionner un devis source...';
                                const d = devisMaag.find((x) => x.id === selectedDevisSource);
                                return d ? `${d.objet} (Version ${d.version}) - ${formatMoney(d.total_ht)}` : 'Devis sélectionné';
                              })()}
                            </span>
                            <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${devisSourceMenuOpen ? 'rotate-180' : ''}`} />
                          </button>
                          {devisSourceMenuOpen && (
                            <>
                              <div className="fixed inset-0 z-40" onClick={() => setDevisSourceMenuOpen(false)} />
                              <div
                                data-testid="devis-source-menu"
                                className="absolute left-0 right-0 mt-1 max-h-72 overflow-y-auto bg-white border border-slate-200 rounded-lg shadow-lg z-50"
                              >
                                {devisMaag.length === 0 ? (
                                  <div className="px-4 py-3 text-sm text-slate-500 italic">Aucun devis MAAG sur ce projet</div>
                                ) : (
                                  devisMaag.map((devis) => (
                                    <button
                                      key={devis.id}
                                      type="button"
                                      data-testid={`devis-source-option-${devis.id}`}
                                      onClick={() => {
                                        setSelectedDevisSource(devis.id);
                                        setDevisSourceMenuOpen(false);
                                      }}
                                      className={`w-full text-left px-4 py-2.5 text-sm hover:bg-emerald-50 ${selectedDevisSource === devis.id ? 'bg-emerald-50 font-semibold' : ''}`}
                                    >
                                      <div className="font-medium text-slate-900">{devis.objet}</div>
                                      <div className="text-xs text-slate-500 mt-0.5">Version {devis.version} · {formatMoney(devis.total_ht)} HT</div>
                                    </button>
                                  ))
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        <button
                          onClick={handleCreateDescriptif}
                          disabled={!selectedDevisSource || creatingDescriptif}
                          className="w-full px-4 py-3 bg-emerald-600 text-white rounded-lg font-medium hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                          data-testid="create-descriptif-btn"
                        >
                          {creatingDescriptif ? (
                            <Loader2 className="w-4 h-4 animate-spin" />
                          ) : (
                            <Plus className="w-4 h-4" />
                          )}
                          Générer le descriptif
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                // Descriptif existe : affichage et édition
                <div className="space-y-6">
                  {/* Barre d'actions */}
                  <div className="flex flex-wrap items-center justify-between gap-4 bg-emerald-50 border border-emerald-200 rounded-lg p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                        <FileText className="w-5 h-5 text-white" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-emerald-900">
                          Basé sur : {descriptifArtisans.devis_source_objet} (V{descriptifArtisans.devis_source_version})
                        </p>
                        <p className="text-xs text-emerald-700">
                          {descriptifArtisans.lots?.reduce((sum, lot) => sum + lot.lignes.length, 0) || 0} lignes • 
                          Modifié le {new Date(descriptifArtisans.updated_at).toLocaleDateString('fr-FR')}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => {
                          setNewDevisSource(descriptifArtisans.devis_source_id || '');
                          setShowChangeSourceModal(true);
                        }}
                        className="px-3 py-2 text-sm border border-blue-300 text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 flex items-center gap-1"
                        title="Changer le devis source et resynchroniser"
                        data-testid="change-devis-source-btn"
                      >
                        <RefreshCw className="w-4 h-4" />
                        Changer devis source
                      </button>
                      <button
                        onClick={handleResyncDescriptif}
                        disabled={resyncingDescriptif}
                        className="px-3 py-2 text-sm border border-amber-300 text-amber-700 bg-amber-50 rounded-lg hover:bg-amber-100 flex items-center gap-1"
                        title="Resynchroniser depuis le devis source actuel"
                      >
                        <RefreshCw className={`w-4 h-4 ${resyncingDescriptif ? 'animate-spin' : ''}`} />
                        Resync
                      </button>
                      <button
                        onClick={handleDeleteDescriptif}
                        className="px-3 py-2 text-sm border border-red-300 text-red-700 bg-red-50 rounded-lg hover:bg-red-100 flex items-center gap-1"
                        title="Supprimer le descriptif pour repartir de zéro"
                        data-testid="delete-descriptif-btn"
                      >
                        <Trash2 className="w-4 h-4" />
                        Supprimer
                      </button>
                      <button
                        onClick={() => {
                          setSelectedLotsForExport([]);
                          setShowExportModal(true);
                        }}
                        className="px-4 py-2 text-sm bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 flex items-center gap-2"
                        data-testid="export-descriptif-btn"
                      >
                        <Download className="w-4 h-4" />
                        Exporter
                      </button>
                      <button
                        onClick={handleOpenEmailModal}
                        className="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
                        data-testid="send-email-btn"
                      >
                        <Mail className="w-4 h-4" />
                        Envoyer par email
                      </button>
                    </div>
                  </div>

                  {/* Historique des envois */}
                  {emailHistory.length > 0 && (
                    <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
                      <button
                        onClick={() => setShowEmailHistory(!showEmailHistory)}
                        className="flex items-center justify-between w-full text-left"
                      >
                        <span className="font-medium text-slate-700 flex items-center gap-2">
                          <Mail className="w-4 h-4" />
                          Historique des envois ({emailHistory.length})
                        </span>
                        <span className="text-slate-400">{showEmailHistory ? '▲' : '▼'}</span>
                      </button>
                      {showEmailHistory && (
                        <div className="mt-3 space-y-2">
                          {emailHistory.map(email => (
                            <div key={email.id} className="bg-white border border-slate-100 rounded p-3 text-sm">
                              <div className="flex items-center justify-between">
                                <span className="font-medium text-slate-800">{email.prenom_artisan}</span>
                                <span className={`px-2 py-0.5 rounded text-xs ${email.statut === 'envoye' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                  {email.statut === 'envoye' ? 'Envoyé' : 'Erreur'}
                                </span>
                              </div>
                              <p className="text-slate-500">{email.email_artisan}</p>
                              <p className="text-xs text-slate-400 mt-1">
                                {new Date(email.date_envoi).toLocaleDateString('fr-FR')} à {new Date(email.date_envoi).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                                {' • '}
                                {email.lots_envoyes.includes('all') ? 'Tous lots' : `Lots ${email.lots_envoyes.join(', ')}`}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Zone remarques */}
                  <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="font-medium text-amber-900 flex items-center gap-2">
                        <AlertCircle className="w-4 h-4" />
                        Remarques / Contraintes
                      </h4>
                      <button
                        onClick={handleUpdateDescriptifRemarques}
                        className="text-xs px-3 py-1 bg-amber-600 text-white rounded hover:bg-amber-700"
                      >
                        Enregistrer
                      </button>
                    </div>
                    <textarea
                      value={descriptifRemarques}
                      onChange={(e) => setDescriptifRemarques(e.target.value)}
                      placeholder="Contraintes chantier, horaires d'accès, ERP, centre commercial, etc."
                      className="w-full px-3 py-2 text-sm border border-amber-200 rounded-lg bg-white focus:ring-2 focus:ring-amber-500 resize-y"
                      rows={4}
                      style={{ minHeight: '110px' }}
                      spellCheck="true"
                      lang="fr"
                    />
                  </div>

                  {/* Liste des lots */}
                  <div className="space-y-4">
                    {descriptifArtisans.lots?.map(lot => (
                      <div key={lot.lot_id} className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                        <div className="bg-emerald-700 text-white px-4 py-3 flex items-center justify-between">
                          <span className="font-medium">LOT {lot.lot_id} – {lot.lot_nom}</span>
                          <span className="text-sm text-emerald-200">{lot.lignes.length} lignes</span>
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full">
                            <thead className="bg-slate-50">
                              <tr>
                                <th className="px-4 py-2 text-left text-xs font-medium text-slate-500 uppercase w-1/2">Description</th>
                                <th className="px-4 py-2 text-left text-xs font-medium text-slate-500 uppercase">Sous-lot</th>
                                <th className="px-4 py-2 text-center text-xs font-medium text-slate-500 uppercase w-20">Unité</th>
                                <th className="px-4 py-2 text-right text-xs font-medium text-slate-500 uppercase w-24">Quantité</th>
                                <th className="px-4 py-2 text-center text-xs font-medium text-slate-500 uppercase w-24">Actions</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                              {(() => {
                                // Sort lignes by display_order to preserve devis order
                                const sorted = [...lot.lignes].sort((a, b) => {
                                  const oa = a.display_order ?? 9999;
                                  const ob = b.display_order ?? 9999;
                                  if (oa !== ob) return oa - ob;
                                  return (a.sous_lot_nom || '').localeCompare(b.sous_lot_nom || '');
                                });
                                let currentSousLot = null;
                                let currentSousSousLot = null;
                                let currentGroupe = null;
                                const rows = [];
                                for (const ligne of sorted) {
                                  const sl = ligne.sous_lot_nom || null;
                                  const ssl = ligne.sous_sous_lot_nom || null;
                                  const grp = ligne.groupe_nom || null;
                                  // Emit hierarchy headers when levels change
                                  if (sl && sl !== currentSousLot) {
                                    currentSousLot = sl; currentSousSousLot = null; currentGroupe = null;
                                    rows.push(
                                      <tr key={`sl-${ligne.id}`} className="bg-emerald-700">
                                        <td colSpan={5} className="px-4 py-1.5 text-xs font-bold text-white uppercase tracking-wide">■ {sl}</td>
                                      </tr>
                                    );
                                  } else if (!sl) { currentSousLot = null; currentSousSousLot = null; currentGroupe = null; }
                                  if (ssl && ssl !== currentSousSousLot) {
                                    currentSousSousLot = ssl; currentGroupe = null;
                                    rows.push(
                                      <tr key={`ssl-${ligne.id}`} className="bg-blue-100">
                                        <td colSpan={5} className="px-6 py-1 text-xs font-semibold text-blue-800">▸ {ssl}</td>
                                      </tr>
                                    );
                                  } else if (!ssl) { currentSousSousLot = null; currentGroupe = null; }
                                  if (grp && grp !== currentGroupe) {
                                    currentGroupe = grp;
                                    rows.push(
                                      <tr key={`grp-${ligne.id}`} className="bg-green-50">
                                        <td colSpan={5} className="px-8 py-1 text-xs italic font-medium text-green-800">· {grp}</td>
                                      </tr>
                                    );
                                  } else if (!grp) { currentGroupe = null; }
                                  // Titre libre = section header without qty
                                  if (ligne.is_titre_libre) {
                                    rows.push(
                                      <tr key={ligne.id} className="bg-amber-50">
                                        <td colSpan={5} className="px-4 py-2 text-sm font-bold text-amber-900">{ligne.description}</td>
                                      </tr>
                                    );
                                    continue;
                                  }
                                  // Regular ligne
                                  rows.push(
                                <tr key={ligne.id} className="hover:bg-slate-50">
                                  {editingDescriptifLigne === ligne.id ? (
                                    // Mode édition
                                    <>
                                      <td className="px-4 py-2">
                                        <textarea
                                          defaultValue={ligne.description}
                                          className="w-full px-2 py-2 text-sm border border-slate-300 rounded mb-1 resize-y font-normal leading-snug"
                                          id={`edit-desc-${ligne.id}`}
                                          placeholder="Description"
                                          rows={4}
                                          style={{ minHeight: '110px' }}
                                          spellCheck="true"
                                          lang="fr"
                                          autoFocus
                                        />
                                        <textarea
                                          defaultValue={ligne.localisation || ''}
                                          className="w-full px-2 py-1.5 text-xs border border-blue-200 rounded bg-blue-50/30 mb-1 resize-y"
                                          id={`edit-loc-${ligne.id}`}
                                          placeholder="Localisation (ex: Bureau, Zone RJ45 …)"
                                          rows={2}
                                          style={{ minHeight: '48px' }}
                                          spellCheck="true"
                                          lang="fr"
                                        />
                                        <textarea
                                          defaultValue={ligne.commentaire || ''}
                                          className="w-full px-2 py-1.5 text-xs border border-slate-200 rounded italic resize-y"
                                          id={`edit-comm-${ligne.id}`}
                                          placeholder="Commentaire (optionnel)"
                                          rows={2}
                                          style={{ minHeight: '48px' }}
                                          spellCheck="true"
                                          lang="fr"
                                        />
                                      </td>
                                      <td className="px-4 py-2">
                                        <input
                                          type="text"
                                          defaultValue={ligne.sous_lot_nom || ''}
                                          className="w-full px-2 py-1 text-sm border border-slate-300 rounded"
                                          id={`edit-souslot-${ligne.id}`}
                                        />
                                      </td>
                                      <td className="px-4 py-2">
                                        <input
                                          type="text"
                                          defaultValue={ligne.unite}
                                          className="w-full px-2 py-1 text-sm border border-slate-300 rounded text-center"
                                          id={`edit-unite-${ligne.id}`}
                                        />
                                      </td>
                                      <td className="px-4 py-2">
                                        <input
                                          type="number"
                                          step="0.01"
                                          defaultValue={ligne.quantite}
                                          className="w-full px-2 py-1 text-sm border border-slate-300 rounded text-right"
                                          id={`edit-qte-${ligne.id}`}
                                        />
                                      </td>
                                      <td className="px-4 py-2">
                                        <div className="flex items-center justify-center gap-1">
                                          <button
                                            onClick={() => {
                                              const updates = {
                                                description: document.getElementById(`edit-desc-${ligne.id}`).value,
                                                sous_lot_nom: document.getElementById(`edit-souslot-${ligne.id}`).value,
                                                unite: document.getElementById(`edit-unite-${ligne.id}`).value,
                                                quantite: parseFloat(document.getElementById(`edit-qte-${ligne.id}`).value) || 0,
                                                localisation: document.getElementById(`edit-loc-${ligne.id}`).value,
                                                commentaire: document.getElementById(`edit-comm-${ligne.id}`).value
                                              };
                                              handleUpdateDescriptifLigne(ligne.id, updates);
                                            }}
                                            className="p-1 text-green-600 hover:bg-green-50 rounded"
                                          >
                                            <Check className="w-4 h-4" />
                                          </button>
                                          <button
                                            onClick={() => setEditingDescriptifLigne(null)}
                                            className="p-1 text-slate-400 hover:bg-slate-100 rounded"
                                          >
                                            <X className="w-4 h-4" />
                                          </button>
                                        </div>
                                      </td>
                                    </>
                                  ) : (
                                    // Mode affichage
                                    <>
                                      <td className="px-4 py-2 text-sm text-slate-700">
                                        {ligne.localisation && (
                                          <span className="inline-block mr-2 px-1.5 py-0.5 text-[10px] font-semibold uppercase bg-blue-100 text-blue-700 rounded" title="Localisation">
                                            📍 {ligne.localisation}
                                          </span>
                                        )}
                                        {ligne.description}
                                        {ligne.commentaire && (
                                          <div className="text-xs italic text-slate-500 mt-0.5">{ligne.commentaire}</div>
                                        )}
                                      </td>
                                      <td className="px-4 py-2 text-sm text-slate-500">{ligne.sous_lot_nom || '-'}</td>
                                      <td className="px-4 py-2 text-sm text-slate-500 text-center">{ligne.unite}</td>
                                      <td className="px-4 py-2 text-sm text-slate-700 text-right">{ligne.quantite.toLocaleString('fr-FR')}</td>
                                      <td className="px-4 py-2">
                                        <div className="flex items-center justify-center gap-1">
                                          <button
                                            onClick={() => setEditingDescriptifLigne(ligne.id)}
                                            className="p-1 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
                                            title="Modifier"
                                          >
                                            <Edit2 className="w-4 h-4" />
                                          </button>
                                          <button
                                            onClick={() => handleDeleteDescriptifLigne(ligne.id)}
                                            className="p-1 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded"
                                            title="Supprimer"
                                          >
                                            <Trash2 className="w-4 h-4" />
                                          </button>
                                        </div>
                                      </td>
                                    </>
                                  )}
                                </tr>
                                  );
                                }
                                return rows;
                              })()}
                            </tbody>
                          </table>
                        </div>
                        {/* Bouton ajouter ligne */}
                        <div className="px-4 py-2 border-t border-slate-100 bg-slate-50">
                          <button
                            onClick={() => {
                              setNewLigne({
                                lot_id: lot.lot_id,
                                lot_nom: lot.lot_nom,
                                sous_lot_nom: '',
                                sous_sous_lot_nom: '',
                                groupe_nom: '',
                                is_titre_libre: false,
                                description: '',
                                unite: 'U',
                                quantite: 0,
                                localisation: '',
                                commentaire: ''
                              });
                              setShowAddLigneModal(true);
                            }}
                            className="text-sm text-emerald-600 hover:text-emerald-700 flex items-center gap-1"
                          >
                            <Plus className="w-4 h-4" />
                            Ajouter une ligne
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Modal Export */}
              {showExportModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-xl w-full max-w-lg mx-4 shadow-2xl">
                    <div className="p-6 border-b border-slate-200">
                      <h3 className="text-lg font-semibold text-slate-900">Exporter le descriptif</h3>
                      <p className="text-sm text-slate-500">Choisissez les lots à exporter et le format</p>
                    </div>
                    <div className="p-6 space-y-4 max-h-96 overflow-y-auto">
                      <div className="space-y-2">
                        <label className="flex items-center gap-2 p-3 border border-slate-200 rounded-lg hover:bg-slate-50 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedLotsForExport.length === 0}
                            onChange={() => setSelectedLotsForExport([])}
                            className="w-4 h-4 text-emerald-600 border-slate-300 rounded focus:ring-emerald-500"
                          />
                          <span className="font-medium">Tous les lots</span>
                        </label>
                        {descriptifArtisans?.lots?.map(lot => (
                          <label key={lot.lot_id} className="flex items-center gap-2 p-3 border border-slate-200 rounded-lg hover:bg-slate-50 cursor-pointer">
                            <input
                              type="checkbox"
                              checked={selectedLotsForExport.includes(lot.lot_id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedLotsForExport([...selectedLotsForExport, lot.lot_id]);
                                } else {
                                  setSelectedLotsForExport(selectedLotsForExport.filter(id => id !== lot.lot_id));
                                }
                              }}
                              className="w-4 h-4 text-emerald-600 border-slate-300 rounded focus:ring-emerald-500"
                            />
                            <span>Lot {lot.lot_id} – {lot.lot_nom}</span>
                            <span className="text-xs text-slate-400 ml-auto">{lot.lignes.length} lignes</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    <div className="p-6 border-t border-slate-200 flex gap-3">
                      <button
                        onClick={() => setShowExportModal(false)}
                        className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={() => handleExportDescriptif('excel')}
                        disabled={exportingDescriptif}
                        className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2"
                        data-testid="export-excel-btn"
                      >
                        {exportingDescriptif ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileSpreadsheet className="w-4 h-4" />}
                        Excel
                      </button>
                      <button
                        onClick={() => handleExportDescriptif('pdf')}
                        disabled={exportingDescriptif}
                        className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
                        data-testid="export-pdf-btn"
                      >
                        {exportingDescriptif ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
                        PDF
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Modal Envoi Email */}
              {showEmailModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-y-auto">
                  <div className="bg-white rounded-xl w-full max-w-2xl mx-4 my-8 shadow-2xl">
                    <div className="p-6 border-b border-slate-200 bg-blue-50">
                      <h3 className="text-lg font-semibold text-blue-900 flex items-center gap-2">
                        <Mail className="w-5 h-5" />
                        Envoyer la demande de devis
                      </h3>
                      <p className="text-sm text-blue-700">Email envoyé depuis devis@maag-moe.com • Copie à m.gond@outlook.fr</p>
                    </div>
                    <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto">
                      {/* Destinataire avec auto-complétion */}
                      <div className="grid grid-cols-2 gap-4">
                        <div className="relative">
                          <label className="block text-sm font-medium text-slate-700 mb-1">Prénom de l'artisan *</label>
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={emailForm.prenom_artisan}
                              onChange={(e) => {
                                setEmailForm({...emailForm, prenom_artisan: e.target.value});
                                handleContactSearch(e.target.value);
                              }}
                              onFocus={() => {
                                if (emailForm.prenom_artisan.length >= 2) {
                                  handleContactSearch(emailForm.prenom_artisan);
                                }
                              }}
                              onBlur={() => {
                                setTimeout(() => setShowContactSuggestions(false), 200);
                                handleUpdateEmailPreview();
                              }}
                              className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                              placeholder="Tapez pour rechercher..."
                              data-testid="email-prenom-input"
                            />
                            <button
                              type="button"
                              onClick={() => {
                                setContactPickerSearch('');
                                setShowContactPickerModal(true);
                              }}
                              className="px-3 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition flex items-center gap-1"
                              title="Choisir un contact"
                              data-testid="open-contact-picker-btn"
                            >
                              <BookUser className="w-4 h-4" />
                            </button>
                          </div>
                          {/* Suggestions dropdown */}
                          {showContactSuggestions && filteredContacts.length > 0 && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-slate-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                              {filteredContacts.map((contact) => (
                                <button
                                  key={contact.id}
                                  type="button"
                                  onClick={() => handleSelectContact(contact)}
                                  className="w-full px-3 py-2 text-left hover:bg-blue-50 flex items-center gap-2 text-sm border-b border-slate-100 last:border-0"
                                  data-testid={`contact-suggestion-${contact.id}`}
                                >
                                  <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold text-xs">
                                    {(contact.prenom?.[0] || contact.nom?.[0] || '?').toUpperCase()}
                                  </div>
                                  <div className="flex-1">
                                    <div className="font-medium text-slate-800">
                                      {contact.prenom} {contact.nom}
                                    </div>
                                    <div className="text-xs text-slate-500">
                                      {contact.email} {contact.entreprise && `• ${contact.entreprise}`}
                                    </div>
                                  </div>
                                </button>
                              ))}
                            </div>
                          )}
                          {contactsList.length > 0 && !showContactSuggestions && emailForm.prenom_artisan.length === 0 && (
                            <p className="text-xs text-slate-400 mt-1">{contactsList.length} contacts disponibles</p>
                          )}
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Email de l'artisan *</label>
                          <input
                            type="email"
                            value={emailForm.email_artisan}
                            onChange={(e) => setEmailForm({...emailForm, email_artisan: e.target.value})}
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                            placeholder="artisan@email.com"
                            data-testid="email-artisan-input"
                          />
                        </div>
                      </div>

                      {/* Toggle Tutoiement / Vouvoiement */}
                      <div className="flex items-center gap-4 bg-slate-50 p-3 rounded-lg">
                        <span className="text-sm font-medium text-slate-700">Ton du message :</span>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => {
                              setEmailForm({...emailForm, mode_tutoiement: true});
                              setTimeout(handleUpdateEmailPreview, 100);
                            }}
                            className={`px-3 py-1.5 text-sm rounded-lg transition ${emailForm.mode_tutoiement ? 'bg-blue-600 text-white' : 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-100'}`}
                          >
                            Tutoiement
                          </button>
                          <button
                            onClick={() => {
                              setEmailForm({...emailForm, mode_tutoiement: false});
                              setTimeout(handleUpdateEmailPreview, 100);
                            }}
                            className={`px-3 py-1.5 text-sm rounded-lg transition ${!emailForm.mode_tutoiement ? 'bg-blue-600 text-white' : 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-100'}`}
                          >
                            Vouvoiement
                          </button>
                        </div>
                      </div>

                      {/* Sélection des lots */}
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">Lots à inclure</label>
                        <div className="flex flex-wrap gap-2">
                          <label className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded-lg hover:bg-slate-50 cursor-pointer text-sm">
                            <input
                              type="checkbox"
                              checked={emailForm.lots === 'all'}
                              onChange={() => setEmailForm({...emailForm, lots: 'all'})}
                              className="w-4 h-4 text-blue-600 border-slate-300 rounded"
                            />
                            Tous les lots
                          </label>
                          {descriptifArtisans?.lots?.map(lot => (
                            <label key={lot.lot_id} className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 rounded-lg hover:bg-slate-50 cursor-pointer text-sm">
                              <input
                                type="checkbox"
                                checked={emailForm.lots !== 'all' && emailForm.lots.split(',').includes(lot.lot_id)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    const current = emailForm.lots === 'all' ? [] : emailForm.lots.split(',').filter(Boolean);
                                    setEmailForm({...emailForm, lots: [...current, lot.lot_id].join(',')});
                                  } else {
                                    const current = emailForm.lots.split(',').filter(id => id !== lot.lot_id);
                                    setEmailForm({...emailForm, lots: current.length > 0 ? current.join(',') : 'all'});
                                  }
                                }}
                                className="w-4 h-4 text-blue-600 border-slate-300 rounded"
                              />
                              {lot.lot_nom}
                            </label>
                          ))}
                        </div>
                      </div>

                      {/* Objet */}
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Objet du mail</label>
                        <input
                          type="text"
                          value={emailForm.objet || emailPreview?.objet || ''}
                          onChange={(e) => setEmailForm({...emailForm, objet: e.target.value})}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                          placeholder="Demande de devis – Projet – Lots"
                        />
                      </div>

                      {/* Message éditable (template pré-rempli) */}
                      {emailPreview && emailForm.prenom_artisan && (
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">
                            Message <span className="text-xs text-slate-400 ml-2">(modifiable)</span>
                          </label>
                          <div 
                            className="w-full px-4 py-3 border border-slate-300 rounded-lg text-sm focus-within:ring-2 focus-within:ring-blue-500 bg-white min-h-[200px] prose prose-sm max-w-none overflow-y-auto"
                            contentEditable
                            suppressContentEditableWarning
                            onBlur={(e) => setEmailForm({...emailForm, message_html: e.currentTarget.innerHTML})}
                            dangerouslySetInnerHTML={{ __html: emailForm.message_html || emailPreview.html_body }}
                          />
                        </div>
                      )}

                      {/* Pièces jointes (info uniquement) */}
                      <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
                        <p className="text-sm font-medium text-slate-700 mb-2">📎 Pièces jointes automatiques :</p>
                        <ul className="text-sm text-slate-600 space-y-1">
                          <li>✓ PDF de la demande de devis (avec colonnes prix à remplir)</li>
                          <li>✓ Excel de la demande de devis (avec formules de calcul)</li>
                        </ul>
                        
                        {/* Zone pour ajouter des fichiers supplémentaires */}
                        <div className="mt-3 pt-3 border-t border-slate-200">
                          <input
                            ref={emailAttachmentRef}
                            type="file"
                            multiple
                            accept="image/*,.pdf,.doc,.docx,.dwg"
                            onChange={handleAddEmailAttachment}
                            className="hidden"
                          />
                          <button
                            onClick={() => emailAttachmentRef.current?.click()}
                            className="text-sm text-blue-600 hover:text-blue-700 flex items-center gap-1"
                          >
                            <Upload className="w-3 h-3" />
                            + Ajouter des fichiers (photos, plans...)
                          </button>
                          {emailAttachments.length > 0 && (
                            <div className="mt-2 space-y-1">
                              {emailAttachments.map((file, index) => (
                                <div key={index} className="flex items-center justify-between bg-white px-3 py-2 rounded text-sm">
                                  <span className="text-slate-700 truncate">{file.name}</span>
                                  <div className="flex items-center gap-2">
                                    <span className="text-xs text-slate-400">{(file.size / 1024).toFixed(0)} KB</span>
                                    <button
                                      onClick={() => handleRemoveEmailAttachment(index)}
                                      className="text-red-500 hover:text-red-700"
                                    >
                                      <X className="w-4 h-4" />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Info copie */}
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-sm">
                        <p className="text-blue-800">
                          ℹ️ Vous recevrez une copie de cet email sur <strong>m.gond@outlook.fr</strong>
                          <br/>
                          Les réponses de l'artisan arriveront également sur cette adresse.
                        </p>
                      </div>
                    </div>
                    <div className="p-6 border-t border-slate-200 flex gap-3">
                      <button
                        onClick={() => setShowEmailModal(false)}
                        className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={handleSendEmail}
                        disabled={sendingEmail || !emailForm.email_artisan || !emailForm.prenom_artisan}
                        className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        data-testid="confirm-send-email-btn"
                      >
                        {sendingEmail ? (
                          <Loader2 className="w-4 h-4 animate-spin" />
                        ) : (
                          <Mail className="w-4 h-4" />
                        )}
                        Envoyer l'email
                      </button>
                    </div>
                    
                    {/* Prompt sauvegarder le contact */}
                    {showSaveContactPrompt && (
                      <div className="p-6 border-t border-slate-200 bg-green-50">
                        <div className="flex items-start gap-3">
                          <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600">
                            ✓
                          </div>
                          <div className="flex-1">
                            <h4 className="font-semibold text-green-800">Email envoyé avec succès !</h4>
                            <p className="text-sm text-green-700 mt-1">
                              Voulez-vous enregistrer <strong>{emailForm.prenom_artisan}</strong> ({emailForm.email_artisan}) dans vos contacts ?
                            </p>
                            <div className="flex gap-2 mt-3">
                              <button
                                onClick={handleSaveNewContact}
                                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm"
                                data-testid="save-contact-after-send"
                              >
                                Oui, enregistrer
                              </button>
                              <button
                                onClick={() => {
                                  setShowSaveContactPrompt(false);
                                  setShowEmailModal(false);
                                }}
                                className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-100 text-sm"
                              >
                                Non, fermer
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Modal Sélection Contact */}
              {showContactPickerModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
                  <div className="bg-white rounded-xl w-full max-w-md mx-4 shadow-2xl max-h-[80vh] flex flex-col">
                    <div className="p-4 border-b border-slate-200 bg-orange-50">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-orange-900 flex items-center gap-2">
                          <BookUser className="w-5 h-5" />
                          Choisir un contact
                        </h3>
                        <button
                          onClick={() => setShowContactPickerModal(false)}
                          className="text-slate-400 hover:text-slate-600"
                        >
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      <div className="mt-3 relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                        <input
                          type="text"
                          value={contactPickerSearch}
                          onChange={(e) => setContactPickerSearch(e.target.value)}
                          placeholder="Rechercher..."
                          className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-500"
                          autoFocus
                        />
                      </div>
                    </div>
                    <div className="flex-1 overflow-y-auto p-2">
                      {contactsList.length === 0 ? (
                        <div className="text-center py-8 text-slate-500">
                          <BookUser className="w-12 h-12 mx-auto text-slate-300 mb-2" />
                          <p>Aucun contact enregistré</p>
                          <p className="text-sm">Allez dans l'onglet Contacts pour en créer</p>
                        </div>
                      ) : (
                        <>
                          {contactsList
                            .filter(c => {
                              if (!contactPickerSearch) return true;
                              const search = contactPickerSearch.toLowerCase();
                              return (
                                c.nom?.toLowerCase().includes(search) ||
                                c.prenom?.toLowerCase().includes(search) ||
                                c.entreprise?.toLowerCase().includes(search) ||
                                c.email?.toLowerCase().includes(search) ||
                                c.metier?.toLowerCase().includes(search)
                              );
                            })
                            .map((contact) => (
                              <button
                                key={contact.id}
                                type="button"
                                onClick={() => {
                                  handleSelectContact(contact);
                                  setShowContactPickerModal(false);
                                }}
                                className="w-full p-3 text-left hover:bg-orange-50 rounded-lg flex items-center gap-3 transition mb-1"
                                data-testid={`contact-picker-${contact.id}`}
                              >
                                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold">
                                  {(contact.prenom?.[0] || contact.nom?.[0] || '?').toUpperCase()}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <div className="font-medium text-slate-800 truncate">
                                    {contact.prenom} {contact.nom}
                                  </div>
                                  <div className="text-sm text-slate-500 truncate">
                                    {contact.email}
                                  </div>
                                  <div className="flex items-center gap-2 mt-0.5">
                                    {contact.entreprise && (
                                      <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded">
                                        {contact.entreprise}
                                      </span>
                                    )}
                                    {contact.metier && (
                                      <span className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded">
                                        {contact.metier}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </button>
                            ))}
                          {contactsList.filter(c => {
                            if (!contactPickerSearch) return true;
                            const search = contactPickerSearch.toLowerCase();
                            return (
                              c.nom?.toLowerCase().includes(search) ||
                              c.prenom?.toLowerCase().includes(search) ||
                              c.entreprise?.toLowerCase().includes(search) ||
                              c.email?.toLowerCase().includes(search)
                            );
                          }).length === 0 && (
                            <div className="text-center py-8 text-slate-500">
                              <p>Aucun contact trouvé pour "{contactPickerSearch}"</p>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    <div className="p-3 border-t border-slate-200 bg-slate-50">
                      <p className="text-xs text-slate-500 text-center">
                        {contactsList.length} contact(s) • <a href="/contacts" className="text-orange-600 hover:underline">Gérer les contacts</a>
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Modal Changer devis source */}
              {showChangeSourceModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-xl w-full max-w-md mx-4 shadow-2xl" data-testid="change-devis-source-modal">
                    <div className="p-6 border-b border-slate-200">
                      <h3 className="text-lg font-semibold text-slate-900">Changer le devis source</h3>
                      <p className="text-sm text-slate-500 mt-1">
                        Sélectionnez le devis à partir duquel le descriptif sera régénéré.
                        <br />
                        <span className="text-red-600 font-medium">Attention : toutes les lignes actuelles seront écrasées.</span>
                      </p>
                    </div>
                    <div className="p-6 space-y-3">
                      {devisMaag.length === 0 ? (
                        <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg p-3">
                          Aucun devis MAAG disponible sur ce projet.
                        </p>
                      ) : (
                        devisMaag.map((devis) => (
                          <label
                            key={devis.id}
                            className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-slate-50 ${newDevisSource === devis.id ? 'border-emerald-500 bg-emerald-50' : 'border-slate-200'}`}
                            data-testid={`change-source-option-${devis.id}`}
                          >
                            <input
                              type="radio"
                              name="new-devis-source"
                              value={devis.id}
                              checked={newDevisSource === devis.id}
                              onChange={(e) => setNewDevisSource(e.target.value)}
                              className="text-emerald-600 focus:ring-emerald-500"
                            />
                            <div className="flex-1">
                              <p className="text-sm font-medium text-slate-900">
                                {devis.objet}
                                {descriptifArtisans?.devis_source_id === devis.id && (
                                  <span className="ml-2 text-xs text-emerald-700 bg-emerald-100 px-2 py-0.5 rounded-full">source actuelle</span>
                                )}
                              </p>
                              <p className="text-xs text-slate-500">
                                Version {devis.version} · {formatMoney(devis.total_ht)} HT · {devis.date_creation ? new Date(devis.date_creation).toLocaleDateString('fr-FR') : ''}
                              </p>
                            </div>
                          </label>
                        ))
                      )}
                    </div>
                    <div className="p-4 border-t border-slate-200 flex justify-end gap-2">
                      <button
                        onClick={() => { setShowChangeSourceModal(false); setNewDevisSource(''); }}
                        className="px-4 py-2 text-sm border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={handleChangeSourceDevis}
                        disabled={!newDevisSource || resyncingDescriptif || newDevisSource === descriptifArtisans?.devis_source_id}
                        className="px-4 py-2 text-sm bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                        data-testid="confirm-change-source-btn"
                      >
                        {resyncingDescriptif && <Loader2 className="w-4 h-4 animate-spin" />}
                        Confirmer
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Modal Ajouter Ligne */}
              {showAddLigneModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-xl w-full max-w-md mx-4 shadow-2xl">
                    <div className="p-6 border-b border-slate-200">
                      <h3 className="text-lg font-semibold text-slate-900">Ajouter une ligne</h3>
                      <p className="text-sm text-slate-500">Lot {newLigne.lot_id} – {newLigne.lot_nom}</p>
                    </div>
                    <div className="p-6 space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Description *</label>
                        <textarea
                          value={newLigne.description}
                          onChange={(e) => setNewLigne({...newLigne, description: e.target.value})}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 resize-y"
                          rows={5}
                          style={{ minHeight: '140px' }}
                          spellCheck="true"
                          lang="fr"
                          placeholder="Description de la prestation"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Sous-lot (optionnel)</label>
                        <input
                          type="text"
                          value={newLigne.sous_lot_nom}
                          onChange={(e) => setNewLigne({...newLigne, sous_lot_nom: e.target.value})}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                          placeholder="Nom du sous-lot"
                        />
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Sous-sous-lot</label>
                          <input
                            type="text"
                            value={newLigne.sous_sous_lot_nom || ''}
                            onChange={(e) => setNewLigne({...newLigne, sous_sous_lot_nom: e.target.value})}
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                            placeholder="Ex: ALIM RJ45"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Groupe</label>
                          <input
                            type="text"
                            value={newLigne.groupe_nom || ''}
                            onChange={(e) => setNewLigne({...newLigne, groupe_nom: e.target.value})}
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                            placeholder="Ex: ESPACE CAISSE"
                          />
                        </div>
                      </div>
                      <label className="flex items-center gap-2 text-sm">
                        <input
                          type="checkbox"
                          checked={!!newLigne.is_titre_libre}
                          onChange={(e) => setNewLigne({...newLigne, is_titre_libre: e.target.checked})}
                          className="rounded"
                        />
                        Titre libre (ligne de section, sans quantité)
                      </label>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Localisation (optionnel)</label>
                        <textarea
                          value={newLigne.localisation || ''}
                          onChange={(e) => setNewLigne({...newLigne, localisation: e.target.value})}
                          className="w-full px-3 py-2 border border-blue-200 bg-blue-50/30 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 resize-y"
                          rows={2}
                          spellCheck="true"
                          lang="fr"
                          placeholder="Ex: Bureau, Zone RJ45, Réserve arrière …"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Commentaire (optionnel)</label>
                        <textarea
                          value={newLigne.commentaire || ''}
                          onChange={(e) => setNewLigne({...newLigne, commentaire: e.target.value})}
                          className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 resize-y"
                          rows={3}
                          spellCheck="true"
                          lang="fr"
                          placeholder="Précision pour l'artisan"
                        />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Unité</label>
                          <input
                            type="text"
                            value={newLigne.unite}
                            onChange={(e) => setNewLigne({...newLigne, unite: e.target.value})}
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-slate-700 mb-1">Quantité</label>
                          <input
                            type="number"
                            step="0.01"
                            value={newLigne.quantite}
                            onChange={(e) => setNewLigne({...newLigne, quantite: parseFloat(e.target.value) || 0})}
                            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="p-6 border-t border-slate-200 flex gap-3">
                      <button
                        onClick={() => setShowAddLigneModal(false)}
                        className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
                      >
                        Annuler
                      </button>
                      <button
                        onClick={handleAddDescriptifLigne}
                        disabled={!newLigne.description.trim()}
                        className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50 flex items-center justify-center gap-2"
                      >
                        <Plus className="w-4 h-4" />
                        Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Tab: Planning */}
          {activeTab === 'planning' && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold">Planning Travaux</h3>
                <Button 
                  onClick={handleCreatePlanning}
                  disabled={creatingPlanning}
                  className="bg-indigo-600 hover:bg-indigo-700"
                >
                  <Plus className="w-4 h-4 mr-1" />
                  {creatingPlanning ? 'Création...' : 'Nouveau Planning'}
                </Button>
              </div>

              {plannings.length === 0 ? (
                <div className="bg-slate-50 border border-dashed border-slate-200 rounded-lg p-8 text-center">
                  <Calendar className="w-12 h-12 text-slate-300 mx-auto mb-3" />
                  <p className="text-slate-600 mb-2">Aucun planning pour ce projet</p>
                  <p className="text-sm text-slate-500 mb-4">
                    Créez un planning pour organiser les travaux. Les dates de démarrage et d'ouverture du projet seront utilisées automatiquement.
                  </p>
                  <Button onClick={handleCreatePlanning} disabled={creatingPlanning} variant="outline">
                    <Plus className="w-4 h-4 mr-1" />
                    Créer le premier planning
                  </Button>
                </div>
              ) : (
                <div className="grid gap-4">
                  {plannings.map(planning => (
                    <div key={planning.id} className="bg-white border border-slate-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                            <Calendar className="w-6 h-6 text-indigo-600" />
                          </div>
                          <div>
                            <h4 className="font-medium text-slate-900">
                              Planning Version {planning.version}
                            </h4>
                            <p className="text-sm text-slate-500">
                              {planning.semaines?.length || 0} semaines • 
                              Créé le {new Date(planning.created_at).toLocaleDateString('fr-FR')}
                            </p>
                            <div className="flex gap-4 text-xs text-slate-500 mt-1">
                              <span>Démarrage: {planning.date_demarrage || '-'}</span>
                              <span>Ouverture: {planning.date_ouverture || '-'}</span>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => handleDuplicatePlanning(planning.id)}
                            title="Dupliquer"
                          >
                            <Copy className="w-4 h-4" />
                          </Button>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => openPdfPreview(
                              `/plannings/${planning.id}/pdf?token=${localStorage.getItem('token')}`,
                              { title: `Planning ${planning.titre || ''}`, filename: `planning-${(planning.titre || planning.id).replace(/\s+/g, '-')}.pdf` }
                            )}
                            title="Aperçu PDF"
                          >
                            <Download className="w-4 h-4" />
                          </Button>
                          <Button 
                            variant="outline" 
                            size="sm"
                            onClick={() => handleDeletePlanning(planning.id)}
                            className="text-red-600 hover:bg-red-50"
                            title="Supprimer"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                          <Button 
                            size="sm"
                            onClick={() => navigate(`/planning/${planning.id}`)}
                            className="bg-indigo-600 hover:bg-indigo-700"
                          >
                            Ouvrir
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Tab: Marge */}
          {activeTab === 'marge' && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Pilotage Financier</h3>

              {/* Factures Client (Henrri) - obligatoires pour clôturer */}
              <div className="mb-6 bg-white border border-slate-200 rounded-xl p-4">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h4 className="font-semibold text-slate-800 flex items-center gap-2">
                      <FileText className="w-4 h-4 text-emerald-600" />
                      Factures Client
                      <span className="text-xs font-normal bg-slate-100 px-2 py-0.5 rounded">
                        {facturesClient.length} facture{facturesClient.length > 1 ? 's' : ''}
                      </span>
                    </h4>
                    <p className="text-xs text-slate-500 mt-1">
                      Total facturé client : <strong className="text-emerald-700">{formatMoney(facturesClient.reduce((s, f) => s + (f.montant_ht || 0), 0))} HT</strong>
                      {!projet.is_cloture && facturesClient.length === 0 && (
                        <span className="ml-2 text-amber-600">⚠️ Requis pour clôturer le projet</span>
                      )}
                    </p>
                  </div>
                  {!projet.is_cloture && (
                    <button
                      onClick={() => {
                        setFactureClientForm({ numero_facture: '', date_facture: new Date().toISOString().slice(0, 10), montant_ht: '', montant_ttc: '', file: null });
                        setShowFactureClientModal(true);
                      }}
                      className="px-3 py-1.5 bg-emerald-600 text-white text-sm rounded-lg hover:bg-emerald-700 flex items-center gap-1"
                      data-testid="add-facture-client-btn"
                    >
                      <Plus className="w-4 h-4" />
                      Ajouter
                    </button>
                  )}
                </div>
                {facturesClient.length > 0 && (
                  <div className="space-y-1">
                    {facturesClient.map((fc) => (
                      <div key={fc.id} className="flex items-center justify-between py-2 px-3 bg-slate-50 rounded text-sm">
                        <div className="flex-1 min-w-0">
                          <span className="font-medium text-slate-900">{fc.numero_facture || 'Sans n°'}</span>
                          <span className="text-slate-500 ml-2 text-xs">{fc.date_facture}</span>
                        </div>
                        <span className="font-mono font-semibold text-emerald-700 mr-3">{formatMoney(fc.montant_ht)} HT</span>
                        <a
                          href={downloadFactureClientUrl(fc.id)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-1 text-slate-400 hover:text-indigo-600"
                          title="Télécharger PDF"
                        >
                          <Download className="w-4 h-4" />
                        </a>
                        {!projet.is_cloture && (
                          <button
                            onClick={async () => {
                              if (!window.confirm(`Supprimer la facture ${fc.numero_facture || ''} ?`)) return;
                              try {
                                await deleteFactureClient(projetId, fc.id);
                                toast.success('Facture supprimée');
                                loadData();
                              } catch (e) {
                                toast.error('Erreur lors de la suppression');
                              }
                            }}
                            className="p-1 text-slate-400 hover:text-red-600"
                            title="Supprimer"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {/* Marge finale (si clôturé ou si facturé) */}
                {facturesClient.length > 0 && (
                  <div className="mt-3 pt-3 border-t border-slate-200">
                    {(() => {
                      const totalFactureClient = facturesClient.reduce((s, f) => s + (f.montant_ht || 0), 0);
                      const totalFactureArtisan = margeData?.total_factures_recues || 0;
                      const totalFraisGen = fraisGeneraux.reduce((s, f) => s + (f.montant_ht || 0), 0);
                      const margeReelle = totalFactureClient - totalFactureArtisan - totalFraisGen;
                      const margePct = totalFactureClient > 0 ? (margeReelle / totalFactureClient) * 100 : null;
                      const margeColor = margePct === null ? 'text-slate-700' : margePct < 15 ? 'text-red-700' : margePct < 20 ? 'text-amber-700' : 'text-emerald-700';
                      return (
                        <div className="flex items-center justify-between text-sm">
                          <span className="text-slate-600" title="Facturé client − Factures artisans − Frais généraux">
                            Marge réelle (Facturé − Artisans − Frais&nbsp;G.) :
                          </span>
                          <div className="flex items-center gap-3">
                            <span className={`font-bold font-mono ${margeColor}`}>{formatMoney(margeReelle)}</span>
                            {margePct !== null && (
                              <span className={`text-xs px-2 py-0.5 rounded-full font-semibold ${margePct < 15 ? 'bg-red-100 text-red-700' : margePct < 20 ? 'bg-amber-100 text-amber-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                {margePct.toFixed(1)}%
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>

              {/* Frais Généraux : pas de section séparée — désormais affichée
                  comme une ligne "FRAIS GÉNÉRAUX" en bas du tableau de marge.
                  Le modal de saisie manuelle reste accessible via cette ligne. */}

              {/* Summary cards */}
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-xs font-medium text-blue-600 mb-1">CA MAAG (Vendu)</p>
                  <p className="text-2xl font-bold text-blue-900 font-mono">{formatMoney(projet.ca_maag)}</p>
                </div>
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-4" title="Estimations + factures (MAX) — coût prévisionnel">
                  <p className="text-xs font-medium text-slate-600 mb-1">Coûts Fournisseurs <span className="text-slate-400">(prév.)</span></p>
                  <p className="text-2xl font-bold text-slate-900 font-mono">{formatMoney(projet.total_achats_artisans)}</p>
                </div>
                <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4" title="Somme des factures artisans reçues (réel, identique à Suivi Factures)">
                  <p className="text-xs font-medium text-indigo-600 mb-1">Factures Reçues</p>
                  <p className="text-2xl font-bold text-indigo-900 font-mono">{formatMoney(margeData?.total_factures_recues || 0)}</p>
                  <p className="text-xs text-indigo-500 mt-1">{margeData?.total_factures_count || 0} facture(s)</p>
                </div>
                <div className={`rounded-lg p-4 ${getMargeColorBg(projet.marge_pourcentage)}`}>
                  <p className="text-xs font-medium opacity-70 mb-1">Marge €</p>
                  <p className="text-2xl font-bold font-mono">{formatMoney(projet.marge_euros)}</p>
                </div>
                <div className={`rounded-lg p-4 ${getMargeColorBg(projet.marge_pourcentage)}`}>
                  <p className="text-xs font-medium opacity-70 mb-1">Marge %</p>
                  <p className="text-2xl font-bold font-mono">
                    {projet.marge_pourcentage !== null ? `${projet.marge_pourcentage.toFixed(1)}%` : '-'}
                  </p>
                </div>
              </div>

              {/* Zone de drop pour analyse IA des devis fournisseurs */}
              <div
                className={`mb-6 border-2 border-dashed rounded-lg p-4 transition-colors ${
                  isDraggingDevisFournisseur 
                    ? 'border-indigo-500 bg-indigo-50' 
                    : 'border-slate-300 bg-slate-50 hover:border-indigo-400'
                }`}
                onDragOver={(e) => { e.preventDefault(); setIsDraggingDevisFournisseur(true); }}
                onDragLeave={() => setIsDraggingDevisFournisseur(false)}
                onDrop={async (e) => {
                  e.preventDefault();
                  setIsDraggingDevisFournisseur(false);
                  const file = e.dataTransfer.files[0];
                  if (file && file.type === 'application/pdf') {
                    setAnalyzingDevisFournisseur(true);
                    try {
                      const res = await analyzeDevisFournisseur(projetId, file);
                      // Skip the "Select lot" modal — use the lot chosen by AI directly.
                      // User can reassign later from Suivi Factures if needed.
                      const data = res.data;
                      const createRes = await createFournisseurFromAnalysis(projetId, {
                        lot_id: data.lot_id || '1',
                        entreprise: data.entreprise,
                        montant_ht: data.montant_ht,
                        temp_filename: data.temp_filename,
                        slot: 1,
                        reference_devis: data.reference_devis || '',
                        date_devis: data.date_devis || '',
                      });
                      const lotObj =
                        (margeData?.marges_par_lot || []).find((m) => String(m.lot_id) === String(data.lot_id)) ||
                        (lots || []).find((l) => String(l.id) === String(data.lot_id));
                      const lotName = lotObj?.lot_nom || lotObj?.nom || `Lot ${data.lot_id}`;
                      const assignedSlot = createRes?.data?.slot || 1;
                      toast.success(`Devis "${data.entreprise}" ajouté en place ${assignedSlot} du lot ${lotName} (${Math.round(data.montant_ht)}€ HT)`);
                      loadData();
                    } catch (err) {
                      const detail = err.response?.data?.detail || 'Erreur lors de l\'analyse';
                      if (err.response?.status === 409) {
                        toast.error(detail, { duration: 8000 });
                      } else {
                        toast.error(detail);
                      }
                    } finally {
                      setAnalyzingDevisFournisseur(false);
                    }
                  } else {
                    toast.error('Seuls les fichiers PDF sont acceptés');
                  }
                }}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
                      {analyzingDevisFournisseur ? (
                        <Loader2 className="w-5 h-5 text-indigo-600 animate-spin" />
                      ) : (
                        <Upload className="w-5 h-5 text-indigo-600" />
                      )}
                    </div>
                    <div>
                      <p className="font-medium text-slate-700">
                        {analyzingDevisFournisseur ? 'Analyse en cours...' : 'Glissez-déposez un devis fournisseur PDF'}
                      </p>
                      <p className="text-xs text-slate-500">L'IA extrait automatiquement : entreprise, montant</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => devisFournisseurInputRef.current?.click()}
                      disabled={analyzingDevisFournisseur}
                      className="px-3 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2"
                    >
                      <Upload className="w-4 h-4" />
                      Parcourir
                    </button>
                    <input
                      ref={devisFournisseurInputRef}
                      type="file"
                      accept=".pdf"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          setAnalyzingDevisFournisseur(true);
                          try {
                            const res = await analyzeDevisFournisseur(projetId, file);
                            const data = res.data;
                            const createRes = await createFournisseurFromAnalysis(projetId, {
                              lot_id: data.lot_id || '1',
                              entreprise: data.entreprise,
                              montant_ht: data.montant_ht,
                              temp_filename: data.temp_filename,
                              slot: 1,
                              reference_devis: data.reference_devis || '',
                              date_devis: data.date_devis || '',
                            });
                            const lotObj =
                              (margeData?.marges_par_lot || []).find((m) => String(m.lot_id) === String(data.lot_id)) ||
                              (lots || []).find((l) => String(l.id) === String(data.lot_id));
                            const lotName = lotObj?.lot_nom || lotObj?.nom || `Lot ${data.lot_id}`;
                            const assignedSlot = createRes?.data?.slot || 1;
                            toast.success(`Devis "${data.entreprise}" ajouté en place ${assignedSlot} du lot ${lotName} (${Math.round(data.montant_ht)}€ HT)`);
                            loadData();
                          } catch (err) {
                            const detail = err.response?.data?.detail || 'Erreur lors de l\'analyse';
                            if (err.response?.status === 409) {
                              toast.error(detail, { duration: 8000 });
                            } else {
                              toast.error(detail);
                            }
                          } finally {
                            setAnalyzingDevisFournisseur(false);
                            e.target.value = '';
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Main table */}
              {margeData && margeData.marges_par_lot && (
                <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                  {/* Légende couleurs + Action doublons */}
                  <div className="px-3 py-2 bg-slate-50 border-b border-slate-200 flex items-center gap-3 text-xs flex-wrap">
                    <span className="font-semibold text-slate-600">Légende :</span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-slate-50 border border-slate-200"></span>Vide</span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-orange-50 border border-orange-200"></span>Renseigné</span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-blue-50 border border-blue-200"></span>Devis reçu</span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-green-50 border border-green-200"></span>BDC émis</span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-orange-200 ring-2 ring-orange-400"></span><strong>🟧 Facture reçue</strong></span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-yellow-200 ring-2 ring-yellow-400"></span><strong>🟨 Acompte payé (finale manquante)</strong></span>
                    <span className="inline-flex items-center gap-1"><span className="w-3 h-3 rounded bg-emerald-200 ring-2 ring-emerald-400"></span><strong>🟩 Facture payée</strong></span>
                    <span className="text-slate-500 italic">🔒 = verrouillé par une facture liée</span>
                    <button
                      onClick={handleOpenDuplicates}
                      data-testid="detect-duplicates-btn"
                      className="ml-auto inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-800 rounded font-semibold hover:bg-amber-200 transition-colors"
                      title="Détecter les fournisseurs en double dans ce projet"
                    >
                      🔍 Détecter doublons
                    </button>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-slate-800 text-white">
                          <th className="px-3 py-3 text-left font-bold" rowSpan={2}>LOT</th>
                          <th className="px-3 py-3 text-right font-bold" rowSpan={2}>VENDU</th>
                          <th className="px-3 py-3 text-center font-bold border-l border-slate-600" colSpan={6}>COÛT FOURNISSEURS</th>
                          <th className="px-3 py-3 text-right font-bold border-l border-slate-600" rowSpan={2}>MARGE €</th>
                          <th className="px-3 py-3 text-center font-bold" rowSpan={2}>%</th>
                        </tr>
                        <tr className="bg-slate-700 text-white text-xs">
                          <th className="px-2 py-2 text-center border-l border-slate-600">Entreprise 1</th>
                          <th className="px-2 py-2 text-right">Montant</th>
                          <th className="px-2 py-2 text-center border-l border-slate-500">Entreprise 2</th>
                          <th className="px-2 py-2 text-right">Montant</th>
                          <th className="px-2 py-2 text-center border-l border-slate-500">Entreprise 3</th>
                          <th className="px-2 py-2 text-right">Montant</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {margeData.marges_par_lot
                          .filter(m => !m.is_frais_generaux && (m.vendu > 0 || m.cout > 0 || (m.fournisseurs && m.fournisseurs.length > 0)))
                          .map((lot) => {
                            const slotMap = mapFournisseursBySlot(lot.fournisseurs);
                            const f1 = slotMap[1];
                            const f2 = slotMap[2];
                            const f3 = slotMap[3];

                            // Match factures artisans to fournisseur slots :
                            // 1. Par parent_fournisseur_id (rattachement explicite via modal)
                            // 2. Par nom d'entreprise (case-insensitive) si pas de parent_id et slot renseigné
                            const getFacturesFor = (f) => {
                              if (!f || !f.id) return [];
                              // Priority 1: explicit parent_fournisseur_id link
                              const linkedById = facturesArtisans.filter(fa =>
                                fa.parent_fournisseur_id && String(fa.parent_fournisseur_id) === String(f.id)
                              );
                              if (linkedById.length > 0) return linkedById;
                              // Priority 2: fallback to name matching (legacy / auto-linked)
                              // Skip factures explicitly detached by the user (manually_unlinked=true)
                              const nameTarget = (f.entreprise || '').trim().toLowerCase();
                              if (!nameTarget) return [];
                              return facturesArtisans.filter(fa =>
                                !fa.parent_fournisseur_id &&
                                !fa.manually_unlinked &&
                                (fa.artisan_nom || '').trim().toLowerCase() === nameTarget
                              );
                            };

                            // Returns all factures linked to this lot (by lot_id) and not yet matched to a slot
                            const lotIdStr = String(lot.lot_id || lot.id || '');
                            const orphanFacturesForLot = facturesArtisans.filter(fa => {
                              const faLot = String(fa.lot_id || '');
                              if (faLot !== lotIdStr) return false;
                              // Already explicitly linked to a slot via parent_fournisseur_id
                              if (fa.parent_fournisseur_id) return false;
                              // Manually detached → always show as orphan (bypass name-match)
                              if (fa.manually_unlinked) return true;
                              // Check if matched by name to any existing slot
                              const matched = (lot.fournisseurs || []).some(slot =>
                                (slot.entreprise || '').trim().toLowerCase() === (fa.artisan_nom || '').trim().toLowerCase()
                              );
                              return !matched;
                            });

                            const getStatusBg = (f) => {
                              if (!f || (!f.entreprise && !f.montant_ht)) return 'bg-slate-50';
                              const factures = getFacturesFor(f);
                              if (factures.length > 0) {
                                const hasFinale = factures.some(fa => fa.type_facture === 'finale');
                                const allPaid = factures.every(fa => fa.statut === 'payee');
                                // Acompte payé mais pas de facture finale → jaune flashy (alerte)
                                if (!hasFinale && allPaid && factures.some(fa => fa.type_facture === 'acompte')) {
                                  return 'bg-yellow-200 ring-2 ring-yellow-400';
                                }
                                if (allPaid && hasFinale) return 'bg-emerald-200 ring-2 ring-emerald-400';
                                if (allPaid) return 'bg-emerald-200 ring-2 ring-emerald-400';
                                return 'bg-orange-200 ring-2 ring-orange-400';
                              }
                              if (f.statut === 'bdc_emis' || f.bdc_id) return 'bg-green-50';
                              if (f.statut === 'devis_recu') return 'bg-blue-50';
                              return 'bg-orange-50';
                            };

                            // Returns true if the slot has any linked facture (locks the inputs)
                            const isLocked = (f) => getFacturesFor(f).length > 0;
                            const getFactureTotal = (f) => getFacturesFor(f).reduce((s, fa) => s + (fa.montant_ht || 0), 0);
                            // The amount actually used in the margin calculation (matches backend _compute_slot_cost):
                            // - With factures finales → sum of finales
                            // - With only acompte/simple → max(estimation, sum_factures)
                            // - Without facture → slot estimation
                            const getEffectiveAmount = (f) => {
                              if (!f) return 0;
                              const factures = getFacturesFor(f);
                              const estim = f.montant_ht || 0;
                              if (factures.length === 0) return estim;
                              const finales = factures.filter(fa => fa.type_facture === 'finale');
                              if (finales.length > 0) {
                                return finales.reduce((s, fa) => s + (fa.montant_ht || 0), 0);
                              }
                              const sumFac = factures.reduce((s, fa) => s + (fa.montant_ht || 0), 0);
                              return Math.max(estim, sumFac);
                            };
                            const getFactureTooltip = (f) => {
                              const factures = getFacturesFor(f);
                              if (factures.length === 0) return '';
                              const lines = factures.map(fa => `• ${fa.statut === 'payee' ? '✓ Payée' : '⏳ Reçue'} — ${formatMoney(fa.montant_ht)} (${(fa.date_facture || '').slice(0, 10)})`);
                              return `${factures.length} facture(s) liée(s) — total ${formatMoney(getFactureTotal(f))}\n${lines.join('\n')}\n\n🔒 Modifiable uniquement dans l'onglet Suivi Factures`;
                            };
                            
                            return (
                              <tr key={lot.lot_id} className="hover:bg-slate-50/50">
                                {/* LOT */}
                                <td className="px-3 py-2 font-medium whitespace-nowrap">
                                  {lot.lot_id}. {lot.lot_nom}
                                </td>
                                
                                {/* VENDU */}
                                <td className="px-3 py-2 text-right font-mono">{formatMoney(lot.vendu)}</td>
                                
                                {/* FOURNISSEUR 1 */}
                                <td className={`px-1 py-1 border-l border-slate-200 ${getStatusBg(f1)}`} title={getFactureTooltip(f1)}>
                                  <div className="flex items-center gap-1">
                                    <input
                                      key={`ent-s1-lot${lot.lot_id}-${f1?.id || 'empty'}-${f1?.entreprise || ''}-${f1?.pdf_filename || ''}`}
                                      data-testid={`marge-entreprise-f1-lot${lot.lot_id}`}
                                      type="text"
                                      placeholder="Entreprise..."
                                      defaultValue={f1?.entreprise || ''}
                                      disabled={isLocked(f1)}
                                      className="w-24 h-7 px-1 text-xs border border-slate-200 rounded bg-transparent focus:border-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:font-semibold"
                                      onBlur={async (e) => {
                                        if (deletingSlotIdRef.current && f1?.id && deletingSlotIdRef.current === f1.id) return;
                                        const val = e.target.value.trim();
                                        const asMontant = parseMontantInput(val);
                                        if (val && asMontant.ok && asMontant.value > 0) {
                                          toast.info(`« ${val} » ressemble à un montant : enregistré dans la colonne Montant`);
                                          e.target.value = f1?.entreprise || '';
                                          if (f1?.id && !f1.legacy) await updateFournisseurLot(projetId, f1.id, { montant_ht: asMontant.value });
                                          else await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: asMontant.value, slot: 1 });
                                          await loadData();
                                          return;
                                        }
                                        if (f1?.id && !f1.legacy) {
                                          await updateFournisseurLot(projetId, f1.id, { entreprise: val });
                                          await loadData();
                                        } else if (val) {
                                          await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: val, montant_ht: 0, slot: 1 });
                                          await loadData();
                                        }
                                      }}
                                    />
                                    {isLocked(f1) ? (
                                      <button
                                        type="button"
                                        onClick={() => handleForceUnlockSlot(f1, getFacturesFor(f1))}
                                        title={`Verrouillé par ${getFacturesFor(f1).length} facture(s). Cliquer pour déverrouiller.`}
                                        data-testid={`marge-force-unlock-f1-lot${lot.lot_id}`}
                                        className="hover:scale-125 transition-transform"
                                      >
                                        🔒
                                      </button>
                                    ) : (f1?.bdc_id && <Check className="w-3 h-3 text-green-600" />)}
                                  </div>
                                  {f1?.facturation_progress && (
                                    <button
                                      type="button"
                                      onClick={() => setFactureHistorySlot(f1)}
                                      className={`text-[10px] mt-0.5 font-mono underline-offset-2 hover:underline cursor-pointer ${f1.facturation_progress.has_finale ? 'text-emerald-700 font-bold' : 'text-amber-700'}`}
                                      title="Voir les factures liées à ce fournisseur"
                                      data-testid={`progress-f1-lot${lot.lot_id}`}
                                    >
                                      {f1.facturation_progress.has_finale ? 'Final ' : ''}
                                      {formatMoney(f1.facturation_progress.facture)} / {formatMoney(f1.facturation_progress.estimation)}
                                      {f1.facturation_progress.pct != null && ` (${f1.facturation_progress.pct}%)`}
                                    </button>
                                  )}
                                </td>
                                <td className={`px-1 py-1 ${getStatusBg(f1)}`} title={getFactureTooltip(f1)}>
                                  <div className="flex items-center gap-0.5">
                                    <input
                                      key={`mnt-s1-lot${lot.lot_id}-${f1?.id || 'empty'}-${f1?.montant_ht || 0}-${isLocked(f1) ? 'L' : 'U'}`}
                                      {...MONTANT_INPUT_PROPS}
                                      data-testid={`marge-montant-f1-lot${lot.lot_id}`}
                                      value={isLocked(f1) ? getEffectiveAmount(f1) : undefined}
                                      defaultValue={!isLocked(f1) ? (f1?.montant_ht || '') : undefined}
                                      disabled={isLocked(f1)}
                                      className="w-[4.5rem] h-7 px-1 text-xs text-right font-mono border-2 border-amber-400 rounded bg-amber-50/60 placeholder:text-amber-500 focus:border-amber-600 focus:bg-white focus:outline-none disabled:cursor-not-allowed disabled:font-bold disabled:border-slate-300 disabled:bg-slate-50"
                                      onBlur={async (e) => {
                                        if (deletingSlotIdRef.current && f1?.id && deletingSlotIdRef.current === f1.id) return;
                                        const parsed = parseMontantInput(e.target.value);
                                        if (!parsed.ok) { toast.error(parsed.error); e.target.value = f1?.montant_ht || ''; return; }
                                        const val = parsed.value;
                                        if (f1?.id && !f1.legacy) {
                                          if (val === (f1.montant_ht || 0)) return;
                                          await updateFournisseurLot(projetId, f1.id, { montant_ht: val });
                                          await loadData();
                                        } else if (val > 0) {
                                          await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: val, slot: 1 });
                                          await loadData();
                                        }
                                      }}
                                    />
                                    {/* Upload devis */}
                                    {f1?.id && !f1.legacy && !isLocked(f1) && (
                                      <label className="p-0.5 text-blue-500 hover:bg-blue-50 rounded cursor-pointer" title="Importer devis reçu">
                                        <Upload className="w-3.5 h-3.5" />
                                        <input
                                          type="file"
                                          accept=".pdf"
                                          className="hidden"
                                          onChange={async (e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                              try {
                                                await uploadDevisFournisseur(projetId, f1.id, file);
                                                toast.success('Devis importé');
                                                loadData();
                                              } catch (err) {
                                                toast.error(err.response?.data?.detail || 'Erreur upload');
                                              }
                                            }
                                          }}
                                        />
                                      </label>
                                    )}
                                    {/* Voir devis */}
                                    {f1?.pdf_filename && (
                                      <button
                                        onClick={async () => {
                                          try {
                                            await downloadDevisFournisseurPdf(projetId, f1.id, f1.entreprise);
                                          } catch (err) {
                                            toast.error('Erreur lors du téléchargement');
                                          }
                                        }}
                                        className="p-0.5 text-indigo-600 hover:bg-indigo-50 rounded"
                                        title="Voir devis reçu"
                                      >
                                        <Eye className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Générer BDC */}
                                    {f1 && f1.montant_ht > 0 && !f1.bdc_id && !isLocked(f1) && (
                                      <button
                                        onClick={() => handleOpenBdcModal(f1)}
                                        className="p-0.5 text-green-600 hover:bg-green-100 rounded"
                                        title="Générer BDC"
                                      >
                                        <FileCheck className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Déplacer vers un autre lot */}
                                    {f1?.id && !isLocked(f1) && (
                                      <button
                                        onClick={() => handleOpenMoveFournisseur({ ...f1, lot_id: lot.lot_id })}
                                        className="p-0.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
                                        title="Déplacer vers un autre lot"
                                        data-testid={`marge-move-f1-lot${lot.lot_id}`}
                                      >
                                        <MoveRight className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Supprimer fournisseur */}
                                    {f1?.id && !isLocked(f1) && (
                                      <button
                                        onMouseDown={() => { deletingSlotIdRef.current = f1.id; }}
                                        onClick={() => handleDeleteFournisseur(f1)}
                                        className="p-0.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded"
                                        title="Supprimer ce fournisseur"
                                        data-testid={`marge-delete-f1-lot${lot.lot_id}`}
                                      >
                                        <Trash2 className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                                
                                {/* FOURNISSEUR 2 */}
                                <td className={`px-1 py-1 border-l border-slate-200 ${getStatusBg(f2)}`} title={getFactureTooltip(f2)}>
                                  <div className="flex items-center gap-1">
                                  <input
                                    key={`ent-s2-lot${lot.lot_id}-${f2?.id || 'empty'}-${f2?.entreprise || ''}-${f2?.pdf_filename || ''}`}
                                    data-testid={`marge-entreprise-f2-lot${lot.lot_id}`}
                                    type="text"
                                    placeholder="Entreprise..."
                                    defaultValue={f2?.entreprise || ''}
                                    disabled={isLocked(f2)}
                                    className="w-24 h-7 px-1 text-xs border border-slate-200 rounded bg-transparent focus:border-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:font-semibold"
                                    onBlur={async (e) => {
                                      if (deletingSlotIdRef.current && f2?.id && deletingSlotIdRef.current === f2.id) return;
                                      const val = e.target.value.trim();
                                      const asMontant = parseMontantInput(val);
                                      if (val && asMontant.ok && asMontant.value > 0) {
                                        toast.info(`« ${val} » ressemble à un montant : enregistré dans la colonne Montant`);
                                        e.target.value = f2?.entreprise || '';
                                        if (f2?.id && !f2.legacy) await updateFournisseurLot(projetId, f2.id, { montant_ht: asMontant.value });
                                        else await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: asMontant.value, slot: 2 });
                                        await loadData();
                                        return;
                                      }
                                      if (f2?.id && !f2.legacy) {
                                        await updateFournisseurLot(projetId, f2.id, { entreprise: val });
                                        await loadData();
                                      } else if (val) {
                                        await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: val, montant_ht: 0, slot: 2 });
                                        await loadData();
                                      }
                                    }}
                                  />
                                  {isLocked(f2) && (
                                    <button
                                      type="button"
                                      onClick={() => handleForceUnlockSlot(f2, getFacturesFor(f2))}
                                      title={`Verrouillé par ${getFacturesFor(f2).length} facture(s). Cliquer pour déverrouiller.`}
                                      data-testid={`marge-force-unlock-f2-lot${lot.lot_id}`}
                                      className="hover:scale-125 transition-transform"
                                    >
                                      🔒
                                    </button>
                                  )}
                                  </div>
                                </td>
                                <td className={`px-1 py-1 ${getStatusBg(f2)}`} title={getFactureTooltip(f2)}>
                                  <div className="flex items-center gap-0.5">
                                    <input
                                      key={`mnt-s2-lot${lot.lot_id}-${f2?.id || 'empty'}-${f2?.montant_ht || 0}-${isLocked(f2) ? 'L' : 'U'}`}
                                      {...MONTANT_INPUT_PROPS}
                                      data-testid={`marge-montant-f2-lot${lot.lot_id}`}
                                      value={isLocked(f2) ? getEffectiveAmount(f2) : undefined}
                                      defaultValue={!isLocked(f2) ? (f2?.montant_ht || '') : undefined}
                                      disabled={isLocked(f2)}
                                      className="w-[4.5rem] h-7 px-1 text-xs text-right font-mono border-2 border-amber-400 rounded bg-amber-50/60 placeholder:text-amber-500 focus:border-amber-600 focus:bg-white focus:outline-none disabled:cursor-not-allowed disabled:font-bold disabled:border-slate-300 disabled:bg-slate-50"
                                      onBlur={async (e) => {
                                        if (deletingSlotIdRef.current && f2?.id && deletingSlotIdRef.current === f2.id) return;
                                        const parsed = parseMontantInput(e.target.value);
                                        if (!parsed.ok) { toast.error(parsed.error); e.target.value = f2?.montant_ht || ''; return; }
                                        const val = parsed.value;
                                        if (f2?.id && !f2.legacy) {
                                          if (val === (f2.montant_ht || 0)) return;
                                          await updateFournisseurLot(projetId, f2.id, { montant_ht: val });
                                          await loadData();
                                        } else if (val > 0) {
                                          await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: val, slot: 2 });
                                          await loadData();
                                        }
                                      }}
                                    />
                                    {/* Upload devis */}
                                    {f2?.id && !f2.legacy && !isLocked(f2) && (
                                      <label className="p-0.5 text-blue-500 hover:bg-blue-50 rounded cursor-pointer" title="Importer devis reçu">
                                        <Upload className="w-3.5 h-3.5" />
                                        <input
                                          type="file"
                                          accept=".pdf"
                                          className="hidden"
                                          onChange={async (e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                              try {
                                                await uploadDevisFournisseur(projetId, f2.id, file);
                                                toast.success('Devis importé');
                                                loadData();
                                              } catch (err) {
                                                toast.error(err.response?.data?.detail || 'Erreur upload');
                                              }
                                            }
                                          }}
                                        />
                                      </label>
                                    )}
                                    {/* Voir devis */}
                                    {f2?.pdf_filename && (
                                      <button
                                        onClick={async () => {
                                          try {
                                            await downloadDevisFournisseurPdf(projetId, f2.id, f2.entreprise);
                                          } catch (err) {
                                            toast.error('Erreur lors du téléchargement');
                                          }
                                        }}
                                        className="p-0.5 text-indigo-600 hover:bg-indigo-50 rounded"
                                        title="Voir devis reçu"
                                      >
                                        <Eye className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Générer BDC */}
                                    {f2 && f2.montant_ht > 0 && !f2.bdc_id && !isLocked(f2) && (
                                      <button
                                        onClick={() => handleOpenBdcModal(f2)}
                                        className="p-0.5 text-green-600 hover:bg-green-100 rounded"
                                        title="Générer BDC"
                                      >
                                        <FileCheck className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Déplacer vers un autre lot */}
                                    {f2?.id && !isLocked(f2) && (
                                      <button
                                        onClick={() => handleOpenMoveFournisseur({ ...f2, lot_id: lot.lot_id })}
                                        className="p-0.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
                                        title="Déplacer vers un autre lot"
                                        data-testid={`marge-move-f2-lot${lot.lot_id}`}
                                      >
                                        <MoveRight className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Supprimer fournisseur */}
                                    {f2?.id && !isLocked(f2) && (
                                      <button
                                        onMouseDown={() => { deletingSlotIdRef.current = f2.id; }}
                                        onClick={() => handleDeleteFournisseur(f2)}
                                        className="p-0.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded"
                                        title="Supprimer ce fournisseur"
                                        data-testid={`marge-delete-f2-lot${lot.lot_id}`}
                                      >
                                        <Trash2 className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                                
                                {/* FOURNISSEUR 3 */}
                                <td className={`px-1 py-1 border-l border-slate-200 ${getStatusBg(f3)}`} title={getFactureTooltip(f3)}>
                                  <div className="flex items-center gap-1">
                                  <input
                                    key={`ent-s3-lot${lot.lot_id}-${f3?.id || 'empty'}-${f3?.entreprise || ''}-${f3?.pdf_filename || ''}`}
                                    data-testid={`marge-entreprise-f3-lot${lot.lot_id}`}
                                    type="text"
                                    placeholder="Entreprise..."
                                    defaultValue={f3?.entreprise || ''}
                                    disabled={isLocked(f3)}
                                    className="w-24 h-7 px-1 text-xs border border-slate-200 rounded bg-transparent focus:border-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:font-semibold"
                                    onBlur={async (e) => {
                                      if (deletingSlotIdRef.current && f3?.id && deletingSlotIdRef.current === f3.id) return;
                                      const val = e.target.value.trim();
                                      const asMontant = parseMontantInput(val);
                                      if (val && asMontant.ok && asMontant.value > 0) {
                                        toast.info(`« ${val} » ressemble à un montant : enregistré dans la colonne Montant`);
                                        e.target.value = f3?.entreprise || '';
                                        if (f3?.id && !f3.legacy) await updateFournisseurLot(projetId, f3.id, { montant_ht: asMontant.value });
                                        else await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: asMontant.value, slot: 3 });
                                        await loadData();
                                        return;
                                      }
                                      if (f3?.id && !f3.legacy) {
                                        await updateFournisseurLot(projetId, f3.id, { entreprise: val });
                                        await loadData();
                                      } else if (val) {
                                        await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: val, montant_ht: 0, slot: 3 });
                                        await loadData();
                                      }
                                    }}
                                  />
                                  {isLocked(f3) && (
                                    <button
                                      type="button"
                                      onClick={() => handleForceUnlockSlot(f3, getFacturesFor(f3))}
                                      title={`Verrouillé par ${getFacturesFor(f3).length} facture(s). Cliquer pour déverrouiller.`}
                                      data-testid={`marge-force-unlock-f3-lot${lot.lot_id}`}
                                      className="hover:scale-125 transition-transform"
                                    >
                                      🔒
                                    </button>
                                  )}
                                  </div>
                                </td>
                                <td className={`px-1 py-1 ${getStatusBg(f3)}`} title={getFactureTooltip(f3)}>
                                  <div className="flex items-center gap-0.5">
                                    <input
                                      key={`mnt-s3-lot${lot.lot_id}-${f3?.id || 'empty'}-${f3?.montant_ht || 0}-${isLocked(f3) ? 'L' : 'U'}`}
                                      {...MONTANT_INPUT_PROPS}
                                      data-testid={`marge-montant-f3-lot${lot.lot_id}`}
                                      value={isLocked(f3) ? getEffectiveAmount(f3) : undefined}
                                      defaultValue={!isLocked(f3) ? (f3?.montant_ht || '') : undefined}
                                      disabled={isLocked(f3)}
                                      className="w-[4.5rem] h-7 px-1 text-xs text-right font-mono border-2 border-amber-400 rounded bg-amber-50/60 placeholder:text-amber-500 focus:border-amber-600 focus:bg-white focus:outline-none disabled:cursor-not-allowed disabled:font-bold disabled:border-slate-300 disabled:bg-slate-50"
                                      onBlur={async (e) => {
                                        if (deletingSlotIdRef.current && f3?.id && deletingSlotIdRef.current === f3.id) return;
                                        const parsed = parseMontantInput(e.target.value);
                                        if (!parsed.ok) { toast.error(parsed.error); e.target.value = f3?.montant_ht || ''; return; }
                                        const val = parsed.value;
                                        if (f3?.id && !f3.legacy) {
                                          if (val === (f3.montant_ht || 0)) return;
                                          await updateFournisseurLot(projetId, f3.id, { montant_ht: val });
                                          await loadData();
                                        } else if (val > 0) {
                                          await createFournisseurLot(projetId, { lot_id: lot.lot_id, entreprise: '', montant_ht: val, slot: 3 });
                                          await loadData();
                                        }
                                      }}
                                    />
                                    {/* Upload devis */}
                                    {f3?.id && !f3.legacy && !isLocked(f3) && (
                                      <label className="p-0.5 text-blue-500 hover:bg-blue-50 rounded cursor-pointer" title="Importer devis reçu">
                                        <Upload className="w-3.5 h-3.5" />
                                        <input
                                          type="file"
                                          accept=".pdf"
                                          className="hidden"
                                          onChange={async (e) => {
                                            const file = e.target.files?.[0];
                                            if (file) {
                                              try {
                                                await uploadDevisFournisseur(projetId, f3.id, file);
                                                toast.success('Devis importé');
                                                loadData();
                                              } catch (err) {
                                                toast.error(err.response?.data?.detail || 'Erreur upload');
                                              }
                                            }
                                          }}
                                        />
                                      </label>
                                    )}
                                    {/* Voir devis */}
                                    {f3?.pdf_filename && (
                                      <button
                                        onClick={async () => {
                                          try {
                                            await downloadDevisFournisseurPdf(projetId, f3.id, f3.entreprise);
                                          } catch (err) {
                                            toast.error('Erreur lors du téléchargement');
                                          }
                                        }}
                                        className="p-0.5 text-indigo-600 hover:bg-indigo-50 rounded"
                                        title="Voir devis reçu"
                                      >
                                        <Eye className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Générer BDC */}
                                    {f3 && f3.montant_ht > 0 && !f3.bdc_id && !isLocked(f3) && (
                                      <button
                                        onClick={() => handleOpenBdcModal(f3)}
                                        className="p-0.5 text-green-600 hover:bg-green-100 rounded"
                                        title="Générer BDC"
                                      >
                                        <FileCheck className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Déplacer vers un autre lot */}
                                    {f3?.id && !isLocked(f3) && (
                                      <button
                                        onClick={() => handleOpenMoveFournisseur({ ...f3, lot_id: lot.lot_id })}
                                        className="p-0.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
                                        title="Déplacer vers un autre lot"
                                        data-testid={`marge-move-f3-lot${lot.lot_id}`}
                                      >
                                        <MoveRight className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                    {/* Supprimer fournisseur */}
                                    {f3?.id && !isLocked(f3) && (
                                      <button
                                        onMouseDown={() => { deletingSlotIdRef.current = f3.id; }}
                                        onClick={() => handleDeleteFournisseur(f3)}
                                        className="p-0.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded"
                                        title="Supprimer ce fournisseur"
                                        data-testid={`marge-delete-f3-lot${lot.lot_id}`}
                                      >
                                        <Trash2 className="w-3.5 h-3.5" />
                                      </button>
                                    )}
                                  </div>
                                </td>
                                
                                {/* MARGE */}
                                <td className="px-3 py-2 text-right font-mono font-semibold border-l border-slate-200">
                                  <span className={lot.marge_euros >= 0 ? 'text-green-600' : 'text-red-600'}>
                                    {formatMoney(lot.marge_euros)}
                                  </span>
                                </td>
                                <td className="px-2 py-2 text-center">
                                  {lot.marge_pourcentage !== null && (
                                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${getMargeColorBg(lot.marge_pourcentage)}`}>
                                      {lot.marge_pourcentage.toFixed(0)}%
                                    </span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        {/* Virtual "FRAIS GÉNÉRAUX" lot row */}
                        {(() => {
                          const fgLot = (margeData.marges_par_lot || []).find(m => m.is_frais_generaux);
                          if (!fgLot) return null;
                          const fgFactures = facturesArtisans.filter(fa => fa.lot_id === 'frais_generaux');
                          const fgManualTotal = fraisGeneraux.reduce((s, f) => s + (f.montant_ht || 0), 0);
                          const fgFacturesTotal = fgFactures.reduce((s, f) => s + (f.montant_ht || 0), 0);
                          const fgTotal = fgManualTotal + fgFacturesTotal;
                          return (
                            <tr className="bg-amber-50/50 hover:bg-amber-50 border-t-2 border-amber-200" data-testid="frais-generaux-row">
                              <td className="px-3 py-2 font-bold whitespace-nowrap text-amber-900">
                                <div className="flex items-center gap-2">
                                  <Receipt className="w-4 h-4 text-amber-600" />
                                  FRAIS GÉNÉRAUX
                                  <span className="text-[10px] font-normal bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded">
                                    {fgLot.frais_generaux_count || 0}
                                  </span>
                                </div>
                              </td>
                              <td className="px-3 py-2 text-right font-mono text-slate-400 italic text-xs">—</td>
                              <td className="px-2 py-2 border-l border-slate-200" colSpan={6}>
                                <div className="flex items-center justify-between gap-2">
                                  <div className="flex items-center gap-3 flex-wrap">
                                    <span className="font-mono font-bold text-amber-800">{formatMoney(fgTotal)}</span>
                                    <span className="text-[11px] text-amber-700/80">
                                      {fgFactures.length > 0 && <>📄 {fgFactures.length} facture{fgFactures.length > 1 ? 's' : ''}</>}
                                      {fgFactures.length > 0 && fraisGeneraux.length > 0 && ' • '}
                                      {fraisGeneraux.length > 0 && <>✏️ {fraisGeneraux.length} saisie{fraisGeneraux.length > 1 ? 's' : ''} manuelle{fraisGeneraux.length > 1 ? 's' : ''}</>}
                                      {fgTotal === 0 && <span className="italic">Aucun frais — timbres, restau, CB, déplacements…</span>}
                                    </span>
                                  </div>
                                  {!projet.is_cloture && (
                                    <div className="flex items-center gap-1">
                                      {fgTotal > 0 && (
                                        <button
                                          onClick={() => setShowFraisGenDetailModal(true)}
                                          className="px-2 py-1 text-xs bg-white border border-amber-300 text-amber-700 rounded hover:bg-amber-100 flex items-center gap-1"
                                          data-testid="frais-gen-detail-btn"
                                          title="Voir le détail"
                                        >
                                          <Eye className="w-3 h-3" />
                                          Détail
                                        </button>
                                      )}
                                      <button
                                        onClick={() => openFraisGenModal(null)}
                                        className="px-2 py-1 text-xs bg-amber-600 text-white rounded hover:bg-amber-700 flex items-center gap-1"
                                        data-testid="add-frais-general-btn"
                                        title="Saisir un frais sans facture PDF (timbre, repas…)"
                                      >
                                        <Plus className="w-3 h-3" />
                                        Ajouter
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className="px-3 py-2 text-right font-mono border-l border-slate-200 text-amber-800 font-bold">
                                {fgTotal > 0 ? `-${formatMoney(fgTotal)}` : '—'}
                              </td>
                              <td className="px-2 py-2 text-center text-slate-400 text-xs">—</td>
                            </tr>
                          );
                        })()}
                      </tbody>
                      <tfoot>
                        <tr className="bg-slate-800 text-white font-bold">
                          <td className="px-3 py-3">TOTAL</td>
                          <td className="px-3 py-3 text-right font-mono">{formatMoney(projet.ca_maag)}</td>
                          <td className="px-3 py-3 text-center border-l border-slate-600" colSpan={6}>
                            <span className="font-mono">{formatMoney(projet.total_achats_artisans)}</span>
                          </td>
                          <td className="px-3 py-3 text-right font-mono border-l border-slate-600">{formatMoney(projet.marge_euros)}</td>
                          <td className="px-2 py-3 text-center">{projet.marge_pourcentage?.toFixed(1)}%</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}

              {/* Légende */}
              <div className="mt-4 flex flex-wrap gap-4 text-xs text-slate-500">
                <span className="flex items-center gap-1"><span className="w-3 h-3 bg-orange-100 rounded"></span> Estimation</span>
                <span className="flex items-center gap-1"><span className="w-3 h-3 bg-blue-100 rounded"></span> Devis reçu</span>
                <span className="flex items-center gap-1"><span className="w-3 h-3 bg-green-100 rounded"></span> BDC émis</span>
                <span className="flex items-center gap-1"><Upload className="w-3 h-3 text-blue-500" /> Importer devis</span>
                <span className="flex items-center gap-1"><Eye className="w-3 h-3 text-indigo-600" /> Voir devis</span>
                <span className="flex items-center gap-1"><FileCheck className="w-3 h-3 text-green-600" /> Générer BDC</span>
              </div>

              {/* Section Bons de Commande */}
              <div className="mt-8 pt-6 border-t border-slate-200">
                <h4 className="text-lg font-semibold mb-4 flex items-center gap-2">
                  <FileCheck className="w-5 h-5 text-green-600" />
                  Bons de Commande
                  {bdcList.length > 0 && (
                    <span className="ml-2 px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                      {bdcList.length}
                    </span>
                  )}
                </h4>
                
                {bdcList.length > 0 ? (
                  <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
                    <table className="w-full text-sm">
                      <thead className="bg-slate-50 border-b border-slate-200">
                        <tr>
                          <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500">N° BDC</th>
                          <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500">Lot</th>
                          <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500">Fournisseur</th>
                          <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500">Montant HT</th>
                          <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500">Montant TTC</th>
                          <th className="px-3 py-2 text-center text-xs font-bold uppercase text-slate-500">Statut</th>
                          <th className="px-3 py-2 text-center text-xs font-bold uppercase text-slate-500">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {bdcList.map((bdc) => (
                          <tr key={bdc.id} className="hover:bg-slate-50">
                            <td className="px-3 py-2">
                              <span className="font-mono font-semibold text-green-700">{bdc.numero}</span>
                            </td>
                            <td className="px-3 py-2">{bdc.lot_id}. {bdc.lot_nom}</td>
                            <td className="px-3 py-2 font-medium">{bdc.entreprise}</td>
                            <td className="px-3 py-2 text-right font-mono">{formatMoney(bdc.montant_ht)}</td>
                            <td className="px-3 py-2 text-right font-mono font-semibold">{formatMoney(bdc.montant_ttc)}</td>
                            <td className="px-3 py-2 text-center">
                              {bdc.statut === 'signe' ? (
                                <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center justify-center gap-1">
                                  <Check className="w-3 h-3" />
                                  Signé
                                </span>
                              ) : (
                                <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">
                                  En attente
                                </span>
                              )}
                            </td>
                            <td className="px-3 py-2">
                              <div className="flex items-center justify-center gap-1">
                                {/* Envoyer par email */}
                                <button
                                  onClick={() => handleOpenBDCEmailModal(bdc)}
                                  className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                                  title="Envoyer par email"
                                  data-testid={`send-bdc-email-${bdc.id}`}
                                >
                                  <Send className="w-4 h-4" />
                                </button>
                                {/* Signer et Envoyer BDC */}
                                {bdc.statut !== 'signe' && (
                                  <button
                                    onClick={() => handleSignerEtEnvoyerBDC(bdc)}
                                    className="p-1 text-indigo-600 hover:bg-indigo-50 rounded"
                                    title="Signer et envoyer"
                                  >
                                    <Edit2 className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Télécharger PDF */}
                                {/* Aperçu PDF */}
                                <button
                                  onClick={() => openPdfPreview(
                                    `/projets/${projetId}/bdc/${bdc.id}/${bdc.statut === 'signe' ? 'pdf-signe' : 'pdf'}`,
                                    { title: `BDC ${bdc.numero}${bdc.statut === 'signe' ? ' (signé)' : ''}`, filename: `BDC_${bdc.numero.replace(/-/g, '_')}${bdc.statut === 'signe' ? '_SIGNE' : ''}.pdf` }
                                  )}
                                  className="p-1 text-green-600 hover:bg-green-50 rounded"
                                  title={bdc.statut === 'signe' ? "Aperçu BDC signé" : "Aperçu BDC"}
                                >
                                  <Download className="w-4 h-4" />
                                </button>
                                {/* Copier */}
                                <button
                                  onClick={async () => {
                                    const text = `Bon de Commande ${bdc.numero}\nFournisseur: ${bdc.entreprise}\nMontant TTC: ${formatMoney(bdc.montant_ttc)}\nStatut: ${bdc.statut === 'signe' ? 'SIGNÉ' : 'En attente'}`;
                                    await navigator.clipboard.writeText(text);
                                    toast.success('Copié !');
                                  }}
                                  className="p-1 text-slate-400 hover:text-purple-600 hover:bg-purple-50 rounded"
                                  title="Copier pour email"
                                >
                                  <Clipboard className="w-4 h-4" />
                                </button>
                                {/* Supprimer BDC */}
                                <button
                                  onClick={() => handleDeleteBDC(bdc)}
                                  className="p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded"
                                  title="Supprimer ce BDC"
                                  data-testid={`bdc-delete-${bdc.id}`}
                                >
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="bg-slate-100">
                        <tr>
                          <td colSpan={3} className="px-3 py-2 font-bold">TOTAL</td>
                          <td className="px-3 py-2 text-right font-mono font-bold">{formatMoney(bdcList.reduce((s, b) => s + b.montant_ht, 0))}</td>
                          <td className="px-3 py-2 text-right font-mono font-bold">{formatMoney(bdcList.reduce((s, b) => s + b.montant_ttc, 0))}</td>
                          <td colSpan={2}></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-8 bg-slate-50 rounded-lg">
                    <FileCheck className="w-10 h-10 mx-auto mb-3 text-slate-300" />
                    <p className="text-slate-500">Aucun bon de commande</p>
                    <p className="text-xs text-slate-400 mt-1">Cliquez sur <FileCheck className="w-3 h-3 inline text-green-600" /> dans le tableau ci-dessus pour générer un BDC</p>
                  </div>
                )}
              </div>
            </div>
          )}



          {/* Tab: Suivi Factures */}
          {activeTab === 'suivi_factures' && (
            <div>
              {/* Section Factures PDF with Drag & Drop */}
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-lg font-semibold flex items-center gap-2">
                      <FileCheck className="w-5 h-5 text-indigo-600" />
                      Factures PDF Artisans
                    </h3>
                    <p className="text-sm text-slate-500">Glissez-déposez vos factures PDF - l'IA extrait automatiquement les données</p>
                  </div>
                  <div className="flex gap-2">
                    {facturesArtisans.filter(f => f.statut === 'validee').length > 0 && (
                      <a
                        href={getFacturesExportUrl(projetId, 'validee')}
                        className="inline-flex items-center px-3 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                      >
                        <Package className="w-4 h-4 mr-2" />
                        Exporter ({facturesArtisans.filter(f => f.statut === 'validee').length})
                      </a>
                    )}
                  </div>
                </div>

                {/* Drag & Drop Zone */}
                <div 
                  className={`relative bg-gradient-to-r from-indigo-50 to-slate-50 rounded-xl p-6 mb-6 border-2 border-dashed transition-all ${
                    isDraggingFacture ? 'border-indigo-500 bg-indigo-100' : 'border-slate-300 hover:border-indigo-400'
                  }`}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsDraggingFacture(true);
                  }}
                  onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Only set false when actually leaving the drop zone (not entering a child)
                    if (e.currentTarget.contains(e.relatedTarget)) return;
                    setIsDraggingFacture(false);
                  }}
                  onDrop={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsDraggingFacture(false);
                    
                    const file = e.dataTransfer.files[0];
                    if (!file) return;
                    
                    if (!file.name.toLowerCase().endsWith('.pdf')) {
                      toast.error('Seuls les fichiers PDF sont acceptés');
                      return;
                    }
                    
                    // Open modal first, then let handleAnalyzeInvoice fill the fields.
                    // The user must select the Lot and confirm before saving.
                    setShowUploadFactureModal(true);
                    await handleAnalyzeInvoice(file);
                  }}
                >
                  {isDraggingFacture && (
                    <div className="absolute inset-0 bg-indigo-500/10 rounded-xl flex items-center justify-center z-10 pointer-events-none">
                      <div className="bg-white rounded-lg px-6 py-4 shadow-lg">
                        <Upload className="w-8 h-8 text-indigo-600 mx-auto mb-2" />
                        <p className="text-indigo-700 font-medium">Déposez la facture ici</p>
                      </div>
                    </div>
                  )}
                  
                  <div className="flex flex-wrap items-center gap-4">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-indigo-100 rounded-xl flex items-center justify-center">
                        <FileCheck className="w-8 h-8 text-indigo-600" />
                      </div>
                    </div>
                    
                    <div className="flex-1 min-w-[250px]">
                      <p className="font-semibold text-slate-800 mb-1">Glissez-déposez votre facture PDF ici</p>
                      <p className="text-sm text-slate-500">L'IA extrait automatiquement : artisan, n° facture, montants</p>
                    </div>
                    
                    <div className="flex items-center gap-3">
                      <label className="flex items-center justify-center gap-2 h-10 px-5 bg-indigo-600 text-white rounded-lg cursor-pointer hover:bg-indigo-700 transition-colors">
                        <Upload className="w-4 h-4" />
                        <span className="text-sm font-medium">Parcourir</span>
                        <input
                          type="file"
                          accept=".pdf"
                          className="hidden"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            e.target.value = '';

                            // Open modal first, then let the AI analysis populate
                            // the fields. The user must select the Lot and confirm.
                            setShowUploadFactureModal(true);
                            await handleAnalyzeInvoice(file);
                          }}
                        />
                      </label>
                      <button
                        onClick={() => setShowUploadFactureModal(true)}
                        className="h-10 px-4 bg-slate-200 text-slate-700 rounded-lg text-sm font-medium hover:bg-slate-300 transition-colors flex items-center gap-2"
                      >
                        <Plus className="w-4 h-4" />
                        Saisie manuelle
                      </button>
                    </div>
                  </div>
                </div>

                {facturesArtisans.length === 0 ? (
                  <div className="text-center py-8 bg-slate-50 rounded-lg">
                    <p className="text-slate-400">Aucune facture PDF uploadée</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-slate-50">
                        <tr>
                          <th className="px-3 py-3 text-left text-xs font-bold uppercase text-slate-500">Artisan</th>
                          <th className="px-3 py-3 text-left text-xs font-bold uppercase text-slate-500">N° Facture</th>
                          <th className="px-3 py-3 text-left text-xs font-bold uppercase text-slate-500">Date</th>
                          <th className="px-3 py-3 text-right text-xs font-bold uppercase text-slate-500">Montant HT</th>
                          <th className="px-3 py-3 text-right text-xs font-bold uppercase text-slate-500">Montant TTC</th>
                          <th className="px-3 py-3 text-center text-xs font-bold uppercase text-slate-500">Statut</th>
                          <th className="px-3 py-3 text-left text-xs font-bold uppercase text-slate-500">Rattachement</th>
                          <th className="px-3 py-3 text-left text-xs font-bold uppercase text-slate-500">Fichier renommé</th>
                          <th className="px-3 py-3 text-center text-xs font-bold uppercase text-slate-500">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {facturesArtisans.map((facture) => {
                          const linkedSlot = facture.parent_fournisseur_id
                            ? allFournisseurSlots.find((s) => s.id === facture.parent_fournisseur_id)
                            : null;
                          const lotInfo = facture.lot_id
                            ? allFournisseurSlots.find((s) => String(s.lot_id) === String(facture.lot_id))
                            : null;
                          const typeBadgeColor = {
                            simple: 'bg-slate-100 text-slate-700',
                            acompte: 'bg-amber-100 text-amber-800',
                            finale: 'bg-emerald-100 text-emerald-800',
                          }[facture.type_facture || 'simple'];
                          return (
                          <tr key={facture.id} className="hover:bg-slate-50">
                            <td className="px-3 py-3 font-medium">
                              <div className="flex items-center gap-2">
                                <span>{facture.artisan_nom}</span>
                                {facture.type_facture && facture.type_facture !== 'simple' && (
                                  <span className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${typeBadgeColor}`}>
                                    {facture.type_facture === 'acompte' ? 'Acompte' : 'Finale'}
                                  </span>
                                )}
                              </div>
                            </td>
                            <td className="px-3 py-3 text-slate-500">{facture.numero_facture || '-'}</td>
                            <td className="px-3 py-3 text-slate-500">{facture.date_facture || '-'}</td>
                            <td className="px-3 py-3 text-right font-mono">{formatMoney(facture.montant_ht)}</td>
                            <td className="px-3 py-3 text-right font-mono font-medium">{formatMoney(facture.montant_ttc)}</td>
                            <td className="px-3 py-3 text-center">
                              {facture.statut === 'payee' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                                  <Check className="w-3 h-3 mr-1" /> Payée
                                </span>
                              ) : facture.statut === 'validee' ? (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                                  <FileCheck className="w-3 h-3 mr-1" /> Validée
                                </span>
                              ) : (
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-700">
                                  <Clock className="w-3 h-3 mr-1" /> En attente
                                </span>
                              )}
                            </td>
                            <td className="px-3 py-3" data-testid={`rattachement-cell-${facture.id}`}>
                              <button
                                onClick={() => handleOpenReassign(facture)}
                                className="text-left text-xs hover:bg-indigo-50 px-2 py-1 rounded transition-colors group w-full"
                                title="Changer le rattachement"
                              >
                                {linkedSlot ? (
                                  <>
                                    <div className="font-semibold text-emerald-700 group-hover:text-indigo-700 flex items-center gap-1">
                                      <Check className="w-3 h-3" />
                                      <span>Lot {linkedSlot.lot_id}</span>
                                      <Edit2 className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                                    </div>
                                    <div className="text-slate-600 truncate max-w-[140px]">
                                      {linkedSlot.entreprise || '—'}
                                    </div>
                                  </>
                                ) : facture.lot_id ? (
                                  <>
                                    <div className="font-semibold text-indigo-700 group-hover:text-indigo-800 flex items-center gap-1">
                                      <span>Lot {facture.lot_id}</span>
                                      <Edit2 className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                                    </div>
                                    <div className="text-slate-500 text-[10px]">Lot uniquement</div>
                                  </>
                                ) : (
                                  <span className="text-amber-600 italic flex items-center gap-1 font-medium">
                                    À rattacher
                                    <Edit2 className="w-3 h-3 opacity-0 group-hover:opacity-100" />
                                  </span>
                                )}
                              </button>
                            </td>
                            <td className="px-3 py-3">
                              <span className="text-xs font-mono bg-slate-100 px-2 py-1 rounded truncate max-w-[200px] block">
                                {facture.fichier_renomme}
                              </span>
                            </td>
                            <td className="px-3 py-3 text-center">
                              <div className="flex items-center justify-center gap-1">
                                {/* Voir le PDF */}
                                <a
                                  href={getFactureDownloadUrl(facture.id)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded"
                                  title="Voir le PDF"
                                >
                                  <Eye className="w-4 h-4" />
                                </a>
                                {/* Télécharger */}
                                <a
                                  href={getFactureDownloadUrl(facture.id)}
                                  download
                                  className="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded"
                                  title="Télécharger (renommé)"
                                >
                                  <Download className="w-4 h-4" />
                                </a>
                                {/* Valider */}
                                {facture.statut === 'en_attente' && (
                                  <button
                                    onClick={() => handleValidateFacture(facture.id)}
                                    className="p-1.5 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded"
                                    title="Valider pour paiement"
                                  >
                                    <FileCheck className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Marquer payée */}
                                {facture.statut === 'validee' && (
                                  <button
                                    onClick={() => handlePayFacture(facture.id)}
                                    className="p-1.5 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded"
                                    title="Marquer comme payée"
                                  >
                                    <Check className="w-4 h-4" />
                                  </button>
                                )}
                                {/* Supprimer */}
                                {facture.statut !== 'payee' && (
                                  <button
                                    onClick={() => handleDeleteFacture(facture.id)}
                                    className="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded"
                                    title="Supprimer"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    {/* Summary factures */}
                    <div className="mt-4 grid grid-cols-3 gap-4">
                      <div className="bg-amber-50 rounded-lg p-3 text-center">
                        <p className="text-xs text-amber-600 mb-1">En attente</p>
                        <p className="text-lg font-bold text-amber-700">
                          {formatMoney(facturesArtisans.filter(f => f.statut === 'en_attente').reduce((s, f) => s + f.montant_ht, 0))}
                        </p>
                        <p className="text-xs text-amber-500">{facturesArtisans.filter(f => f.statut === 'en_attente').length} facture(s)</p>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-3 text-center">
                        <p className="text-xs text-blue-600 mb-1">Validées (à payer)</p>
                        <p className="text-lg font-bold text-blue-700">
                          {formatMoney(facturesArtisans.filter(f => f.statut === 'validee').reduce((s, f) => s + f.montant_ht, 0))}
                        </p>
                        <p className="text-xs text-blue-500">{facturesArtisans.filter(f => f.statut === 'validee').length} facture(s)</p>
                      </div>
                      <div className="bg-green-50 rounded-lg p-3 text-center">
                        <p className="text-xs text-green-600 mb-1">Payées</p>
                        <p className="text-lg font-bold text-green-700">
                          {formatMoney(facturesArtisans.filter(f => f.statut === 'payee').reduce((s, f) => s + f.montant_ht, 0))}
                        </p>
                        <p className="text-xs text-green-500">{facturesArtisans.filter(f => f.statut === 'payee').length} facture(s)</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Tab: Infos Projet */}
          {activeTab === 'infos' && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Informations du projet</h3>
              <MagasinHistorique projetId={projetId} />
              
              {/* Section 1: Adresse du Projet */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <h4 className="text-sm font-bold text-blue-800 uppercase mb-3 flex items-center">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-2"></span>
                  Adresse du Projet (Chantier)
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Ville *</label>
                    <input
                      type="text"
                      value={projet.ville || ''}
                      onChange={(e) => handleFieldChange('ville', e.target.value)}
                      disabled={projet.is_cloture}
                      placeholder="Lyon Confluence"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Adresse du chantier</label>
                    <input
                      type="text"
                      value={projet.adresse || ''}
                      onChange={(e) => handleFieldChange('adresse', e.target.value)}
                      disabled={projet.is_cloture}
                      placeholder="Centre Commercial Confluence, 69002 Lyon"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-100"
                    />
                  </div>
                </div>
              </div>

              {/* Section 2: Facturation (spécifique au projet) */}
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                <h4 className="text-sm font-bold text-amber-800 uppercase mb-1 flex items-center">
                  <span className="w-2 h-2 bg-amber-600 rounded-full mr-2"></span>
                  Facturation du Projet
                </h4>
                <p className="text-xs text-amber-600 mb-4">Ces informations apparaissent sur le devis PDF</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Nom du client (raison sociale) *</label>
                    <input
                      type="text"
                      value={projet.client_facturation || ''}
                      onChange={(e) => handleFieldChange('client_facturation', e.target.value)}
                      disabled={projet.is_cloture}
                      placeholder="ADOPT SAS / Franchisé X"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Adresse de facturation *</label>
                    <input
                      type="text"
                      value={projet.adresse_facturation || ''}
                      onChange={(e) => handleFieldChange('adresse_facturation', e.target.value)}
                      disabled={projet.is_cloture}
                      placeholder="123 Rue du Commerce, 75001 Paris"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Contact facturation</label>
                    <input
                      type="text"
                      value={projet.contact_facturation || ''}
                      onChange={(e) => handleFieldChange('contact_facturation', e.target.value)}
                      disabled={projet.is_cloture}
                      placeholder="Jean DUPONT - Directeur"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-100"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Téléphone</label>
                      <input
                        type="tel"
                        value={projet.telephone_facturation || ''}
                        onChange={(e) => handleFieldChange('telephone_facturation', e.target.value)}
                        disabled={projet.is_cloture}
                        placeholder="01 23 45 67 89"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-100"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                      <input
                        type="email"
                        value={projet.email_facturation || ''}
                        onChange={(e) => handleFieldChange('email_facturation', e.target.value)}
                        disabled={projet.is_cloture}
                        placeholder="contact@client.fr"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:bg-slate-100"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3: Planning & Surfaces */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left - Planning */}
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
                  <h4 className="text-sm font-bold text-slate-700 uppercase mb-3">Planning</h4>
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Date début</label>
                        <input
                          type="date"
                          value={projet.date_debut || ''}
                          data-testid="projet-detail-date-debut"
                          onChange={(e) => {
                            const d = e.target.value;
                            handleFieldChange('date_debut', d);
                            if (d && (!projet.date_fin || projet.date_fin < d)) handleFieldChange('date_fin', d);
                          }}
                          disabled={projet.is_cloture}
                          className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-700 mb-1">Date fin</label>
                        <input
                          type="date"
                          value={projet.date_fin || ''}
                          min={projet.date_debut || undefined}
                          data-testid="projet-detail-date-fin"
                          onChange={(e) => handleFieldChange('date_fin', e.target.value)}
                          disabled={projet.is_cloture}
                          className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Durée estimée</label>
                      <p className="h-10 px-3 flex items-center text-slate-600 bg-white border border-slate-200 rounded-lg">
                        {calculateDuration()}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Responsable MAAG</label>
                      <input
                        type="text"
                        value={projet.responsable || ''}
                        onChange={(e) => handleFieldChange('responsable', e.target.value)}
                        disabled={projet.is_cloture}
                        placeholder="Nom du responsable"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Right - Surfaces */}
                <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
                  <h4 className="text-sm font-bold text-slate-700 uppercase mb-3">Surfaces</h4>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Surface commerciale (m²)</label>
                      <input
                        type="number"
                        value={projet.surface_commerciale || ''}
                        onChange={(e) => handleFieldChange('surface_commerciale', parseFloat(e.target.value) || 0)}
                        disabled={projet.is_cloture}
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Surface annexes (m²)</label>
                      <input
                        type="number"
                        value={projet.surface_annexes || ''}
                        onChange={(e) => handleFieldChange('surface_annexes', parseFloat(e.target.value) || 0)}
                        disabled={projet.is_cloture}
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Surface totale</label>
                      <p className="h-10 px-3 flex items-center font-semibold text-slate-900 bg-white border border-slate-200 rounded-lg">
                        {((projet.surface_commerciale || 0) + (projet.surface_annexes || 0)).toLocaleString('fr-FR')} m²
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Comments */}
              <div className="mt-6">
                <label className="block text-sm font-medium text-slate-700 mb-1">Commentaires</label>
                <textarea
                  value={projet.commentaires || ''}
                  onChange={(e) => handleFieldChange('commentaires', e.target.value)}
                  disabled={projet.is_cloture}
                  rows={3}
                  placeholder="Notes sur le projet..."
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 disabled:bg-slate-100"
                />
              </div>
            </div>
          )}

          {/* Tab: Visites (Comptes-rendus) */}
          {activeTab === 'visites' && (
            <div>
              <ComptesRendusTab projetId={projetId} projet={projet} />
            </div>
          )}

          {/* Tab: Serveur */}
          {activeTab === 'serveur' && (
            <div data-testid="serveur-tab">
              <ProjectFileManager 
                projetId={projetId} 
                projetName={`${projet?.enseigne_nom || 'Projet'}_${projet?.ville || ''}`}
              />
            </div>
          )}
        </div>
      </div>

      {/* Modal: Nouveau Devis */}
      {showNewDevisModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden flex flex-col" data-testid="new-devis-modal">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Nouveau Devis</h2>
                <p className="text-sm text-slate-500">Projet: {projet?.enseigne_nom} - {projet?.ville}</p>
              </div>
              <button 
                onClick={() => { setShowNewDevisModal(false); setNewDevisObjet(''); setCreateMode('vide'); setSelectedSourceDevis(null); }}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-6 space-y-4 overflow-y-auto flex-1">
              {/* Toggle: Vide / Modèle / Copier */}
              <div className="flex gap-1 p-1 bg-slate-100 rounded-lg">
                <button
                  onClick={() => { setCreateMode('vide'); setSelectedSourceDevis(null); }}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${createMode === 'vide' ? 'bg-white text-slate-900 shadow' : 'text-slate-600 hover:text-slate-900'}`}
                >
                  Devis vide
                </button>
                {availableDevisTypes.length > 0 && (
                  <button
                    onClick={() => { setCreateMode('modele'); setSelectedSourceDevis(null); }}
                    className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${createMode === 'modele' ? 'bg-white text-slate-900 shadow' : 'text-slate-600 hover:text-slate-900'}`}
                  >
                    Depuis un modèle
                  </button>
                )}
                <button
                  onClick={() => { setCreateMode('copier'); loadDevisForCopy(copyFilter); }}
                  className={`flex-1 py-2 px-3 rounded-md text-sm font-medium transition-all ${createMode === 'copier' ? 'bg-white text-slate-900 shadow' : 'text-slate-600 hover:text-slate-900'}`}
                >
                  Copier un existant
                </button>
              </div>

              {/* Mode modèle : sélection du type */}
              {createMode === 'modele' && (
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-slate-700">Sélectionner un modèle</label>
                  <div className="space-y-2">
                    {availableDevisTypes.map(type => (
                      <button
                        key={type.code}
                        onClick={() => {
                          handleAddDevisType(type.code);
                          setShowNewDevisModal(false);
                        }}
                        disabled={addingDevisType}
                        className="w-full p-4 text-left border-2 border-slate-200 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition-all disabled:opacity-50"
                      >
                        <p className="font-medium text-slate-900">{type.nom}</p>
                        <p className="text-xs text-slate-500 mt-1">
                          Créer un devis pré-rempli avec le modèle "{type.nom}"
                        </p>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Objet du devis (pour vide et copie) */}
              {createMode !== 'modele' && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Objet du devis *
                  </label>
                  <div className="flex items-stretch rounded-lg border border-slate-300 bg-white focus-within:ring-2 focus-within:ring-slate-900 overflow-hidden">
                    <span className="flex items-center px-3 text-sm font-semibold text-slate-600 bg-slate-100 border-r border-slate-200 whitespace-nowrap" data-testid="new-devis-objet-prefix">{objetPrefix()}</span>
                    <input
                      type="text"
                      value={newDevisObjet}
                      onChange={(e) => setNewDevisObjet(e.target.value)}
                      placeholder="Ex: MAINTENANCE, CRÉATION MAGASIN…"
                      className="flex-1 h-10 px-3 text-sm uppercase focus:outline-none min-w-0"
                      autoFocus
                      data-testid="new-devis-objet-input"
                    />
                  </div>
                  <p className="text-xs text-slate-500 mt-1" data-testid="new-devis-objet-preview">Nom final : <b>{formatObjet(newDevisObjet || '…')}</b></p>
                  {createMode === 'copier' && selectedSourceDevis && selectedSourceDevis.projet_id !== projet?.id && (
                    <p className="text-xs text-slate-500 mt-1" data-testid="new-devis-objet-hint">
                      Objet adapté à ce projet (l'original était « {selectedSourceDevis.objet} »). Vous pouvez le modifier librement.
                    </p>
                  )}
                </div>
              )}

              {/* Mode copie : sélection du devis source */}
              {createMode === 'copier' && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Filtrer</label>
                    <div className="flex gap-2">
                      <button
                        onClick={() => { setCopyFilter('same_enseigne'); loadDevisForCopy('same_enseigne'); }}
                        className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium border transition-all ${copyFilter === 'same_enseigne' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`}
                      >
                        Même enseigne ({projet?.enseigne_nom})
                      </button>
                      <button
                        onClick={() => { setCopyFilter('all'); loadDevisForCopy('all'); }}
                        className={`flex-1 py-2 px-3 rounded-lg text-sm font-medium border transition-all ${copyFilter === 'all' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-slate-200 text-slate-600 hover:border-slate-300'}`}
                      >
                        Tous les projets
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Sélectionner le devis à copier</label>
                    {/* Barre de recherche */}
                    <input
                      type="text"
                      value={copySearchQuery}
                      onChange={(e) => setCopySearchQuery(e.target.value)}
                      placeholder="Rechercher (ex: adopt lyon)..."
                      className="w-full h-10 px-3 mb-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      data-testid="copy-devis-search"
                    />
                    {loadingDevisForCopy ? (
                      <div className="flex items-center justify-center py-8">
                        <div className="w-6 h-6 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
                      </div>
                    ) : availableDevisForCopy.length === 0 ? (
                      <div className="text-center py-8 text-slate-500 text-sm">Aucun devis disponible</div>
                    ) : (() => {
                      // Filter by search query
                      const q = copySearchQuery.trim().toLowerCase();
                      const filtered = q ? availableDevisForCopy.filter(d =>
                        (d.projet_nom || '').toLowerCase().includes(q) ||
                        (d.objet || '').toLowerCase().includes(q) ||
                        (d.enseigne_nom || '').toLowerCase().includes(q)
                      ) : availableDevisForCopy;
                      // Group by enseigne
                      const byEnseigne = {};
                      filtered.forEach(d => {
                        const ens = d.enseigne_nom || 'Sans enseigne';
                        if (!byEnseigne[ens]) byEnseigne[ens] = [];
                        byEnseigne[ens].push(d);
                      });
                      const enseignes = Object.keys(byEnseigne).sort();
                      // If search active OR only 1 enseigne, auto-expand
                      const autoExpand = q.length > 0 || enseignes.length === 1;
                      return (
                        <div className="max-h-80 overflow-y-auto space-y-1 border border-slate-200 rounded-lg p-2">
                          {enseignes.length === 0 && (
                            <p className="text-center text-slate-400 text-sm py-4">Aucun résultat pour "{copySearchQuery}"</p>
                          )}
                          {enseignes.map((ens) => {
                            const isOpen = autoExpand || !!expandedEnseignesInCopy[ens];
                            return (
                              <div key={ens} className="border border-slate-100 rounded-lg overflow-hidden">
                                <button
                                  onClick={() => setExpandedEnseignesInCopy(p => ({ ...p, [ens]: !p[ens] }))}
                                  className="w-full px-3 py-2 flex items-center justify-between bg-slate-50 hover:bg-slate-100 text-left"
                                  data-testid={`copy-enseigne-toggle-${ens}`}
                                >
                                  <span className="text-sm font-semibold text-slate-800">{ens}</span>
                                  <span className="text-xs text-slate-500">{byEnseigne[ens].length} devis · {isOpen ? '▾' : '▸'}</span>
                                </button>
                                {isOpen && (
                                  <div className="p-1 space-y-1 bg-white">
                                    {byEnseigne[ens].map((devis) => (
                                      <button
                                        key={devis.id}
                                        onClick={() => {
                                          setSelectedSourceDevis(devis);
                                          // Objet adapté au projet courant (sauf si l'utilisateur a saisi le sien)
                                          const suggestion = adaptObjetToProjet(devis);
                                          if (!newDevisObjet.trim() || newDevisObjet === suggestedObjet) {
                                            setNewDevisObjet(suggestion);
                                          }
                                          setSuggestedObjet(suggestion);
                                        }}
                                        className={`w-full p-2.5 text-left rounded-md border transition-all ${selectedSourceDevis?.id === devis.id ? 'border-blue-500 bg-blue-50' : 'border-slate-100 hover:border-slate-300 hover:bg-slate-50'}`}
                                        data-testid={`copy-devis-option-${devis.id}`}
                                      >
                                        <div className="flex items-start justify-between gap-2">
                                          <div className="flex-1 min-w-0">
                                            <p className="font-medium text-slate-900 text-sm truncate">{devis.projet_nom}</p>
                                            <p className="text-xs text-slate-500 truncate mt-0.5">{devis.objet}</p>
                                          </div>
                                          <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded shrink-0">{devis.postes_count} postes</span>
                                        </div>
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </div>
                  {selectedSourceDevis && (
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                      <p className="text-sm text-green-800">
                        <strong>Devis sélectionné :</strong> {selectedSourceDevis.projet_nom} - {selectedSourceDevis.objet}
                      </p>
                    </div>
                  )}
                </>
              )}
              
              {createMode === 'vide' && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                  <p className="text-sm text-blue-800">
                    Le devis sera pré-rempli avec les prestations de la Base MAAG et les prix de l'enseigne <strong>{projet?.enseigne_nom}</strong>.
                  </p>
                </div>
              )}
            </div>

            {createMode !== 'modele' && (
              <div className="flex gap-3 p-6 border-t border-slate-200 bg-slate-50 rounded-b-xl">
                <button
                  type="button"
                  onClick={() => { setShowNewDevisModal(false); setNewDevisObjet(''); setCreateMode('vide'); setSelectedSourceDevis(null); }}
                  className="flex-1 h-10 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white transition-colors"
                >
                  Annuler
                </button>
                <button
                  onClick={handleCreateDevis}
                  disabled={creatingDevis || !newDevisObjet.trim() || (createMode === 'copier' && !selectedSourceDevis)}
                  className="flex-1 h-10 bg-slate-900 text-white rounded-lg font-medium hover:bg-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                  data-testid="create-devis-submit"
                >
                  {creatingDevis ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
                      {createMode === 'copier' ? 'Copie...' : 'Création...'}
                    </>
                  ) : (
                    createMode === 'copier' ? 'Copier le devis' : 'Créer le devis'
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal - Upload Facture Artisan */}
      {showUploadFactureModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Ajouter une facture artisan</h2>
                <p className="text-sm text-slate-500">
                  {!selectedFile 
                    ? "Sélectionnez un PDF - l'IA analysera automatiquement" 
                    : "Vérifiez les données extraites et enregistrez"}
                </p>
              </div>
              <button 
                onClick={() => {
                  setShowUploadFactureModal(false);
                  setSelectedFile(null);
                  setNewFacture({
                    artisan_nom: '',
                    montant_ht: '',
                    montant_ttc: '',
                    date_facture: '',
                    numero_facture: '',
                    achat_artisan_id: '',
                    lot_id: '',
                    commentaire: ''
                  });
                }}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-6 space-y-4">
              {/* File upload zone */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  Fichier PDF * {selectedFile && <span className="text-green-600">✓ {selectedFile.name}</span>}
                </label>
                {!selectedFile ? (
                  <div 
                    onClick={() => !analyzingInvoice && fileInputRef.current?.click()}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-all ${
                      analyzingInvoice 
                        ? 'border-indigo-400 bg-indigo-50' 
                        : isDragging
                          ? 'border-indigo-500 bg-indigo-100 scale-[1.02]'
                          : 'border-slate-300 hover:border-indigo-500 hover:bg-indigo-50'
                    }`}
                  >
                    {analyzingInvoice ? (
                      <>
                        <div className="w-10 h-10 mx-auto mb-3 border-3 border-indigo-600 border-t-transparent rounded-full animate-spin" />
                        <p className="text-sm text-indigo-600 font-medium">Analyse IA en cours...</p>
                        <p className="text-xs text-indigo-500 mt-1">Extraction des données de la facture</p>
                      </>
                    ) : isDragging ? (
                      <>
                        <Upload className="w-10 h-10 mx-auto mb-3 text-indigo-500 animate-bounce" />
                        <p className="text-sm text-indigo-600 font-medium">Déposez le fichier ici</p>
                      </>
                    ) : (
                      <>
                        <Upload className="w-10 h-10 mx-auto mb-3 text-slate-400" />
                        <p className="text-sm text-slate-600 font-medium">Glissez-déposez votre PDF ici</p>
                        <p className="text-xs text-slate-400 mt-2">ou cliquez pour sélectionner un fichier</p>
                        <p className="text-xs text-indigo-500 mt-3 font-medium">L'IA analysera automatiquement la facture</p>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="flex items-center gap-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                    <FileCheck className="w-6 h-6 text-green-600" />
                    <div className="flex-1">
                      <p className="text-sm font-medium text-green-800">{selectedFile.name}</p>
                      <p className="text-xs text-green-600">Fichier prêt - vérifiez les données ci-dessous</p>
                    </div>
                    <button
                      onClick={() => {
                        setSelectedFile(null);
                        setFactureTvaWarning(false);
                        setFactureTvaAccepted(false);
                        setFactureDetectedType(null);
                        setNewFacture({
                          artisan_nom: '',
                          montant_ht: '',
                          montant_ttc: '',
                          date_facture: '',
                          numero_facture: '',
                          achat_artisan_id: '',
                          lot_id: '',
                          commentaire: ''
                        });
                      }}
                      className="p-1 text-slate-400 hover:text-red-600"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                )}
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".pdf"
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      handleAnalyzeInvoice(file);
                    }
                  }}
                />
              </div>

              {/* Extracted/Editable fields - only show after file selected */}
              {(selectedFile || analyzingInvoice) && (
                <>
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                    <p className="text-xs text-blue-700 flex items-center gap-1">
                      <Info className="w-3 h-3" />
                      Données extraites par l'IA - vérifiez et corrigez si nécessaire
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Nom artisan *</label>
                      <input
                        type="text"
                        value={newFacture.artisan_nom}
                        onChange={(e) => setNewFacture({ ...newFacture, artisan_nom: e.target.value })}
                        placeholder="Ex: DURAND Électricité"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">
                        Lot du projet <span className="text-xs text-slate-500 font-normal">(pour rattachement à la Marge)</span>
                      </label>
                      <select
                        value={newFacture.lot_id || ''}
                        onChange={(e) => setNewFacture({ ...newFacture, lot_id: e.target.value })}
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white"
                        data-testid="facture-lot-select"
                      >
                        <option value="">— Non rattaché —</option>
                        {lots.map((lot) => (
                          <option key={lot.lot_id || lot.id} value={String(lot.lot_id || lot.id)}>
                            Lot {lot.lot_id || lot.id} — {lot.nom}
                          </option>
                        ))}
                        <option value="frais_generaux">🧾 Frais Général (timbre, repas, CB…)</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">N° Facture</label>
                    <input
                      type="text"
                      value={newFacture.numero_facture}
                      onChange={(e) => setNewFacture({ ...newFacture, numero_facture: e.target.value })}
                      placeholder="Ex: FAC-2026-001"
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Montant HT *</label>
                      <input
                        type="number"
                        step="0.01"
                        value={newFacture.montant_ht}
                        onChange={(e) => setNewFacture({ ...newFacture, montant_ht: e.target.value })}
                        placeholder="1500.00"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Montant TTC</label>
                      <input
                        type="number"
                        step="0.01"
                        value={newFacture.montant_ttc}
                        onChange={(e) => setNewFacture({ ...newFacture, montant_ttc: e.target.value })}
                        placeholder="Auto (HT x 1.2)"
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Date facture</label>
                      <input
                        type="date"
                        value={newFacture.date_facture}
                        onChange={(e) => setNewFacture({ ...newFacture, date_facture: e.target.value })}
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                  </div>

                  {/* Link to achat artisan */}
                  {achatsArtisans.length > 0 && (
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1">Lier à un achat artisan (optionnel)</label>
                      <select
                        value={newFacture.achat_artisan_id}
                        onChange={(e) => setNewFacture({ ...newFacture, achat_artisan_id: e.target.value })}
                        className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                        <option value="">-- Aucun --</option>
                        {achatsArtisans.map(achat => (
                          <option key={achat.id} value={achat.id}>
                            {achat.entreprise} - {achat.description} ({formatMoney(achat.montant_ht)})
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-2">Type de facture</label>
                    <div className="grid grid-cols-3 gap-2" data-testid="facture-type-radios">
                      {[
                        { value: 'simple', label: 'Simple', desc: 'Pas de devis associé' },
                        { value: 'acompte', label: 'Acompte / Situation', desc: 'Cumul ≤ devis' },
                        { value: 'finale', label: 'Facture finale', desc: 'Remplace le devis' },
                      ].map((opt) => (
                        <label
                          key={opt.value}
                          className={`flex flex-col gap-1 p-2 border-2 rounded-lg cursor-pointer transition-all ${
                            newFacture.type_facture === opt.value
                              ? 'border-indigo-500 bg-indigo-50'
                              : 'border-slate-200 hover:border-slate-300'
                          }`}
                        >
                          <div className="flex items-center gap-1">
                            <input
                              type="radio"
                              name="type-facture"
                              checked={newFacture.type_facture === opt.value}
                              onChange={() => setNewFacture({ ...newFacture, type_facture: opt.value })}
                              className="w-3 h-3"
                            />
                            <span className="text-xs font-semibold">{opt.label}</span>
                          </div>
                          <span className="text-[10px] text-slate-500">{opt.desc}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Commentaire</label>
                    <input
                      type="text"
                      value={newFacture.commentaire}
                      onChange={(e) => setNewFacture({ ...newFacture, commentaire: e.target.value })}
                      placeholder="Note optionnelle..."
                      className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                  </div>

                  {/* Preview renamed filename */}
                  {newFacture.artisan_nom && newFacture.montant_ht && (
                    <div className="bg-slate-50 rounded-lg p-3">
                      <p className="text-xs text-slate-500 mb-1">Aperçu du nom de fichier renommé :</p>
                      <p className="text-sm font-mono text-indigo-600">
                        {projet?.enseigne_nom?.replace(/[^a-zA-Z0-9]/g, '_')}_{projet?.ville?.replace(/[^a-zA-Z0-9]/g, '_')}_{newFacture.artisan_nom.replace(/[^a-zA-Z0-9]/g, '_')}_{Math.round(parseFloat(newFacture.montant_ht) || 0)}EUR.pdf
                      </p>
                    </div>
                  )}

                  {/* TVA Warning : sous-traitance détectée mais TVA présente */}
                  {factureTvaWarning && (
                    <div
                      className="bg-red-50 border-2 border-red-400 rounded-lg p-4 space-y-3"
                      data-testid="facture-tva-warning"
                    >
                      <div className="flex items-start gap-2">
                        <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                        <div>
                          <p className="text-sm font-bold text-red-800">
                            ⚠️ Anomalie TVA détectée
                          </p>
                          <p className="text-xs text-red-700 mt-1">
                            L'IA a identifié cette prestation comme de la <b>sous-traitance BTP</b>, mais
                            la facture comporte de la <b>TVA</b>. L'artisan aurait dû facturer en autoliquidation
                            (sans TVA, art. 283-2 nonies du CGI).
                          </p>
                        </div>
                      </div>
                      <label className="flex items-start gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={factureTvaAccepted}
                          onChange={(e) => setFactureTvaAccepted(e.target.checked)}
                          className="mt-0.5"
                          data-testid="facture-tva-accept-checkbox"
                        />
                        <span className="text-xs text-red-800">
                          Je suis au courant et je souhaite quand même enregistrer cette facture avec TVA.
                        </span>
                      </label>
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="p-6 border-t border-slate-200 bg-slate-50 rounded-b-xl flex gap-3">
              <button
                type="button"
                onClick={() => {
                  setShowUploadFactureModal(false);
                  setSelectedFile(null);
                }}
                className="flex-1 h-10 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white transition-colors"
              >
                Annuler
              </button>
              {selectedFile && (
                <button
                  type="button"
                  onClick={handleSaveFacture}
                  disabled={uploadingFacture || !newFacture.artisan_nom || !newFacture.montant_ht || (factureTvaWarning && !factureTvaAccepted)}
                  data-testid="facture-save-btn"
                  className="flex-1 h-10 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  {uploadingFacture ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Enregistrement...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4" />
                      Enregistrer la facture
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de sélection de lot pour devis fournisseur analysé */}
      {showLotSelectionModal && analyzedDevisData && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-lg mx-4">
            <div className="p-6 border-b border-slate-200">
              <h3 className="text-lg font-bold flex items-center gap-2">
                <FileCheck className="w-5 h-5 text-indigo-600" />
                Devis fournisseur analysé
              </h3>
              <p className="text-sm text-slate-500 mt-1">Vérifiez les données extraites et sélectionnez le lot</p>
            </div>
            
            <div className="p-6 space-y-4">
              {/* Données extraites */}
              <div className="bg-indigo-50 rounded-lg p-4 space-y-3">
                <div>
                  <label className="text-xs font-medium text-indigo-600">Entreprise</label>
                  <input
                    type="text"
                    value={analyzedDevisData.entreprise || ''}
                    onChange={(e) => setAnalyzedDevisData({...analyzedDevisData, entreprise: e.target.value})}
                    className="w-full mt-1 px-3 py-2 border border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label className="text-xs font-medium text-indigo-600">Montant HT</label>
                  <input
                    type="number"
                    value={analyzedDevisData.montant_ht || ''}
                    onChange={(e) => setAnalyzedDevisData({...analyzedDevisData, montant_ht: parseFloat(e.target.value) || 0})}
                    className="w-full mt-1 px-3 py-2 border border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 font-mono"
                  />
                </div>
                {analyzedDevisData.description && (
                  <div>
                    <label className="text-xs font-medium text-indigo-600">Description</label>
                    <p className="text-sm text-slate-700 mt-1">{analyzedDevisData.description}</p>
                  </div>
                )}
                {(analyzedDevisData.reference_devis || analyzedDevisData.date_devis) && (
                  <div className="flex gap-4">
                    {analyzedDevisData.reference_devis && (
                      <div className="flex-1">
                        <label className="text-xs font-medium text-indigo-600">Réf. Devis</label>
                        <input
                          type="text"
                          value={analyzedDevisData.reference_devis || ''}
                          onChange={(e) => setAnalyzedDevisData({...analyzedDevisData, reference_devis: e.target.value})}
                          className="w-full mt-1 px-3 py-2 border border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 font-mono text-sm"
                        />
                      </div>
                    )}
                    {analyzedDevisData.date_devis && (
                      <div className="flex-1">
                        <label className="text-xs font-medium text-indigo-600">Date Devis</label>
                        <input
                          type="text"
                          value={analyzedDevisData.date_devis || ''}
                          onChange={(e) => setAnalyzedDevisData({...analyzedDevisData, date_devis: e.target.value})}
                          className="w-full mt-1 px-3 py-2 border border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              
              {/* Sélection du lot */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Affecter au lot</label>
                <select
                  value={selectedLotForDevis}
                  onChange={(e) => setSelectedLotForDevis(e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  data-testid="analyzed-devis-lot-select"
                >
                  <option value="">-- Sélectionnez un lot --</option>
                  {/* Prefer margeData.marges_par_lot (always populated on Marge tab) then fall back to lots */}
                  {(() => {
                    const source =
                      (margeData?.marges_par_lot?.length
                        ? margeData.marges_par_lot.map((m) => ({ id: String(m.lot_id), nom: m.lot_nom }))
                        : null) ||
                      (lots?.length ? lots.map((l) => ({ id: String(l.id), nom: l.nom })) : []);
                    return source.map((lot) => (
                      <option key={lot.id} value={lot.id}>{lot.id}. {lot.nom}</option>
                    ));
                  })()}
                </select>
                {!margeData?.marges_par_lot?.length && !lots?.length && (
                  <p className="text-xs text-red-600 mt-1">
                    ⚠ Aucun lot disponible. Rafraîchis la page (Ctrl+Shift+R) puis réessaie.
                  </p>
                )}
              </div>
              
              {/* Sélection du slot */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Position fournisseur</label>
                <div className="flex gap-2">
                  {[1, 2, 3].map((slot) => (
                    <button
                      key={slot}
                      onClick={() => setSelectedSlotForDevis(slot)}
                      className={`flex-1 py-2 rounded-lg text-sm font-medium transition-colors ${
                        selectedSlotForDevis === slot
                          ? 'bg-indigo-600 text-white'
                          : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                      }`}
                    >
                      Fournisseur {slot}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="p-6 border-t border-slate-200 flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowLotSelectionModal(false);
                  setAnalyzedDevisData(null);
                  setSelectedLotForDevis('');
                  setSelectedSlotForDevis(1);
                }}
                className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-lg"
              >
                Annuler
              </button>
              <button
                onClick={async () => {
                  if (!selectedLotForDevis) {
                    toast.error('Veuillez sélectionner un lot');
                    return;
                  }
                  try {
                    await createFournisseurFromAnalysis(projetId, {
                      lot_id: selectedLotForDevis,
                      entreprise: analyzedDevisData.entreprise,
                      montant_ht: analyzedDevisData.montant_ht,
                      temp_filename: analyzedDevisData.temp_filename,
                      slot: selectedSlotForDevis,
                      reference_devis: analyzedDevisData.reference_devis || '',
                      date_devis: analyzedDevisData.date_devis || ''
                    });
                    toast.success('Devis fournisseur ajouté !');
                    setShowLotSelectionModal(false);
                    setAnalyzedDevisData(null);
                    setSelectedLotForDevis('');
                    setSelectedSlotForDevis(1);
                    loadData();
                  } catch (err) {
                    toast.error(err.response?.data?.detail || 'Erreur lors de l\'ajout');
                  }
                }}
                disabled={!selectedLotForDevis}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                <Check className="w-4 h-4" />
                Valider
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal BDC Email (like Descriptif Artisans) */}
      {showBDCEmailModal && bdcToEmail && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white rounded-xl w-full max-w-2xl mx-4 my-8 shadow-2xl">
            <div className="p-6 border-b border-slate-200 bg-blue-50">
              <h3 className="text-lg font-semibold text-blue-900 flex items-center gap-2">
                <Mail className="w-5 h-5" />
                Envoyer le BDC par email
              </h3>
              <p className="text-sm text-blue-700">BDC {bdcToEmail.numero} • {bdcToEmail.entreprise}</p>
            </div>
            
            <div className="p-6 space-y-4 max-h-[60vh] overflow-y-auto">
              {/* Destinataire avec sélection contact */}
              <div className="grid grid-cols-2 gap-4">
                <div className="relative">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nom du fournisseur *</label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={bdcEmailForm.nom_fournisseur}
                      onChange={(e) => setBdcEmailForm({...bdcEmailForm, nom_fournisseur: e.target.value})}
                      onBlur={handleUpdateBDCEmailPreview}
                      className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                      placeholder="Nom du contact..."
                      data-testid="bdc-email-nom-input"
                    />
                    <button
                      type="button"
                      onClick={() => setShowBdcContactPicker(true)}
                      className="px-3 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition flex items-center gap-1"
                      title="Choisir un contact"
                    >
                      <BookUser className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Email du fournisseur *</label>
                  <input
                    type="email"
                    value={bdcEmailForm.email_fournisseur}
                    onChange={(e) => setBdcEmailForm({...bdcEmailForm, email_fournisseur: e.target.value})}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                    placeholder="fournisseur@email.com"
                    data-testid="bdc-email-input"
                  />
                </div>
              </div>

              {/* Mode vouvoiement/tutoiement */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Ton de l'email</label>
                <div className="flex gap-4">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="bdc_vouvoiement"
                      checked={bdcEmailForm.mode_vouvoiement}
                      onChange={() => {
                        setBdcEmailForm({...bdcEmailForm, mode_vouvoiement: true});
                        setTimeout(handleUpdateBDCEmailPreview, 100);
                      }}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm">Vouvoiement (formel)</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name="bdc_vouvoiement"
                      checked={!bdcEmailForm.mode_vouvoiement}
                      onChange={() => {
                        setBdcEmailForm({...bdcEmailForm, mode_vouvoiement: false});
                        setTimeout(handleUpdateBDCEmailPreview, 100);
                      }}
                      className="w-4 h-4 text-blue-600"
                    />
                    <span className="text-sm">Tutoiement (informel)</span>
                  </label>
                </div>
              </div>

              {/* Objet */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Objet de l'email</label>
                <input
                  type="text"
                  value={bdcEmailForm.objet}
                  onChange={(e) => setBdcEmailForm({...bdcEmailForm, objet: e.target.value})}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                  placeholder="Objet de l'email..."
                />
              </div>

              {/* Corps du message */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Corps de l'email</label>
                <textarea
                  value={bdcEmailForm.message_html}
                  onChange={(e) => setBdcEmailForm({...bdcEmailForm, message_html: e.target.value})}
                  rows={8}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
                  placeholder="Cliquez sur le bouton carnet ou entrez un nom pour générer le template..."
                />
              </div>

              {/* Sauvegarder contact */}
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="save_bdc_contact"
                  checked={saveBdcContact}
                  onChange={(e) => setSaveBdcContact(e.target.checked)}
                  className="w-4 h-4 text-blue-600 rounded"
                />
                <label htmlFor="save_bdc_contact" className="text-sm text-slate-600">
                  Enregistrer ce contact dans mon carnet d'adresses
                </label>
              </div>

              {/* Info */}
              <div className="bg-blue-50 rounded-lg p-3 text-sm text-blue-800">
                <p>📎 Le PDF du BDC sera automatiquement joint à l'email</p>
                <p>📧 Copie envoyée à m.gond@outlook.fr</p>
              </div>
            </div>

            <div className="p-6 border-t border-slate-200 flex gap-3">
              <button
                onClick={() => setShowBDCEmailModal(false)}
                className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
              >
                Annuler
              </button>
              <button
                onClick={handleSendBDCEmail}
                disabled={sendingBDCEmail || !bdcEmailForm.email_fournisseur || !bdcEmailForm.nom_fournisseur}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                data-testid="confirm-send-bdc-email-btn"
              >
                {sendingBDCEmail ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Send className="w-4 h-4" />
                )}
                Envoyer l'email
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Sélection Contact pour BDC */}
      {showBdcContactPicker && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-xl w-full max-w-md mx-4 shadow-2xl max-h-[80vh] flex flex-col">
            <div className="p-4 border-b border-slate-200 bg-orange-50">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-orange-900 flex items-center gap-2">
                  <BookUser className="w-5 h-5" />
                  Choisir un contact
                </h3>
                <button
                  onClick={() => setShowBdcContactPicker(false)}
                  className="text-slate-400 hover:text-slate-600"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="mt-3 relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  type="text"
                  value={bdcContactSearch}
                  onChange={(e) => setBdcContactSearch(e.target.value)}
                  placeholder="Rechercher..."
                  className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-500"
                  autoFocus
                />
              </div>
            </div>
            <div className="flex-1 overflow-y-auto p-2">
              {bdcContactsList.length === 0 ? (
                <div className="text-center py-8 text-slate-500">
                  <BookUser className="w-12 h-12 mx-auto text-slate-300 mb-2" />
                  <p>Aucun contact fournisseur</p>
                </div>
              ) : (
                bdcContactsList
                  .filter(c => {
                    if (!bdcContactSearch) return true;
                    const search = bdcContactSearch.toLowerCase();
                    return (
                      c.nom?.toLowerCase().includes(search) ||
                      c.prenom?.toLowerCase().includes(search) ||
                      c.entreprise?.toLowerCase().includes(search) ||
                      c.email?.toLowerCase().includes(search)
                    );
                  })
                  .map((contact) => (
                    <button
                      key={contact.id}
                      type="button"
                      onClick={() => handleSelectBdcContact(contact)}
                      className="w-full p-3 text-left hover:bg-orange-50 rounded-lg flex items-center gap-3 transition mb-1"
                    >
                      <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-semibold">
                        {(contact.prenom?.[0] || contact.nom?.[0] || '?').toUpperCase()}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="font-medium text-slate-800 truncate">
                          {contact.prenom} {contact.nom}
                        </div>
                        <div className="text-sm text-slate-500 truncate">{contact.email}</div>
                        {contact.entreprise && (
                          <span className="text-xs bg-slate-100 text-slate-600 px-2 py-0.5 rounded">
                            {contact.entreprise}
                          </span>
                        )}
                      </div>
                    </button>
                  ))
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Déplacer Fournisseur */}
      {showMoveFournisseurModal && fournisseurToMove && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl w-full max-w-md mx-4 shadow-2xl">
            <div className="p-6 border-b border-slate-200">
              <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <MoveRight className="w-5 h-5 text-blue-600" />
                Déplacer le fournisseur
              </h3>
              <p className="text-sm text-slate-500 mt-1">{fournisseurToMove.entreprise}</p>
            </div>
            <div className="p-6">
              <label className="block text-sm font-medium text-slate-700 mb-2">Nouveau lot</label>
              <select
                value={newLotId}
                onChange={(e) => setNewLotId(e.target.value)}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                data-testid="move-fournisseur-lot-select"
              >
                {(margeData?.marges_par_lot || []).filter(l => !l.is_frais_generaux).map((l) => {
                  const nb = (l.fournisseurs || []).length;
                  return (
                    <option key={l.lot_id} value={String(l.lot_id)} disabled={nb >= 3 && String(l.lot_id) !== String(fournisseurToMove.lot_id)}>
                      {l.lot_id}. {l.lot_nom}{nb > 0 ? ` (${nb}/3)` : ''}
                    </option>
                  );
                })}
              </select>
              <p className="text-xs text-slate-500 mt-2">Le fournisseur, son devis, son BDC et ses factures suivent dans le nouveau lot (premier emplacement libre).</p>
            </div>
            <div className="p-6 border-t border-slate-200 flex gap-3">
              <button
                onClick={() => setShowMoveFournisseurModal(false)}
                className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
              >
                Annuler
              </button>
              <button
                onClick={handleMoveFournisseur}
                data-testid="move-fournisseur-confirm"
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2"
              >
                <MoveRight className="w-4 h-4" />
                Déplacer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal - Génération BDC : Fourniture (TVA) vs Sous-traitance (autoliquidation) */}
      {bdcModalFournisseur && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md" data-testid="bdc-type-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Générer un Bon de Commande</h2>
                <p className="text-sm text-slate-500">
                  {bdcModalFournisseur.entreprise || 'Fournisseur'} — Lot {bdcModalFournisseur.lot_id}
                </p>
              </div>
              <button
                onClick={() => setBdcModalFournisseur(null)}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
                disabled={bdcGenerating}
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-5 space-y-4">
              {bdcProposing ? (
                <div className="flex items-center gap-2 p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">
                  <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                  Analyse IA du devis en cours pour vous proposer le bon type...
                </div>
              ) : bdcAiProposalSource === 'ai' ? (
                <div className="flex items-start gap-2 p-3 bg-indigo-50 border border-indigo-200 rounded-lg text-sm text-indigo-800">
                  <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>
                    Proposition IA : <b>{bdcAutoLiquidation ? 'Sous-traitance (sans TVA)' : 'Fourniture (avec TVA)'}</b>.
                    Vous pouvez modifier si nécessaire.
                  </span>
                </div>
              ) : null}

              <div className="space-y-2">
                <label
                  className={`flex items-start gap-3 p-3 border-2 rounded-lg cursor-pointer transition-all ${
                    bdcAutoLiquidation ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 hover:border-slate-300'
                  }`}
                  data-testid="bdc-option-sous-traitance"
                >
                  <input
                    type="radio"
                    name="bdc-type"
                    checked={bdcAutoLiquidation}
                    onChange={() => setBdcAutoLiquidation(true)}
                    className="mt-1"
                  />
                  <div className="flex-1">
                    <p className="font-semibold text-slate-900">Sous-traitance (sans TVA)</p>
                    <p className="text-xs text-slate-600 mt-1">
                      Autoliquidation BTP. Mention légale Article 283-2 nonies du CGI ajoutée sur le BDC.
                      L'artisan facturera sans TVA.
                    </p>
                  </div>
                </label>
                <label
                  className={`flex items-start gap-3 p-3 border-2 rounded-lg cursor-pointer transition-all ${
                    !bdcAutoLiquidation ? 'border-indigo-500 bg-indigo-50' : 'border-slate-200 hover:border-slate-300'
                  }`}
                  data-testid="bdc-option-fourniture"
                >
                  <input
                    type="radio"
                    name="bdc-type"
                    checked={!bdcAutoLiquidation}
                    onChange={() => setBdcAutoLiquidation(false)}
                    className="mt-1"
                  />
                  <div className="flex-1">
                    <p className="font-semibold text-slate-900">Fourniture (avec TVA 20%)</p>
                    <p className="text-xs text-slate-600 mt-1">
                      Achat de matériel / fournitures / marchandises. Le BDC inclut la TVA 20%.
                    </p>
                  </div>
                </label>
              </div>

              <div className="bg-slate-50 border border-slate-200 rounded-lg p-3 text-xs text-slate-700">
                <div className="flex justify-between mb-1">
                  <span>Montant HT :</span>
                  <span className="font-mono font-semibold">
                    {formatMoney(bdcModalFournisseur.montant_ht || 0)}
                  </span>
                </div>
                <div className="flex justify-between mb-1">
                  <span>TVA :</span>
                  <span className="font-mono">
                    {bdcAutoLiquidation
                      ? 'Autoliquidation'
                      : formatMoney((bdcModalFournisseur.montant_ht || 0) * 0.2)}
                  </span>
                </div>
                <div className="flex justify-between pt-1 border-t border-slate-300 font-bold">
                  <span>Net à payer :</span>
                  <span className="font-mono">
                    {formatMoney(
                      bdcAutoLiquidation
                        ? bdcModalFournisseur.montant_ht || 0
                        : (bdcModalFournisseur.montant_ht || 0) * 1.2
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex gap-2 p-5 border-t border-slate-200">
              <button
                onClick={() => setBdcModalFournisseur(null)}
                disabled={bdcGenerating}
                className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 disabled:opacity-50"
              >
                Annuler
              </button>
              <button
                onClick={handleConfirmBdc}
                disabled={bdcGenerating || bdcProposing}
                data-testid="bdc-confirm-btn"
                className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {bdcGenerating ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Génération...
                  </>
                ) : (
                  <>
                    <FileCheck className="w-4 h-4" />
                    Générer le BDC
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal - Détection doublons fournisseurs */}
      {duplicatesModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="duplicates-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200 sticky top-0 bg-white">
              <div>
                <h2 className="text-lg font-bold text-slate-900">🔍 Doublons fournisseurs détectés</h2>
                <p className="text-sm text-slate-500">Paires suspectes dans le même lot (nom similaire ≥ 70%)</p>
              </div>
              <button
                onClick={() => setDuplicatesModal(false)}
                className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-5">
              {duplicatesLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="w-6 h-6 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
                </div>
              ) : duplicatesPairs.length === 0 ? (
                <div className="text-center py-8 text-slate-500">
                  <p className="text-2xl mb-2">✅</p>
                  <p>Aucun doublon détecté.</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {duplicatesPairs.map((pair, idx) => {
                    const pairKey = `${pair.slot_a.id}-${pair.slot_b.id}`;
                    const merging = mergingPair === pairKey;
                    return (
                      <div key={pairKey} className="border-2 border-amber-200 bg-amber-50 rounded-lg p-3" data-testid={`duplicate-pair-${idx}`}>
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-xs font-semibold text-amber-800">
                            Lot {pair.lot_id} — Similarité {Math.round(pair.similarity * 100)}%
                          </span>
                        </div>
                        <div className="grid grid-cols-2 gap-2 text-sm">
                          {[{ slot: pair.slot_a, isA: true }, { slot: pair.slot_b, isA: false }].map(({ slot, isA }) => (
                            <div key={slot.id} className="bg-white rounded p-3 border border-slate-200">
                              <div className="font-semibold text-slate-900 mb-1">{slot.entreprise}</div>
                              <div className="text-xs text-slate-600">
                                Slot {slot.slot} · {formatMoney(slot.montant_ht || 0)}
                                {slot.pdf_filename && ' · 📎 devis'}
                                {slot.statut && ` · ${slot.statut}`}
                              </div>
                              <button
                                onClick={() => handleMergeDuplicates(pair, isA)}
                                disabled={merging}
                                data-testid={`merge-keep-${isA ? 'a' : 'b'}-${idx}`}
                                className="mt-2 w-full px-2 py-1 bg-green-600 text-white text-xs rounded font-medium hover:bg-green-700 disabled:opacity-50"
                              >
                                {merging ? 'Fusion...' : `Garder celui-ci, supprimer l'autre`}
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal - Historique factures liées à un slot */}
      {factureHistorySlot && (() => {
        const linked = facturesArtisans.filter(
          (fa) => fa.parent_fournisseur_id === factureHistorySlot.id
        );
        const prog = factureHistorySlot.facturation_progress;
        const typeLabels = {
          simple: { label: 'Simple', color: 'bg-slate-100 text-slate-700' },
          acompte: { label: 'Acompte', color: 'bg-amber-100 text-amber-800' },
          finale: { label: 'Finale', color: 'bg-emerald-100 text-emerald-800' },
        };
        return (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div
              className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] overflow-y-auto"
              data-testid="facture-history-modal"
            >
              <div className="flex items-center justify-between p-5 border-b border-slate-200 sticky top-0 bg-white">
                <div>
                  <h2 className="text-lg font-bold text-slate-900">📋 Factures liées</h2>
                  <p className="text-sm text-slate-500">
                    {factureHistorySlot.entreprise || 'Fournisseur'} — Lot {factureHistorySlot.lot_id}
                  </p>
                </div>
                <button
                  onClick={() => setFactureHistorySlot(null)}
                  className="p-2 hover:bg-slate-100 rounded-lg"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <div className="p-5 space-y-3">
                {prog && (
                  <div
                    className={`p-3 rounded-lg ${
                      prog.has_finale
                        ? 'bg-emerald-50 border border-emerald-200'
                        : 'bg-amber-50 border border-amber-200'
                    }`}
                  >
                    <div className="flex justify-between text-xs">
                      <span className="text-slate-600">Devis estimé :</span>
                      <span className="font-mono font-semibold">
                        {formatMoney(prog.estimation)}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs mt-1">
                      <span className="text-slate-600">Total facturé :</span>
                      <span className="font-mono font-semibold">
                        {formatMoney(prog.facture)}
                      </span>
                    </div>
                    {prog.pct != null && (
                      <div className="mt-2">
                        <div className="h-2 bg-white rounded-full overflow-hidden">
                          <div
                            className={`h-full ${
                              prog.has_finale ? 'bg-emerald-500' : 'bg-amber-500'
                            }`}
                            style={{ width: `${Math.min(prog.pct, 100)}%` }}
                          />
                        </div>
                        <p className="text-[10px] text-slate-500 mt-1 text-right">
                          {prog.has_finale
                            ? 'Facturation finale reçue'
                            : `${prog.pct}% du devis facturé en acompte`}
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {linked.length === 0 ? (
                  <div className="text-center py-6 text-slate-500 text-sm">
                    Aucune facture rattachée à ce slot.
                  </div>
                ) : (
                  <div className="space-y-2">
                    {linked
                      .slice()
                      .sort((a, b) => (a.date_facture || '').localeCompare(b.date_facture || ''))
                      .map((fac) => {
                        const t = typeLabels[fac.type_facture] || typeLabels.simple;
                        return (
                          <div
                            key={fac.id}
                            className="flex items-center justify-between gap-3 p-2.5 bg-slate-50 rounded-lg border border-slate-200"
                            data-testid={`facture-history-row-${fac.id}`}
                          >
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 flex-wrap">
                                <span
                                  className={`text-[10px] px-1.5 py-0.5 rounded font-semibold ${t.color}`}
                                >
                                  {t.label}
                                </span>
                                <span className="text-xs text-slate-500">
                                  {fac.date_facture || '—'}
                                </span>
                                {fac.numero_facture && (
                                  <span className="text-xs text-slate-400">
                                    N° {fac.numero_facture}
                                  </span>
                                )}
                              </div>
                              <p className="text-sm font-mono font-semibold text-slate-900 mt-0.5">
                                {formatMoney(fac.montant_ht || 0)} HT
                              </p>
                            </div>
                            <a
                              href={`${process.env.REACT_APP_BACKEND_URL}/api/factures-artisans/${fac.id}/download?token=${encodeURIComponent(localStorage.getItem('token') || '')}`}
                              target="_blank"
                              rel="noreferrer"
                              className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg flex-shrink-0"
                              title="Ouvrir le PDF"
                            >
                              <FileText className="w-4 h-4" />
                            </a>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })()}
      {/* Modal - Réassignation facture (Suivi Factures) */}
      {reassignFactureTarget && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md" data-testid="reassign-facture-modal">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Changer le rattachement</h2>
                <p className="text-sm text-slate-500 truncate">
                  {reassignFactureTarget.artisan_nom} — {formatMoney(reassignFactureTarget.montant_ht || 0)}
                </p>
              </div>
              <button onClick={() => setReassignFactureTarget(null)} className="p-2 hover:bg-slate-100 rounded-lg">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-5 space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Lot</label>
                <div className="relative">
                  <button
                    type="button"
                    onClick={() => { setReassignLotMenuOpen((v) => !v); setReassignSlotMenuOpen(false); }}
                    data-testid="reassign-lot-button"
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg bg-white text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-indigo-500 hover:bg-slate-50"
                  >
                    <span className="truncate text-slate-900">
                      {(() => {
                        if (!reassignLotId) return <span className="text-slate-500">— Aucun lot —</span>;
                        const lot = (margeData?.marges_par_lot || []).find((l) => String(l.lot_id) === String(reassignLotId));
                        if (lot?.is_frais_generaux) {
                          return <span className="text-amber-800 font-medium">🧾 Frais Général (timbre, repas, CB…)</span>;
                        }
                        return lot ? `Lot ${lot.lot_id} — ${lot.lot_nom}` : `Lot ${reassignLotId}`;
                      })()}
                    </span>
                    <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${reassignLotMenuOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {reassignLotMenuOpen && (
                    <div
                      data-testid="reassign-lot-menu"
                      className="absolute left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-white border border-slate-200 rounded-lg shadow-lg z-[60]"
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setReassignLotId('');
                          setReassignSlotId('');
                          setReassignLotMenuOpen(false);
                        }}
                        className={`w-full text-left px-3 py-2 text-sm hover:bg-indigo-50 ${!reassignLotId ? 'bg-indigo-50 font-medium' : ''}`}
                      >
                        — Aucun lot —
                      </button>
                      {(margeData?.marges_par_lot || []).map((l) => (
                        <button
                          key={l.lot_id}
                          type="button"
                          data-testid={`reassign-lot-option-${l.lot_id}`}
                          onClick={() => {
                            setReassignLotId(String(l.lot_id));
                            setReassignSlotId('');
                            setReassignLotMenuOpen(false);
                          }}
                          className={`w-full text-left px-3 py-2 text-sm hover:bg-indigo-50 ${String(reassignLotId) === String(l.lot_id) ? 'bg-indigo-50 font-medium' : ''} ${l.is_frais_generaux ? 'border-t border-slate-200 bg-amber-50/50 hover:bg-amber-100' : ''}`}
                        >
                          {l.is_frais_generaux ? (
                            <span className="flex items-center gap-2 text-amber-800">
                              🧾 Frais Général (timbre, repas, CB…)
                            </span>
                          ) : (
                            <>Lot {l.lot_id} — {l.lot_nom}</>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Fournisseur / Devis à rattacher
                </label>
                {reassignLotId === 'frais_generaux' ? (
                  <div className="px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800">
                    🧾 Cette facture sera comptée comme <strong>Frais Général</strong> (pas de fournisseur dédié, apparaît en bas du tableau de marge).
                  </div>
                ) : (
                <div className="relative">
                  <button
                    type="button"
                    disabled={!reassignLotId}
                    onClick={() => { setReassignSlotMenuOpen((v) => !v); setReassignLotMenuOpen(false); }}
                    data-testid="reassign-slot-button"
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg bg-white text-left flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-indigo-500 hover:bg-slate-50 disabled:bg-slate-50 disabled:cursor-not-allowed disabled:hover:bg-slate-50"
                  >
                    <span className="truncate text-slate-900">
                      {(() => {
                        if (!reassignSlotId) return <span className="text-slate-500">— Non rattaché (juste le lot) —</span>;
                        const s = allFournisseurSlots.find((x) => String(x.id) === String(reassignSlotId));
                        return s ? `Entreprise ${s.slot} · ${s.entreprise || '—'} (${formatMoney(s.montant_ht || 0)})` : '—';
                      })()}
                    </span>
                    <ChevronDown className={`w-4 h-4 text-slate-500 transition-transform ${reassignSlotMenuOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {reassignSlotMenuOpen && reassignLotId && (
                    <div
                      data-testid="reassign-slot-menu"
                      className="absolute left-0 right-0 mt-1 max-h-60 overflow-y-auto bg-white border border-slate-200 rounded-lg shadow-lg z-[60]"
                    >
                      <button
                        type="button"
                        onClick={() => {
                          setReassignSlotId('');
                          setReassignSlotMenuOpen(false);
                        }}
                        className={`w-full text-left px-3 py-2 text-sm hover:bg-indigo-50 ${!reassignSlotId ? 'bg-indigo-50 font-medium' : ''}`}
                      >
                        — Non rattaché (juste le lot) —
                      </button>
                      {allFournisseurSlots
                        .filter((s) => String(s.lot_id) === String(reassignLotId) && s.id && !s.legacy)
                        .map((s) => (
                          <button
                            key={s.id}
                            type="button"
                            onClick={() => {
                              setReassignSlotId(String(s.id));
                              setReassignSlotMenuOpen(false);
                            }}
                            className={`w-full text-left px-3 py-2 text-sm hover:bg-indigo-50 ${String(reassignSlotId) === String(s.id) ? 'bg-indigo-50 font-medium' : ''}`}
                          >
                            Entreprise {s.slot} · {s.entreprise || '—'} ({formatMoney(s.montant_ht || 0)})
                          </button>
                        ))}
                    </div>
                  )}
                </div>
                )}
                {reassignLotId && reassignLotId !== 'frais_generaux' && reassignFactureTarget && (
                  <button
                    type="button"
                    onClick={async () => {
                      try {
                        const slotsInLot = allFournisseurSlots.filter(
                          (s) => String(s.lot_id) === String(reassignLotId) && s.id && !s.legacy
                        );
                        const usedSlots = new Set(slotsInLot.map((s) => s.slot));
                        const freeSlot = [1, 2, 3].find((n) => !usedSlots.has(n)) || 1;
                        const res = await createFournisseurLot(projetId, {
                          lot_id: String(reassignLotId),
                          entreprise: reassignFactureTarget.artisan_nom,
                          montant_ht: reassignFactureTarget.montant_ht || 0,
                          slot: freeSlot,
                          statut: 'facture_recue',
                        });
                        const newSlotId = res?.data?.id;
                        if (newSlotId) {
                          await reassignFacture(reassignFactureTarget.id, {
                            lot_id: String(reassignLotId),
                            parent_fournisseur_id: newSlotId,
                          });
                          toast.success(`Fournisseur ${reassignFactureTarget.artisan_nom} créé dans Lot ${reassignLotId} et rattaché`);
                          setReassignFactureTarget(null);
                          loadData();
                        }
                      } catch (err) {
                        toast.error(err.response?.data?.detail || 'Erreur création fournisseur');
                      }
                    }}
                    data-testid="reassign-create-slot-btn"
                    className="mt-2 w-full px-3 py-2 bg-emerald-100 text-emerald-800 rounded-lg text-xs font-semibold hover:bg-emerald-200 transition-colors flex items-center justify-center gap-1"
                  >
                    + Créer la ligne fournisseur "{reassignFactureTarget.artisan_nom}" dans Lot {reassignLotId}
                  </button>
                )}
                <p className="text-[11px] text-slate-500 mt-1">
                  Si tu choisis un fournisseur, la facture sera comptabilisée contre son devis dans la Marge.
                  Sinon, elle reste rattachée au lot uniquement.
                </p>
              </div>
            </div>
            <div className="flex gap-2 p-5 border-t border-slate-200">
              <button
                onClick={() => setReassignFactureTarget(null)}
                disabled={reassigning}
                className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
              >
                Annuler
              </button>
              <button
                onClick={handleConfirmReassign}
                disabled={reassigning}
                data-testid="reassign-confirm-btn"
                className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50"
              >
                {reassigning ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Upload Facture Client */}
      {showFactureClientModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
              <h3 className="font-semibold text-slate-900">Ajouter une facture client</h3>
              <button
                onClick={() => setShowFactureClientModal(false)}
                className="p-1 hover:bg-slate-100 rounded"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label className="block text-xs font-medium text-slate-600 mb-1">PDF de la facture</label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setFactureClientForm({ ...factureClientForm, file: e.target.files?.[0] || null })}
                  className="w-full text-sm"
                  data-testid="facture-client-file-input"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">N° Facture</label>
                  <input
                    type="text"
                    value={factureClientForm.numero_facture}
                    onChange={(e) => setFactureClientForm({ ...factureClientForm, numero_facture: e.target.value })}
                    placeholder="ex: FC-2026-01"
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Date</label>
                  <input
                    type="date"
                    value={factureClientForm.date_facture}
                    onChange={(e) => setFactureClientForm({ ...factureClientForm, date_facture: e.target.value })}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Montant HT (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={factureClientForm.montant_ht}
                    onChange={(e) => {
                      const ht = e.target.value;
                      const ttc = parseFloat(ht || 0) * 1.20;
                      setFactureClientForm({ ...factureClientForm, montant_ht: ht, montant_ttc: ttc.toFixed(2) });
                    }}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                    data-testid="facture-client-ht-input"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Montant TTC (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={factureClientForm.montant_ttc}
                    onChange={(e) => setFactureClientForm({ ...factureClientForm, montant_ttc: e.target.value })}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  />
                </div>
              </div>
            </div>
            <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
              <button
                onClick={() => setShowFactureClientModal(false)}
                className="px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 rounded"
              >
                Annuler
              </button>
              <button
                onClick={async () => {
                  if (!factureClientForm.file) {
                    toast.error('Veuillez sélectionner un fichier PDF');
                    return;
                  }
                  if (!factureClientForm.montant_ht) {
                    toast.error('Veuillez saisir le montant HT');
                    return;
                  }
                  setUploadingFactureClient(true);
                  try {
                    const fd = new FormData();
                    fd.append('file', factureClientForm.file);
                    fd.append('numero_facture', factureClientForm.numero_facture);
                    fd.append('date_facture', factureClientForm.date_facture);
                    fd.append('montant_ht', factureClientForm.montant_ht);
                    fd.append('montant_ttc', factureClientForm.montant_ttc || factureClientForm.montant_ht);
                    await uploadFactureClient(projetId, fd);
                    toast.success('Facture client ajoutée');
                    setShowFactureClientModal(false);
                    loadData();
                  } catch (e) {
                    toast.error(e.response?.data?.detail || "Erreur lors de l'upload");
                  } finally {
                    setUploadingFactureClient(false);
                  }
                }}
                disabled={uploadingFactureClient}
                data-testid="upload-facture-client-confirm-btn"
                className="px-4 py-2 text-sm bg-emerald-600 text-white rounded hover:bg-emerald-700 disabled:opacity-50 flex items-center gap-2"
              >
                {uploadingFactureClient ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Détail Frais Généraux (factures + saisies manuelles) */}
      {showFraisGenDetailModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between bg-amber-50">
              <h3 className="font-semibold text-amber-900 flex items-center gap-2">
                <Receipt className="w-4 h-4" />
                Détail Frais Généraux
              </h3>
              <button
                onClick={() => setShowFraisGenDetailModal(false)}
                className="p-1 hover:bg-amber-100 rounded"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-5 space-y-4">
              {/* Factures rattachées comme frais généraux */}
              {(() => {
                const fgFactures = facturesArtisans.filter(fa => fa.lot_id === 'frais_generaux');
                if (fgFactures.length === 0) return null;
                return (
                  <div>
                    <h4 className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2">
                      📄 Factures marquées "Frais Général" <span className="text-xs font-normal text-slate-500">({fgFactures.length})</span>
                    </h4>
                    <div className="border border-slate-200 rounded overflow-hidden">
                      <table className="w-full text-sm">
                        <thead className="bg-slate-50 text-xs text-slate-500">
                          <tr>
                            <th className="text-left py-2 px-2">Date</th>
                            <th className="text-left py-2 px-2">Artisan</th>
                            <th className="text-left py-2 px-2">N°</th>
                            <th className="text-right py-2 px-2">HT</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100">
                          {fgFactures.map(f => (
                            <tr key={f.id} className="hover:bg-slate-50">
                              <td className="py-2 px-2 text-xs text-slate-600">{f.date_facture}</td>
                              <td className="py-2 px-2 text-slate-900">{f.artisan_nom}</td>
                              <td className="py-2 px-2 text-xs text-slate-500">{f.numero_facture || '—'}</td>
                              <td className="py-2 px-2 text-right font-mono font-semibold">{formatMoney(f.montant_ht)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <p className="text-[11px] text-slate-500 mt-1 italic">Modifiable depuis l'onglet "Suivi Factures".</p>
                  </div>
                );
              })()}
              {/* Saisies manuelles */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold text-slate-700 flex items-center gap-2">
                    ✏️ Saisies manuelles <span className="text-xs font-normal text-slate-500">({fraisGeneraux.length})</span>
                  </h4>
                  {!projet.is_cloture && (
                    <button
                      onClick={() => { setShowFraisGenDetailModal(false); openFraisGenModal(null); }}
                      className="px-2 py-1 text-xs bg-amber-600 text-white rounded hover:bg-amber-700 flex items-center gap-1"
                    >
                      <Plus className="w-3 h-3" /> Ajouter
                    </button>
                  )}
                </div>
                {fraisGeneraux.length === 0 ? (
                  <p className="text-xs text-slate-400 italic text-center py-3 border border-dashed border-slate-200 rounded">
                    Aucune saisie manuelle. Utiliser pour les petits frais sans facture PDF (timbres, parking, péage…).
                  </p>
                ) : (
                  <div className="border border-slate-200 rounded overflow-hidden">
                    <table className="w-full text-sm">
                      <thead className="bg-slate-50 text-xs text-slate-500">
                        <tr>
                          <th className="text-left py-2 px-2">Date</th>
                          <th className="text-left py-2 px-2">Catégorie</th>
                          <th className="text-left py-2 px-2">Libellé</th>
                          <th className="text-right py-2 px-2">HT</th>
                          <th className="py-2 px-2"></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {fraisGeneraux.map(f => (
                          <tr key={f.id} className="hover:bg-slate-50">
                            <td className="py-2 px-2 text-xs text-slate-600 whitespace-nowrap">{f.date}</td>
                            <td className="py-2 px-2">
                              <span className="inline-block px-2 py-0.5 bg-amber-50 text-amber-700 text-[11px] rounded">{f.categorie || 'Divers'}</span>
                            </td>
                            <td className="py-2 px-2 text-slate-900">{f.libelle}</td>
                            <td className="py-2 px-2 text-right font-mono font-semibold">{formatMoney(f.montant_ht)}</td>
                            <td className="py-2 px-2 text-right">
                              {!projet.is_cloture && (
                                <div className="flex items-center justify-end gap-1">
                                  <button
                                    onClick={() => { setShowFraisGenDetailModal(false); openFraisGenModal(f); }}
                                    className="p-1 text-slate-400 hover:text-indigo-600 rounded"
                                    title="Modifier"
                                  >
                                    <Edit2 className="w-3.5 h-3.5" />
                                  </button>
                                  <button
                                    onClick={() => handleDeleteFraisGen(f)}
                                    className="p-1 text-slate-400 hover:text-red-600 rounded"
                                    title="Supprimer"
                                  >
                                    <Trash2 className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="pt-3 border-t border-slate-200 flex justify-between items-center bg-amber-50 -mx-5 -mb-5 px-5 py-3 rounded-b-xl">
                <span className="text-sm font-semibold text-amber-900">Total Frais Généraux :</span>
                <span className="font-mono font-bold text-amber-800 text-lg">
                  {formatMoney(
                    fraisGeneraux.reduce((s, f) => s + (f.montant_ht || 0), 0) +
                    facturesArtisans.filter(fa => fa.lot_id === 'frais_generaux').reduce((s, f) => s + (f.montant_ht || 0), 0)
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Frais Général */}
      {showFraisGenModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
            <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
              <h3 className="font-semibold text-slate-900">
                {editingFraisGen ? 'Modifier' : 'Ajouter'} un frais général
              </h3>
              <button
                onClick={() => { setShowFraisGenModal(false); setEditingFraisGen(null); }}
                className="p-1 hover:bg-slate-100 rounded"
                data-testid="frais-gen-close-btn"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label className="block text-xs font-medium text-slate-600 mb-1">Libellé *</label>
                <input
                  type="text"
                  value={fraisGenForm.libelle}
                  onChange={(e) => setFraisGenForm({ ...fraisGenForm, libelle: e.target.value })}
                  placeholder="ex: Repas chantier, Carburant, Timbres La Poste…"
                  className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  data-testid="frais-gen-libelle-input"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Catégorie</label>
                  <select
                    value={fraisGenForm.categorie}
                    onChange={(e) => setFraisGenForm({ ...fraisGenForm, categorie: e.target.value })}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm bg-white"
                    data-testid="frais-gen-categorie-select"
                  >
                    <option value="Divers">Divers</option>
                    <option value="Carte bancaire">Carte bancaire</option>
                    <option value="Restauration">Restauration</option>
                    <option value="Timbres / Courrier">Timbres / Courrier</option>
                    <option value="Carburant / Déplacements">Carburant / Déplacements</option>
                    <option value="Fournitures bureau">Fournitures bureau</option>
                    <option value="Péage / Parking">Péage / Parking</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Date</label>
                  <input
                    type="date"
                    value={fraisGenForm.date}
                    onChange={(e) => setFraisGenForm({ ...fraisGenForm, date: e.target.value })}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Montant HT (€) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={fraisGenForm.montant_ht}
                    onChange={(e) => {
                      const ht = e.target.value;
                      const ttc = parseFloat(ht || 0) * 1.20;
                      setFraisGenForm({ ...fraisGenForm, montant_ht: ht, montant_ttc: ht ? ttc.toFixed(2) : '' });
                    }}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                    data-testid="frais-gen-ht-input"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-slate-600 mb-1">Montant TTC (€)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={fraisGenForm.montant_ttc}
                    onChange={(e) => setFraisGenForm({ ...fraisGenForm, montant_ttc: e.target.value })}
                    className="w-full h-9 px-3 border border-slate-300 rounded text-sm"
                  />
                </div>
              </div>
            </div>
            <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
              <button
                onClick={() => { setShowFraisGenModal(false); setEditingFraisGen(null); }}
                className="px-4 py-2 text-sm text-slate-700 hover:bg-slate-100 rounded"
              >
                Annuler
              </button>
              <button
                onClick={handleSaveFraisGen}
                disabled={savingFraisGen}
                data-testid="frais-gen-save-btn"
                className="px-4 py-2 text-sm bg-amber-600 text-white rounded hover:bg-amber-700 disabled:opacity-50 flex items-center gap-2"
              >
                {savingFraisGen ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                {editingFraisGen ? 'Mettre à jour' : 'Ajouter'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PDF preview shared across all PDF triggers (BDC, planning, descriptif…) */}
      {pdfPreview && (
        <PDFPreviewModal
          url={pdfPreview.url}
          title={pdfPreview.title}
          downloadFilename={pdfPreview.filename}
          onClose={closePdfPreview}
        />
      )}
    </div>
  );
};

export default ProjetDetailPage;
